/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class CheckItemServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 删除点检项
     * @param id (optional) 点检项id
     * @return OK
     */
    deleteCheckItemById(id: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/check-items?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteCheckItemById(_response);
        });
    }

    protected processDeleteCheckItemById(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 分页查询点检项目下的点检项
     * @param current (optional) 当前页
     * @param id (optional) 点检项目id
     * @param size (optional) 每页的数量
     * @return OK
     */
    pageCheckItems(current: number | null | undefined, id: string | null | undefined, size: number | null | undefined): Promise<IPageOfCheckItemVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/check-items/page?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageCheckItems(_response);
        });
    }

    protected processPageCheckItems(response: AxiosResponse): Promise<IPageOfCheckItemVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfCheckItemVO.fromJS(resultData200) : new IPageOfCheckItemVO();
            return result200;
        }
        return Promise.resolve<IPageOfCheckItemVO>(<any>null);
    }
}

export class CheckProjectServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增点检项目
     * @param dto dto
     * @return OK
     */
    createCheckProject(dto: CheckProjectSubmitDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/check-projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateCheckProject(_response);
        });
    }

    protected processCreateCheckProject(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 编辑点检项目
     * @param dto dto
     * @return OK
     */
    updateCheckProjectAndItems(dto: CheckUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/check-projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateCheckProjectAndItems(_response);
        });
    }

    protected processUpdateCheckProjectAndItems(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 批量删除点检项目
     * @param ids ids
     * @return OK
     */
    deleteCheckProjectsByIds(ids: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/check-projects?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteCheckProjectsByIds(_response);
        });
    }

    protected processDeleteCheckProjectsByIds(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 导出点检项目
     * @param dto dto
     * @return OK
     */
    exportCheckProjectAndItem(dto: CheckProjectExcelDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/check-projects/excel/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportCheckProjectAndItem(_response);
        });
    }

    protected processExportCheckProjectAndItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出点检项目模板
     * @return OK
     */
    exportCheckProjectTemplate(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/check-projects/excel/export/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportCheckProjectTemplate(_response);
        });
    }

    protected processExportCheckProjectTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导入点检项目
     * @param file (optional) file
     * @return OK
     */
    importProducts(file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/check-projects/excel/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportProducts(_response);
        });
    }

    protected processImportProducts(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 分页查询点检项目
     * @param dto dto
     * @return OK
     */
    pageCheckProjects(dto: PageCheckProjectsDTO): Promise<IPageOfCheckProjectVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/check-projects/page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageCheckProjects(_response);
        });
    }

    protected processPageCheckProjects(response: AxiosResponse): Promise<IPageOfCheckProjectVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfCheckProjectVO.fromJS(resultData200) : new IPageOfCheckProjectVO();
            return result200;
        }
        return Promise.resolve<IPageOfCheckProjectVO>(<any>null);
    }

    /**
     * 查询点检项目下的点检项
     * @param id (optional) 点检项目id
     * @return OK
     */
    getCheckProjectAndItemById(id: string | null | undefined): Promise<CheckVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/check-projects/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCheckProjectAndItemById(_response);
        });
    }

    protected processGetCheckProjectAndItemById(response: AxiosResponse): Promise<CheckVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? CheckVO.fromJS(resultData200) : new CheckVO();
            return result200;
        }
        return Promise.resolve<CheckVO>(<any>null);
    }
}

export class CheckRecordServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 添加点检记录
     * @param checkRecordDTO checkRecordDTO
     * @return OK
     */
    addCheckRecord(checkRecordDTO: CheckRecordDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/check-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(checkRecordDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddCheckRecord(_response);
        });
    }

    protected processAddCheckRecord(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 修改点检记录
     * @param checkRecordUpdateDTO checkRecordUpdateDTO
     * @return OK
     */
    updateCheckRecord(checkRecordUpdateDTO: CheckRecordUpdateDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/check-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(checkRecordUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateCheckRecord(_response);
        });
    }

    protected processUpdateCheckRecord(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 删除点检项记录(可批量)
     * @param checkRecordIds checkRecordIds
     * @return OK
     */
    deleteCheckRecord(checkRecordIds: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/check-record?";
        if (checkRecordIds === undefined || checkRecordIds === null)
            throw new Error("The parameter 'checkRecordIds' must be defined and cannot be null.");
        else
            checkRecordIds && checkRecordIds.forEach(item => { url_ += "checkRecordIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteCheckRecord(_response);
        });
    }

    protected processDeleteCheckRecord(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查看点检附件
     * @param checkRecordId checkRecordId
     * @return OK
     */
    checkRecordFileList(checkRecordId: string): Promise<CheckRecordFileVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/check-record/check-record-file-list?";
        if (checkRecordId === undefined || checkRecordId === null)
            throw new Error("The parameter 'checkRecordId' must be defined and cannot be null.");
        else
            url_ += "checkRecordId=" + encodeURIComponent("" + checkRecordId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCheckRecordFileList(_response);
        });
    }

    protected processCheckRecordFileList(response: AxiosResponse): Promise<CheckRecordFileVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckRecordFileVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<CheckRecordFileVO[]>(<any>null);
    }

    /**
     * 分页查询点检记录
     * @param current (optional) 当前页
     * @param deviceTypeId (optional) deviceTypeId
     * @param keyWords (optional) keyWords
     * @param size (optional) 每页的数量
     * @return OK
     */
    page(current: number | null | undefined, deviceTypeId: string | null | undefined, keyWords: string | null | undefined, size: number | null | undefined, startTime: string | null | undefined, endTime: string | null | undefined): Promise<IPageOfCheckRecordVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/check-record/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (deviceTypeId !== undefined)
            url_ += "deviceTypeId=" + encodeURIComponent("" + deviceTypeId) + "&"; 
        if (keyWords !== undefined)
            url_ += "keyWords=" + encodeURIComponent("" + keyWords) + "&"; 
        if (startTime !== undefined)
             url_ += "startTime=" + encodeURIComponent("" + startTime) + "&"; 
        if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent("" + endTime) + "&"; 
      
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<IPageOfCheckRecordVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfCheckRecordVO.fromJS(resultData200) : new IPageOfCheckRecordVO();
            return result200;
        }
        return Promise.resolve<IPageOfCheckRecordVO>(<any>null);
    }

    /**
     * 根据设备id分页查询点检记录
     * @param current (optional) 当前页
     * @param deviceId (optional) deviceId
     * @param keyWords (optional) keyWords
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPage(current: number | null | undefined, deviceId: string | null | undefined, keyWords: string | null | undefined, size: number | null | undefined): Promise<IPageOfCheckRecordVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/check-record/page-device-id?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        if (keyWords !== undefined)
            url_ += "keyWords=" + encodeURIComponent("" + keyWords) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPage(_response);
        });
    }

    protected processGetPage(response: AxiosResponse): Promise<IPageOfCheckRecordVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfCheckRecordVO.fromJS(resultData200) : new IPageOfCheckRecordVO();
            return result200;
        }
        return Promise.resolve<IPageOfCheckRecordVO>(<any>null);
    }

    /**
     * 查看点检项
     * @param checkRecordId checkRecordId
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    checkRecordItemList(checkRecordId: string, current: number | null | undefined, size: number | null | undefined): Promise<IPageOfCheckRecordItemVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/check-record/page/check-record-item-list?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (checkRecordId === undefined || checkRecordId === null)
            throw new Error("The parameter 'checkRecordId' must be defined and cannot be null.");
        else
            url_ += "checkRecordId=" + encodeURIComponent("" + checkRecordId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCheckRecordItemList(_response);
        });
    }

    protected processCheckRecordItemList(response: AxiosResponse): Promise<IPageOfCheckRecordItemVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfCheckRecordItemVO.fromJS(resultData200) : new IPageOfCheckRecordItemVO();
            return result200;
        }
        return Promise.resolve<IPageOfCheckRecordItemVO>(<any>null);
    }

    /**
     * 查看点检记录详情
     * @param id id
     * @return OK
     */
    checkRecordDetail(id: string): Promise<CheckRecordVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/check-record/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCheckRecordDetail(_response);
        });
    }

    protected processCheckRecordDetail(response: AxiosResponse): Promise<CheckRecordVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? CheckRecordVO.fromJS(resultData200) : new CheckRecordVO();
            return result200;
        }
        return Promise.resolve<CheckRecordVO>(<any>null);
    }
}

export class CheckRecordExcelServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 导出点检项
     * @param checkRecordIds checkRecordIds
     * @return OK
     */
    exportProduct(checkRecordIds: CheckRecordIdsDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/check-record-excel/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(checkRecordIds);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportProduct(_response);
        });
    }

    protected processExportProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class DeviceMaterialRecordServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * exportDeviceMaterial
     * @param dto dto
     * @return OK
     */
    exportDeviceMaterial(dto: DeviceMaterialRecordExcelDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/device-material-records/excel/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportDeviceMaterial(_response);
        });
    }

    protected processExportDeviceMaterial(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询维修/保养关联的物料信息
     * @param planCode (optional) 维修/保养code
     * @param planId (optional) 维修/保养id
     * @return OK
     */
    getStockOutOrderMaterialList(planCode: string | null | undefined, planId: string | null | undefined): Promise<StockOutOrderMaterialTpmVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/device-material-records/getStockOutOrderMaterialList?";
        if (planCode !== undefined)
            url_ += "planCode=" + encodeURIComponent("" + planCode) + "&"; 
        if (planId !== undefined)
            url_ += "planId=" + encodeURIComponent("" + planId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStockOutOrderMaterialList(_response);
        });
    }

    protected processGetStockOutOrderMaterialList(response: AxiosResponse): Promise<StockOutOrderMaterialTpmVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockOutOrderMaterialTpmVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<StockOutOrderMaterialTpmVO[]>(<any>null);
    }

    /**
     * 查询设备的备品工况
     * @param current (optional) 当前页
     * @param id (optional) 设备id
     * @param size (optional) 每页的数量
     * @return OK
     */
    pageCheckMaterialRecord(current: number | null | undefined, id: string | null | undefined, size: number | null | undefined): Promise<IPageOfDeviceMaterialRecordVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/device-material-records/page?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageCheckMaterialRecord(_response);
        });
    }

    protected processPageCheckMaterialRecord(response: AxiosResponse): Promise<IPageOfDeviceMaterialRecordVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfDeviceMaterialRecordVO.fromJS(resultData200) : new IPageOfDeviceMaterialRecordVO();
            return result200;
        }
        return Promise.resolve<IPageOfDeviceMaterialRecordVO>(<any>null);
    }
}

export class DeviceTypeAndonTypeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 设备类型添加呼叫类型
     * @param dto dto
     * @return OK
     */
    createDeviceTypeAndonType(dto: DeviceTypeAndonTypeDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/device-type-andon-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateDeviceTypeAndonType(_response);
        });
    }

    protected processCreateDeviceTypeAndonType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除设备类型下的呼叫类型
     * @param id 设备类型呼叫类型主键id
     * @return OK
     */
    deleteDeviceTypeAndonType(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/device-type-andon-type?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteDeviceTypeAndonType(_response);
        });
    }

    protected processDeleteDeviceTypeAndonType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 导出对应设备类型下的呼叫类型
     * @param deviceTypeId 设备类型id
     * @return OK
     */
    export(deviceTypeId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/device-type-andon-type/export?";
        if (deviceTypeId === undefined || deviceTypeId === null)
            throw new Error("The parameter 'deviceTypeId' must be defined and cannot be null.");
        else
            url_ += "deviceTypeId=" + encodeURIComponent("" + deviceTypeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询设备类型的呼叫类型
     * @param id (optional) 设备类型id
     * @return OK
     */
    getAndonTypeList(id: string | null | undefined): Promise<DeviceTypeAndonTypeVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/device-type-andon-type/list?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAndonTypeList(_response);
        });
    }

    protected processGetAndonTypeList(response: AxiosResponse): Promise<DeviceTypeAndonTypeVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceTypeAndonTypeVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DeviceTypeAndonTypeVO[]>(<any>null);
    }

    /**
     * 分页查询设备类型的呼叫类型
     * @param current (optional) 当前页
     * @param deviceTypeId 设备类型id
     * @param size (optional) 每页的数量
     * @return OK
     */
    getDeviceTypeAndonTypePage(current: number | null | undefined, deviceTypeId: string, size: number | null | undefined): Promise<IPageOfDeviceTypeAndonTypeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/device-type-andon-type/page?";
        if (deviceTypeId === undefined || deviceTypeId === null)
            throw new Error("The parameter 'deviceTypeId' must be defined and cannot be null.");
        else
            url_ += "deviceTypeId=" + encodeURIComponent("" + deviceTypeId) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceTypeAndonTypePage(_response);
        });
    }

    protected processGetDeviceTypeAndonTypePage(response: AxiosResponse): Promise<IPageOfDeviceTypeAndonTypeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfDeviceTypeAndonTypeVO.fromJS(resultData200) : new IPageOfDeviceTypeAndonTypeVO();
            return result200;
        }
        return Promise.resolve<IPageOfDeviceTypeAndonTypeVO>(<any>null);
    }
}

export class DeviceTypeCheckProjectServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 查询设备类型的点检项目
     * @param id (optional) 设备类型id
     * @return OK
     */
    getDeviceTypeCheckProjects(id: string | null | undefined): Promise<DeviceTypeCheckProjectVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/device-type-check-projects?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceTypeCheckProjects(_response);
        });
    }

    protected processGetDeviceTypeCheckProjects(response: AxiosResponse): Promise<DeviceTypeCheckProjectVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceTypeCheckProjectVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DeviceTypeCheckProjectVO[]>(<any>null);
    }

    /**
     * 设备类型添加点检项目
     * @param dto dto
     * @return OK
     */
    createDeviceTypeCheckProjects(dto: DeviceTypeCheckProjectDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/device-type-check-projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateDeviceTypeCheckProjects(_response);
        });
    }

    protected processCreateDeviceTypeCheckProjects(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除设备类型下的点检项目
     * @param id (optional) 设备类型点检项目主键id
     * @return OK
     */
    deleteDeviceTypeCheckProject(id: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/device-type-check-projects?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteDeviceTypeCheckProject(_response);
        });
    }

    protected processDeleteDeviceTypeCheckProject(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 分页查询设备类型的点检项目
     * @param current (optional) 当前页
     * @param id (optional) 设备类型id
     * @param size (optional) 每页的数量
     * @return OK
     */
    getDeviceTypeCheckProjectPage(current: number | null | undefined, id: string | null | undefined, size: number | null | undefined): Promise<IPageOfDeviceTypeCheckProjectVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/device-type-check-projects/page?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceTypeCheckProjectPage(_response);
        });
    }

    protected processGetDeviceTypeCheckProjectPage(response: AxiosResponse): Promise<IPageOfDeviceTypeCheckProjectVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfDeviceTypeCheckProjectVO.fromJS(resultData200) : new IPageOfDeviceTypeCheckProjectVO();
            return result200;
        }
        return Promise.resolve<IPageOfDeviceTypeCheckProjectVO>(<any>null);
    }
}

export class HmiServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * hmi端添加点检记录
     * @param checkRecordDTO checkRecordDTO
     * @return OK
     */
    addCheckRecord(checkRecordDTO: CheckRecordDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/hmi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(checkRecordDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddCheckRecord(_response);
        });
    }

    protected processAddCheckRecord(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * HMI新增维修申请记录
     * @param repairApplyHmiAdd repairApplyHmiAdd
     * @return OK
     */
    createRepairApplyHmi(repairApplyHmiAdd: RepairApplyHMIAddDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/hmi/create-hmi-apply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(repairApplyHmiAdd);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateRepairApplyHmi(_response);
        });
    }

    protected processCreateRepairApplyHmi(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class MaintainItemServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 添加保养项
     * @param maintainItemAddDto maintainItemAddDto
     * @return OK
     */
    createMaintainItem(maintainItemAddDto: MaintainItemAddDTO): Promise<MaintainItemVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-item/create-maintain-item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maintainItemAddDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateMaintainItem(_response);
        });
    }

    protected processCreateMaintainItem(response: AxiosResponse): Promise<MaintainItemVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? MaintainItemVo.fromJS(resultData200) : new MaintainItemVo();
            return result200;
        }
        return Promise.resolve<MaintainItemVo>(<any>null);
    }

    /**
     * 删除保养项
     * @param ids (optional) 保养项ID
     * @return OK
     */
    deleteMaintainItem(ids: string[] | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-item/delete-maintain-item?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteMaintainItem(_response);
        });
    }

    protected processDeleteMaintainItem(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * 编辑保养项
     * @param maintainItemEditDTO maintainItemEditDTO
     * @return OK
     */
    editMaintainItem(maintainItemEditDTO: MaintainItemUpdateDTO): Promise<MaintainItemVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-item/edit-maintain-item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maintainItemEditDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditMaintainItem(_response);
        });
    }

    protected processEditMaintainItem(response: AxiosResponse): Promise<MaintainItemVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? MaintainItemVo.fromJS(resultData200) : new MaintainItemVo();
            return result200;
        }
        return Promise.resolve<MaintainItemVo>(<any>null);
    }

    /**
     * 导出
     * @param maintainItemExportDTO maintainItemExportDTO
     * @return OK
     */
    exportMaintainItem(maintainItemExportDTO: MaintainItemExportDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-item/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maintainItemExportDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportMaintainItem(_response);
        });
    }

    protected processExportMaintainItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出保养项模板
     * @return OK
     */
    exportMaintainItemTemplate(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-item/export/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportMaintainItemTemplate(_response);
        });
    }

    protected processExportMaintainItemTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 动态导入
     * @param file (optional) file
     * @return OK
     */
    importMaintainItem(file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-item/import-maintain-item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportMaintainItem(_response);
        });
    }

    protected processImportMaintainItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查看保养项列表（不分页）
     * @param keyWord (optional) 关键词
     * @return OK
     */
    queryMaintainItemList(keyWord: string | null | undefined): Promise<MaintainItemVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-item/list?";
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainItemList(_response);
        });
    }

    protected processQueryMaintainItemList(response: AxiosResponse): Promise<MaintainItemVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaintainItemVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaintainItemVo[]>(<any>null);
    }

    /**
     * 查看可以关联的保养项列表（不分页）
     * @return OK
     */
    queryMaintainItemListCanRelate(): Promise<MaintainItemVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-item/list-can-relate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainItemListCanRelate(_response);
        });
    }

    protected processQueryMaintainItemListCanRelate(response: AxiosResponse): Promise<MaintainItemVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaintainItemVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaintainItemVo[]>(<any>null);
    }

    /**
     * 查看保养项列表（分页）
     * @param current (optional) 当前页
     * @param keyWord (optional) 关键词
     * @param size (optional) 每页的数量
     * @return OK
     */
    queryMaintainItemListPage(current: number | null | undefined, keyWord: string | null | undefined, size: number | null | undefined): Promise<IPageOfMaintainItemVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-item/page?";
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainItemListPage(_response);
        });
    }

    protected processQueryMaintainItemListPage(response: AxiosResponse): Promise<IPageOfMaintainItemVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfMaintainItemVo.fromJS(resultData200) : new IPageOfMaintainItemVo();
            return result200;
        }
        return Promise.resolve<IPageOfMaintainItemVo>(<any>null);
    }

    /**
     * 查看保养项
     * @param id (optional) 保养项ID
     * @return OK
     */
    queryMaintainItem(id: string | null | undefined): Promise<MaintainItemVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-item/query-maintain-item?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainItem(_response);
        });
    }

    protected processQueryMaintainItem(response: AxiosResponse): Promise<MaintainItemVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? MaintainItemVo.fromJS(resultData200) : new MaintainItemVo();
            return result200;
        }
        return Promise.resolve<MaintainItemVo>(<any>null);
    }
}

export class MaintainPlanServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 添加保养计划
     * @param maintainPlanAddDTO maintainPlanAddDTO
     * @return OK
     */
    createMaintainPlan(maintainPlanAddDTO: MaintainPlanAddDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-plan/create-maintain-plan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maintainPlanAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateMaintainPlan(_response);
        });
    }

    protected processCreateMaintainPlan(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 删除保养计划
     * @param ids (optional) 保养计划Id
     * @return OK
     */
    deleteMaintainPlan(ids: string[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-plan/delete-maintain-plan?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteMaintainPlan(_response);
        });
    }

    protected processDeleteMaintainPlan(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 编辑保养计划
     * @param maintainPlanUpdateDTO maintainPlanUpdateDTO
     * @return OK
     */
    editMaintainPlan(maintainPlanUpdateDTO: MaintainPlanUpdateDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-plan/edit-maintain-plan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maintainPlanUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditMaintainPlan(_response);
        });
    }

    protected processEditMaintainPlan(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出
     * @param maintainPlanExportDTO maintainPlanExportDTO
     * @return OK
     */
    exportMaintainPlan(maintainPlanExportDTO: MaintainPlanExportDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-plan/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maintainPlanExportDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportMaintainPlan(_response);
        });
    }

    protected processExportMaintainPlan(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查看保养计划
     * @param id (optional) 保养计划ID
     * @return OK
     */
    getMaintainPlan(id: string | null | undefined): Promise<MaintainPlanVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-plan/get-maintain-plan?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMaintainPlan(_response);
        });
    }

    protected processGetMaintainPlan(response: AxiosResponse): Promise<MaintainPlanVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? MaintainPlanVo.fromJS(resultData200) : new MaintainPlanVo();
            return result200;
        }
        return Promise.resolve<MaintainPlanVo>(<any>null);
    }

    /**
     * 通过保养计划ID查看保养项列表（不分页）
     * @param planId (optional) 保养计划Id
     * @return OK
     */
    queryMaintainPlanItemList(planId: string | null | undefined): Promise<MaintainPlanItemVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-plan/item-list?";
        if (planId !== undefined)
            url_ += "planId=" + encodeURIComponent("" + planId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainPlanItemList(_response);
        });
    }

    protected processQueryMaintainPlanItemList(response: AxiosResponse): Promise<MaintainPlanItemVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaintainPlanItemVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaintainPlanItemVo[]>(<any>null);
    }

    /**
     * 通过保养计划ID查看保养项列表（分页）
     * @param current (optional) 当前页
     * @param planId (optional) 保养计划Id
     * @param size (optional) 每页的数量
     * @return OK
     */
    queryMaintainPlanItemListPage(current: number | null | undefined, planId: string | null | undefined, size: number | null | undefined): Promise<IPageOfMaintainPlanItemVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-plan/item-page?";
        if (planId !== undefined)
            url_ += "planId=" + encodeURIComponent("" + planId) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainPlanItemListPage(_response);
        });
    }

    protected processQueryMaintainPlanItemListPage(response: AxiosResponse): Promise<IPageOfMaintainPlanItemVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfMaintainPlanItemVo.fromJS(resultData200) : new IPageOfMaintainPlanItemVo();
            return result200;
        }
        return Promise.resolve<IPageOfMaintainPlanItemVo>(<any>null);
    }

    /**
     * 通过设备类型查看保养计划（不分页）
     * @param maintainPlanSearchDTO maintainPlanSearchDTO
     * @return OK
     */
    queryMaintainPlanList(maintainPlanSearchDTO: MaintainPlanSearchDTO): Promise<MaintainPlanVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-plan/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maintainPlanSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainPlanList(_response);
        });
    }

    protected processQueryMaintainPlanList(response: AxiosResponse): Promise<MaintainPlanVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaintainPlanVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaintainPlanVo[]>(<any>null);
    }

    /**
     * 根据状态查询计划列表
     * @param planStatus (optional) 状态
     * @return OK
     */
    queryMaintainPlanListByStatus(planStatus: number | null | undefined): Promise<MaintainPlanVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-plan/list-by-status?";
        if (planStatus !== undefined)
            url_ += "planStatus=" + encodeURIComponent("" + planStatus) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainPlanListByStatus(_response);
        });
    }

    protected processQueryMaintainPlanListByStatus(response: AxiosResponse): Promise<MaintainPlanVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaintainPlanVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaintainPlanVo[]>(<any>null);
    }

    /**
     * 通过设备类型查看保养计划（分页）
     * @param current (optional) 当前页
     * @param maintainPlanSearchDTO maintainPlanSearchDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    queryMaintainPlanPage(current: number | null | undefined, maintainPlanSearchDTO: MaintainPlanSearchDTO, size: number | null | undefined): Promise<IPageOfMaintainPlanVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-plan/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maintainPlanSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainPlanPage(_response);
        });
    }

    protected processQueryMaintainPlanPage(response: AxiosResponse): Promise<IPageOfMaintainPlanVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfMaintainPlanVo.fromJS(resultData200) : new IPageOfMaintainPlanVo();
            return result200;
        }
        return Promise.resolve<IPageOfMaintainPlanVo>(<any>null);
    }

    /**
     * 查看保养计划（分页）
     * @param current (optional) 当前页
     * @param maintainPlanSearchByPlanStatusDTO maintainPlanSearchByPlanStatusDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    queryMaintainPlanPageByPlanStatus(current: number | null | undefined, maintainPlanSearchByPlanStatusDTO: MaintainPlanSearchByPlanStatusDTO, size: number | null | undefined): Promise<IPageOfMaintainPlanVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-plan/page-by-plan-status?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maintainPlanSearchByPlanStatusDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainPlanPageByPlanStatus(_response);
        });
    }

    protected processQueryMaintainPlanPageByPlanStatus(response: AxiosResponse): Promise<IPageOfMaintainPlanVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfMaintainPlanVo.fromJS(resultData200) : new IPageOfMaintainPlanVo();
            return result200;
        }
        return Promise.resolve<IPageOfMaintainPlanVo>(<any>null);
    }

    /**
     * 执行保养计划
     * @param id (optional) 保养计划Id
     * @return OK
     */
    performMaintainPlan(id: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-plan/perform-maintain-plan?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPerformMaintainPlan(_response);
        });
    }

    protected processPerformMaintainPlan(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class MaintainProjectServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 添加保养项目
     * @param maintainProjectAddDTO maintainProjectAddDTO
     * @return OK
     */
    createMaintainProject(maintainProjectAddDTO: MaintainProjectAddDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-project/create-maintain-project";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maintainProjectAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateMaintainProject(_response);
        });
    }

    protected processCreateMaintainProject(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 删除保养项目
     * @param id (optional) 保养项目Id
     * @return OK
     */
    deleteMaintainProject(id: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-project/delete-maintain-project?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteMaintainProject(_response);
        });
    }

    protected processDeleteMaintainProject(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 编辑保养项目
     * @param maintainProjectUpdateDTO maintainProjectUpdateDTO
     * @return OK
     */
    editMaintainProject(maintainProjectUpdateDTO: MaintainProjectUpdateDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-project/edit-maintain-project";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maintainProjectUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditMaintainProject(_response);
        });
    }

    protected processEditMaintainProject(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 查看保养项目
     * @param id (optional) 保养项目ID
     * @return OK
     */
    queryMaintainProject(id: string | null | undefined): Promise<MaintainProjectVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-project/get-maintain-project?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainProject(_response);
        });
    }

    protected processQueryMaintainProject(response: AxiosResponse): Promise<MaintainProjectVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? MaintainProjectVo.fromJS(resultData200) : new MaintainProjectVo();
            return result200;
        }
        return Promise.resolve<MaintainProjectVo>(<any>null);
    }

    /**
     * 通过保养项目ID查看保养项列表（不分页）
     * @param projectId (optional) 保养项目Id
     * @return OK
     */
    queryMaintainProjectItemList(projectId: string | null | undefined): Promise<MaintainProjectItemVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-project/item-list?";
        if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainProjectItemList(_response);
        });
    }

    protected processQueryMaintainProjectItemList(response: AxiosResponse): Promise<MaintainProjectItemVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaintainProjectItemVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaintainProjectItemVo[]>(<any>null);
    }

    /**
     * 通过保养项目ID查看保养项列表（分页）
     * @param current (optional) 当前页
     * @param projectId (optional) 保养项目Id
     * @param size (optional) 每页的数量
     * @return OK
     */
    queryMaintainProjectItemListPage(current: number | null | undefined, projectId: string | null | undefined, size: number | null | undefined): Promise<IPageOfMaintainProjectItemVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-project/item-page?";
        if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainProjectItemListPage(_response);
        });
    }

    protected processQueryMaintainProjectItemListPage(response: AxiosResponse): Promise<IPageOfMaintainProjectItemVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfMaintainProjectItemVo.fromJS(resultData200) : new IPageOfMaintainProjectItemVo();
            return result200;
        }
        return Promise.resolve<IPageOfMaintainProjectItemVo>(<any>null);
    }

    /**
     * 通过设备类型查看保养项目列表（不分页）
     * @param deviceTypeId (optional) 设备类型id
     * @return OK
     */
    queryMaintainProjectList(deviceTypeId: string | null | undefined): Promise<MaintainProjectVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-project/list?";
        if (deviceTypeId !== undefined)
            url_ += "deviceTypeId=" + encodeURIComponent("" + deviceTypeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainProjectList(_response);
        });
    }

    protected processQueryMaintainProjectList(response: AxiosResponse): Promise<MaintainProjectVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaintainProjectVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaintainProjectVo[]>(<any>null);
    }

    /**
     * 通过设备类型查看保养项目列表（分页）
     * @param current (optional) 当前页
     * @param deviceTypeId (optional) 设备类型id
     * @param size (optional) 每页的数量
     * @return OK
     */
    queryMaintainProjectListPage(current: number | null | undefined, deviceTypeId: string | null | undefined, size: number | null | undefined): Promise<IPageOfMaintainProjectVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-project/page?";
        if (deviceTypeId !== undefined)
            url_ += "deviceTypeId=" + encodeURIComponent("" + deviceTypeId) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainProjectListPage(_response);
        });
    }

    protected processQueryMaintainProjectListPage(response: AxiosResponse): Promise<IPageOfMaintainProjectVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfMaintainProjectVo.fromJS(resultData200) : new IPageOfMaintainProjectVo();
            return result200;
        }
        return Promise.resolve<IPageOfMaintainProjectVo>(<any>null);
    }
}

export class MaintainRecordServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 添加保养记录
     * @param maintainRecordAddDTO maintainRecordAddDTO
     * @return OK
     */
    createMaintainRecord(maintainRecordAddDTO: MaintainRecordAddDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-record/create-maintain-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maintainRecordAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateMaintainRecord(_response);
        });
    }

    protected processCreateMaintainRecord(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 删除保养记录
     * @param ids (optional) 保养记录Id
     * @return OK
     */
    deleteMaintainRecord(ids: string[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-record/delete-maintain-record?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteMaintainRecord(_response);
        });
    }

    protected processDeleteMaintainRecord(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 编辑保养记录
     * @param maintainRecordUpdateDTO maintainRecordUpdateDTO
     * @return OK
     */
    editMaintainRecord(maintainRecordUpdateDTO: MaintainRecordUpdateDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-record/edit-maintain-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maintainRecordUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditMaintainRecord(_response);
        });
    }

    protected processEditMaintainRecord(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出
     * @param maintainRecordExportDTO maintainRecordExportDTO
     * @return OK
     */
    exportMaintainRecord(maintainRecordExportDTO: MaintainRecordExportDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-record/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maintainRecordExportDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportMaintainRecord(_response);
        });
    }

    protected processExportMaintainRecord(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查看保养记录
     * @param id (optional) 保养记录ID
     * @return OK
     */
    getMaintainRecord(id: string | null | undefined): Promise<MaintainRecordVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-record/get-maintain-record?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMaintainRecord(_response);
        });
    }

    protected processGetMaintainRecord(response: AxiosResponse): Promise<MaintainRecordVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? MaintainRecordVo.fromJS(resultData200) : new MaintainRecordVo();
            return result200;
        }
        return Promise.resolve<MaintainRecordVo>(<any>null);
    }

    /**
     * 通过保养记录ID查看保养项列表（不分页）
     * @param recordId (optional) 保养记录Id
     * @return OK
     */
    queryMaintainRecordItemList(recordId: string | null | undefined): Promise<MaintainRecordItemVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-record/item-list?";
        if (recordId !== undefined)
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainRecordItemList(_response);
        });
    }

    protected processQueryMaintainRecordItemList(response: AxiosResponse): Promise<MaintainRecordItemVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaintainRecordItemVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaintainRecordItemVo[]>(<any>null);
    }

    /**
     * 通过保养记录ID查看保养项列表（分页）
     * @param current (optional) 当前页
     * @param recordId (optional) 保养记录Id
     * @param size (optional) 每页的数量
     * @return OK
     */
    queryMaintainRecordItemListPage(current: number | null | undefined, recordId: string | null | undefined, size: number | null | undefined): Promise<IPageOfMaintainRecordItemVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-record/item-page?";
        if (recordId !== undefined)
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainRecordItemListPage(_response);
        });
    }

    protected processQueryMaintainRecordItemListPage(response: AxiosResponse): Promise<IPageOfMaintainRecordItemVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfMaintainRecordItemVo.fromJS(resultData200) : new IPageOfMaintainRecordItemVo();
            return result200;
        }
        return Promise.resolve<IPageOfMaintainRecordItemVo>(<any>null);
    }

    /**
     * 通过设备类型查看保养记录（不分页）
     * @param maintainRecordSearchDTO maintainRecordSearchDTO
     * @return OK
     */
    queryMaintainRecordList(maintainRecordSearchDTO: MaintainRecordSearchDTO): Promise<MaintainRecordVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-record/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maintainRecordSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainRecordList(_response);
        });
    }

    protected processQueryMaintainRecordList(response: AxiosResponse): Promise<MaintainRecordVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaintainRecordVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaintainRecordVo[]>(<any>null);
    }

    /**
     * 通过保养记录ID查看备品备件
     * @param recordId (optional) 保养记录Id
     * @return OK
     */
    queryMaintainRecordMaterialList(recordId: string | null | undefined): Promise<RepairRecordMaterialVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-record/material-list?";
        if (recordId !== undefined)
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainRecordMaterialList(_response);
        });
    }

    protected processQueryMaintainRecordMaterialList(response: AxiosResponse): Promise<RepairRecordMaterialVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RepairRecordMaterialVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<RepairRecordMaterialVO[]>(<any>null);
    }

    /**
     * 通过设备类型查看保养记录（分页）
     * @param current (optional) 当前页
     * @param maintainRecordSearchDTO maintainRecordSearchDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    queryMaintainRecordPage(current: number | null | undefined, maintainRecordSearchDTO: MaintainRecordSearchDTO, size: number | null | undefined): Promise<IPageOfMaintainRecordVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-record/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maintainRecordSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMaintainRecordPage(_response);
        });
    }

    protected processQueryMaintainRecordPage(response: AxiosResponse): Promise<IPageOfMaintainRecordVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfMaintainRecordVo.fromJS(resultData200) : new IPageOfMaintainRecordVo();
            return result200;
        }
        return Promise.resolve<IPageOfMaintainRecordVo>(<any>null);
    }

    /**
     * 确认保养记录
     * @param id (optional) 保养记录Id
     * @return OK
     */
    confirmMaintainRecord(id: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/maintain-record/perform-maintain-record?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processConfirmMaintainRecord(_response);
        });
    }

    protected processConfirmMaintainRecord(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class MalfunctionTypeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增故障类型
     * @param malfunctionTypeAddDTO malfunctionTypeAddDTO
     * @return OK
     */
    createRepairApply(malfunctionTypeAddDTO: MalfunctionTypeAddDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/malfunction-type/create-malfunction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(malfunctionTypeAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateRepairApply(_response);
        });
    }

    protected processCreateRepairApply(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 故障类型删除(批量删除)
     * @param ids (optional) 故障类型ids
     * @return OK
     */
    deleteMalfunction(ids: string[] | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/malfunction-type/delete-malfunction-ids?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteMalfunction(_response);
        });
    }

    protected processDeleteMalfunction(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 导出故障类型
     * @param malfunctionTypeExportDTO malfunctionTypeExportDTO
     * @return OK
     */
    exportProduct(malfunctionTypeExportDTO: MalfunctionTypeExportDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/malfunction-type/export-malfunction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(malfunctionTypeExportDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportProduct(_response);
        });
    }

    protected processExportProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出故障类型模板
     * @return OK
     */
    exportMalfunctionTypeTemplate(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/malfunction-type/export/malfunction_template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportMalfunctionTypeTemplate(_response);
        });
    }

    protected processExportMalfunctionTypeTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 故障类型 详情
     * @param id id
     * @return OK
     */
    getMalfunctionDetail(id: string): Promise<MalfunctionTypeDetailVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/malfunction-type/get-malfunction-detail?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMalfunctionDetail(_response);
        });
    }

    protected processGetMalfunctionDetail(response: AxiosResponse): Promise<MalfunctionTypeDetailVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? MalfunctionTypeDetailVo.fromJS(resultData200) : new MalfunctionTypeDetailVo();
            return result200;
        }
        return Promise.resolve<MalfunctionTypeDetailVo>(<any>null);
    }

    /**
     * 导入故障类型
     * @param file (optional) file
     * @return OK
     */
    importMaterialVerification(file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/malfunction-type/import-malfunction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportMaterialVerification(_response);
        });
    }

    protected processImportMaterialVerification(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 根据关键字查询查询(不分页)
     * @param keywords keywords
     * @return OK
     */
    queryMalfunctionType(keywords: string): Promise<MalfunctionTypeDetailVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/malfunction-type/list?";
        if (keywords === undefined || keywords === null)
            throw new Error("The parameter 'keywords' must be defined and cannot be null.");
        else
            url_ += "keywords=" + encodeURIComponent("" + keywords) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMalfunctionType(_response);
        });
    }

    protected processQueryMalfunctionType(response: AxiosResponse): Promise<MalfunctionTypeDetailVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MalfunctionTypeDetailVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MalfunctionTypeDetailVo[]>(<any>null);
    }

    /**
     * 获取故障编码list
     * @return OK
     */
    getCodeAndRecord(): Promise<MalfunctionTypeRecordVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/malfunction-type/malfunction-code-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCodeAndRecord(_response);
        });
    }

    protected processGetCodeAndRecord(response: AxiosResponse): Promise<MalfunctionTypeRecordVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MalfunctionTypeRecordVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MalfunctionTypeRecordVo[]>(<any>null);
    }

    /**
     * 查询分页
     * @param current (optional) 当前页
     * @param keywords (optional) 关键词
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageRepairApply(current: number | null | undefined, keywords: string | null | undefined, size: number | null | undefined): Promise<IPageOfMalfunctionTypeDetailVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/malfunction-type/page?";
        if (keywords !== undefined)
            url_ += "keywords=" + encodeURIComponent("" + keywords) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageRepairApply(_response);
        });
    }

    protected processGetPageRepairApply(response: AxiosResponse): Promise<IPageOfMalfunctionTypeDetailVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfMalfunctionTypeDetailVo.fromJS(resultData200) : new IPageOfMalfunctionTypeDetailVo();
            return result200;
        }
        return Promise.resolve<IPageOfMalfunctionTypeDetailVo>(<any>null);
    }

    /**
     * 编辑故障类型
     * @param malfunctionTypeUpdateDTO malfunctionTypeUpdateDTO
     * @return OK
     */
    updateMalfunction(malfunctionTypeUpdateDTO: MalfunctionTypeUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/malfunction-type/update-malfunction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(malfunctionTypeUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateMalfunction(_response);
        });
    }

    protected processUpdateMalfunction(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class RepairApplyServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 根据设备ID以及申请单状态查询申请单
     * @param repairApplyConditionDTO repairApplyConditionDTO
     * @return OK
     */
    queryRepairApplyByDeviceId(repairApplyConditionDTO: RepairApplyConditionDTO): Promise<HmiRepairApplyVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-apply/condition/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(repairApplyConditionDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryRepairApplyByDeviceId(_response);
        });
    }

    protected processQueryRepairApplyByDeviceId(response: AxiosResponse): Promise<HmiRepairApplyVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HmiRepairApplyVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<HmiRepairApplyVo[]>(<any>null);
    }

    /**
     * 新增维修申请记录
     * @param repairApplyAddDto repairApplyAddDto
     * @return OK
     */
    createRepairApply(repairApplyAddDto: RepairApplyAddDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-apply/create-repair-apply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(repairApplyAddDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateRepairApply(_response);
        });
    }

    protected processCreateRepairApply(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 维修申请记录(批量删除)
     * @param ids (optional) 维修申请ids
     * @return OK
     */
    deleteApply(ids: string[] | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-apply/delete-apply-ids?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteApply(_response);
        });
    }

    protected processDeleteApply(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 导出维修申请
     * @param repairApplyExportDTO repairApplyExportDTO
     * @return OK
     */
    exportProduct(repairApplyExportDTO: RepairApplyExportDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-apply/export-apply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(repairApplyExportDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportProduct(_response);
        });
    }

    protected processExportProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取维修申请单号列表
     * @return OK
     */
    getApplyCodeList(): Promise<ApplyCodeVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-apply/get-apply-code";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetApplyCodeList(_response);
        });
    }

    protected processGetApplyCodeList(response: AxiosResponse): Promise<ApplyCodeVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplyCodeVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ApplyCodeVo[]>(<any>null);
    }

    /**
     * 获取维修申请详情(包含对应附件)
     * @param id id
     * @return OK
     */
    getApplyDetail(id: string): Promise<RepairApplyDetailVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-apply/get-apply-detail?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetApplyDetail(_response);
        });
    }

    protected processGetApplyDetail(response: AxiosResponse): Promise<RepairApplyDetailVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? RepairApplyDetailVo.fromJS(resultData200) : new RepairApplyDetailVo();
            return result200;
        }
        return Promise.resolve<RepairApplyDetailVo>(<any>null);
    }

    /**
     * 查看申请附件接口
     * @param id id
     * @return OK
     */
    getApplyFile(id: string): Promise<RepairFileVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-apply/get-apply-file?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetApplyFile(_response);
        });
    }

    protected processGetApplyFile(response: AxiosResponse): Promise<RepairFileVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? RepairFileVo.fromJS(resultData200) : new RepairFileVo();
            return result200;
        }
        return Promise.resolve<RepairFileVo>(<any>null);
    }

    /**
     * 确认维修申请单
     * @param id id
     * @return OK
     */
    implementRepairApply(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-apply/implement-repair-apply?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImplementRepairApply(_response);
        });
    }

    protected processImplementRepairApply(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 根据关键字查询(不分页)
     * @param repairApplySearchDTO repairApplySearchDTO
     * @return OK
     */
    queryRepairApply(repairApplySearchDTO: RepairApplySearchDTO): Promise<RepairApplyVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-apply/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(repairApplySearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryRepairApply(_response);
        });
    }

    protected processQueryRepairApply(response: AxiosResponse): Promise<RepairApplyVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RepairApplyVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<RepairApplyVo[]>(<any>null);
    }

    /**
     * 查询分页
     * @param current (optional) 当前页
     * @param repairApplySearchDTO repairApplySearchDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageRepairApply(current: number | null | undefined, repairApplySearchDTO: RepairApplySearchDTO, size: number | null | undefined): Promise<IPageOfRepairApplyVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-apply/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(repairApplySearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageRepairApply(_response);
        });
    }

    protected processGetPageRepairApply(response: AxiosResponse): Promise<IPageOfRepairApplyVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfRepairApplyVo.fromJS(resultData200) : new IPageOfRepairApplyVo();
            return result200;
        }
        return Promise.resolve<IPageOfRepairApplyVo>(<any>null);
    }

    /**
     * 编辑维修申请记录
     * @param repairApplyUpdateDTO repairApplyUpdateDTO
     * @return OK
     */
    updateRepairApply(repairApplyUpdateDTO: RepairApplyUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-apply/update-repair-apply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(repairApplyUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateRepairApply(_response);
        });
    }

    protected processUpdateRepairApply(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class RepairRecordServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 完成维修
     * @param id id
     * @return OK
     */
    completeRepair(id: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-record/complete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCompleteRepair(_response);
        });
    }

    protected processCompleteRepair(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 新增维修记录
     * @param repairRecordAddDTO repairRecordAddDTO
     * @return OK
     */
    createRepairApply(repairRecordAddDTO: RepairRecordAddDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-record/create-repair-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(repairRecordAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateRepairApply(_response);
        });
    }

    protected processCreateRepairApply(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 导出维修记录
     * @param repairRecordExportDTO repairRecordExportDTO
     * @return OK
     */
    exportRecord(repairRecordExportDTO: RepairRecordExportDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-record/export-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(repairRecordExportDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportRecord(_response);
        });
    }

    protected processExportRecord(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取维修记录详情
     * @param id id
     * @return OK
     */
    getApplyDetail(id: string): Promise<RepairRecordDetailVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-record/get-record-detail?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetApplyDetail(_response);
        });
    }

    protected processGetApplyDetail(response: AxiosResponse): Promise<RepairRecordDetailVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? RepairRecordDetailVo.fromJS(resultData200) : new RepairRecordDetailVo();
            return result200;
        }
        return Promise.resolve<RepairRecordDetailVo>(<any>null);
    }

    /**
     * 设备履历关联维修记录接口
     * @param deviceId deviceId
     * @return OK
     */
    getRecordByDeviceId(deviceId: string): Promise<RepairRecordVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-record/get-record-device?";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined and cannot be null.");
        else
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetRecordByDeviceId(_response);
        });
    }

    protected processGetRecordByDeviceId(response: AxiosResponse): Promise<RepairRecordVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RepairRecordVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<RepairRecordVo[]>(<any>null);
    }

    /**
     * 查看维修记录附件接口
     * @param id id
     * @return OK
     */
    getRecordFile(id: string): Promise<ApplyRecordMaterialVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-record/get-record-file?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetRecordFile(_response);
        });
    }

    protected processGetRecordFile(response: AxiosResponse): Promise<ApplyRecordMaterialVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ApplyRecordMaterialVo.fromJS(resultData200) : new ApplyRecordMaterialVo();
            return result200;
        }
        return Promise.resolve<ApplyRecordMaterialVo>(<any>null);
    }

    /**
     * 确认维修申请单
     * @param id id
     * @return OK
     */
    implementRepairRecord(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-record/implement-repair-record?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImplementRepairRecord(_response);
        });
    }

    protected processImplementRepairRecord(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 维修记录查询根据关键字查询(不分页)
     * @param repairRecordSearchDTO repairRecordSearchDTO
     * @return OK
     */
    queryRepairApply(repairRecordSearchDTO: RepairRecordSearchDTO): Promise<RepairRecordVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-record/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(repairRecordSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryRepairApply(_response);
        });
    }

    protected processQueryRepairApply(response: AxiosResponse): Promise<RepairRecordVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RepairRecordVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<RepairRecordVo[]>(<any>null);
    }

    /**
     * 查询分页
     * @param current (optional) 当前页
     * @param repairRecordSearchDTO repairRecordSearchDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageRepairApply(current: number | null | undefined, repairRecordSearchDTO: RepairRecordSearchDTO, size: number | null | undefined): Promise<IPageOfRepairRecordVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-record/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(repairRecordSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageRepairApply(_response);
        });
    }

    protected processGetPageRepairApply(response: AxiosResponse): Promise<IPageOfRepairRecordVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfRepairRecordVo.fromJS(resultData200) : new IPageOfRepairRecordVo();
            return result200;
        }
        return Promise.resolve<IPageOfRepairRecordVo>(<any>null);
    }

    /**
     * 编辑维修记录
     * @param repairRecordUpdateDTO repairRecordUpdateDTO
     * @return OK
     */
    updateRepairApply(repairRecordUpdateDTO: RepairRecordUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/repair-record/update-repair-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(repairRecordUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateRepairApply(_response);
        });
    }

    protected processUpdateRepairApply(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class ServiceRouteServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    listRoutes(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListRoutes(_response);
        });
    }

    protected processListRoutes(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class ListRoutesServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    1(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    2(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process2(_response);
        });
    }

    protected process2(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    3(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process3(_response);
        });
    }

    protected process3(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    5(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process5(_response);
        });
    }

    protected process5(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    6(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process6(_response);
        });
    }

    protected process6(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    4(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process4(_response);
        });
    }

    protected process4(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class WarningServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 今日点检记录分页
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageCheckRecordCurrent(current: number | null | undefined, size: number | null | undefined): Promise<IPageOfCheckRecordVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/waring-tpm/check-record/cur-page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageCheckRecordCurrent(_response);
        });
    }

    protected processGetPageCheckRecordCurrent(response: AxiosResponse): Promise<IPageOfCheckRecordVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfCheckRecordVO.fromJS(resultData200) : new IPageOfCheckRecordVO();
            return result200;
        }
        return Promise.resolve<IPageOfCheckRecordVO>(<any>null);
    }

    /**
     * 所有点检记录分页
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageCheckRecord(current: number | null | undefined, size: number | null | undefined): Promise<IPageOfCheckRecordVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/waring-tpm/check-record/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageCheckRecord(_response);
        });
    }

    protected processGetPageCheckRecord(response: AxiosResponse): Promise<IPageOfCheckRecordVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfCheckRecordVO.fromJS(resultData200) : new IPageOfCheckRecordVO();
            return result200;
        }
        return Promise.resolve<IPageOfCheckRecordVO>(<any>null);
    }

    /**
     * 点检记录附件
     * @param checkRecordId checkRecordId
     * @return OK
     */
    getPageFile(checkRecordId: string): Promise<CheckRecordFileVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/waring-tpm/check-record/page/file?";
        if (checkRecordId === undefined || checkRecordId === null)
            throw new Error("The parameter 'checkRecordId' must be defined and cannot be null.");
        else
            url_ += "checkRecordId=" + encodeURIComponent("" + checkRecordId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageFile(_response);
        });
    }

    protected processGetPageFile(response: AxiosResponse): Promise<CheckRecordFileVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckRecordFileVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<CheckRecordFileVO[]>(<any>null);
    }

    /**
     * 点检记录点检项
     * @param checkRecordId checkRecordId
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageItem(checkRecordId: string, current: number | null | undefined, size: number | null | undefined): Promise<IPageOfCheckRecordItemVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/waring-tpm/check-record/page/item?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (checkRecordId === undefined || checkRecordId === null)
            throw new Error("The parameter 'checkRecordId' must be defined and cannot be null.");
        else
            url_ += "checkRecordId=" + encodeURIComponent("" + checkRecordId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageItem(_response);
        });
    }

    protected processGetPageItem(response: AxiosResponse): Promise<IPageOfCheckRecordItemVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfCheckRecordItemVO.fromJS(resultData200) : new IPageOfCheckRecordItemVO();
            return result200;
        }
        return Promise.resolve<IPageOfCheckRecordItemVO>(<any>null);
    }

    /**
     * 今日点检记录数量
     * @return OK
     */
    checkRecordStatisticsNum(): Promise<number> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/waring-tpm/check-record/statistics/num";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCheckRecordStatisticsNum(_response);
        });
    }

    protected processCheckRecordStatisticsNum(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * 分页查询超期保养计划
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    pageMaintainPlanExpire(current: number | null | undefined, size: number | null | undefined): Promise<IPageOfMaintainPlanExpireVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/waring-tpm/maintain-plan/page-expired?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageMaintainPlanExpire(_response);
        });
    }

    protected processPageMaintainPlanExpire(response: AxiosResponse): Promise<IPageOfMaintainPlanExpireVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfMaintainPlanExpireVO.fromJS(resultData200) : new IPageOfMaintainPlanExpireVO();
            return result200;
        }
        return Promise.resolve<IPageOfMaintainPlanExpireVO>(<any>null);
    }

    /**
     * 分页查询保养计划待确认
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    pageMaintainPlanConfirmed(current: number | null | undefined, size: number | null | undefined): Promise<IPageOfMaintainRecordToConfirmVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/waring-tpm/maintain-plan/page-to-confirmed?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageMaintainPlanConfirmed(_response);
        });
    }

    protected processPageMaintainPlanConfirmed(response: AxiosResponse): Promise<IPageOfMaintainRecordToConfirmVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfMaintainRecordToConfirmVO.fromJS(resultData200) : new IPageOfMaintainRecordToConfirmVO();
            return result200;
        }
        return Promise.resolve<IPageOfMaintainRecordToConfirmVO>(<any>null);
    }

    /**
     * 分页查询今日保养计划
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    pageMaintainPlanToday(current: number | null | undefined, size: number | null | undefined): Promise<IPageOfMaintainPlanExpireVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/waring-tpm/maintain-plan/page-today?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageMaintainPlanToday(_response);
        });
    }

    protected processPageMaintainPlanToday(response: AxiosResponse): Promise<IPageOfMaintainPlanExpireVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfMaintainPlanExpireVO.fromJS(resultData200) : new IPageOfMaintainPlanExpireVO();
            return result200;
        }
        return Promise.resolve<IPageOfMaintainPlanExpireVO>(<any>null);
    }

    /**
     * 分页查询保养计划预警
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    pageMaintainPlanWarning(current: number | null | undefined, size: number | null | undefined): Promise<IPageOfMaintainPlanExpireVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/waring-tpm/maintain-plan/page-warning?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageMaintainPlanWarning(_response);
        });
    }

    protected processPageMaintainPlanWarning(response: AxiosResponse): Promise<IPageOfMaintainPlanExpireVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfMaintainPlanExpireVO.fromJS(resultData200) : new IPageOfMaintainPlanExpireVO();
            return result200;
        }
        return Promise.resolve<IPageOfMaintainPlanExpireVO>(<any>null);
    }

    /**
     * 保养统计
     * @return OK
     */
    maintainStatisticsNum(): Promise<MaintainStatisticsVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/waring-tpm/maintain-statistics";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMaintainStatisticsNum(_response);
        });
    }

    protected processMaintainStatisticsNum(response: AxiosResponse): Promise<MaintainStatisticsVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? MaintainStatisticsVo.fromJS(resultData200) : new MaintainStatisticsVo();
            return result200;
        }
        return Promise.resolve<MaintainStatisticsVo>(<any>null);
    }

    /**
     * 获取维修申请数量
     * @return OK
     */
    getApplyCount(): Promise<number> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/waring-tpm/repair/count-apply";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetApplyCount(_response);
        });
    }

    protected processGetApplyCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * 获取待确认维修记录数量
     * @return OK
     */
    getRecordCount(): Promise<number> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/waring-tpm/repair/count-record";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetRecordCount(_response);
        });
    }

    protected processGetRecordCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * 维修申请查询分页
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageRepairApply(current: number | null | undefined, size: number | null | undefined): Promise<IPageOfRepairApplyVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/waring-tpm/repair/page-apply?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageRepairApply(_response);
        });
    }

    protected processGetPageRepairApply(response: AxiosResponse): Promise<IPageOfRepairApplyVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfRepairApplyVo.fromJS(resultData200) : new IPageOfRepairApplyVo();
            return result200;
        }
        return Promise.resolve<IPageOfRepairApplyVo>(<any>null);
    }

    /**
     * 维修记录查询分页
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageRepairRecord(current: number | null | undefined, size: number | null | undefined): Promise<IPageOfRepairRecordVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-tpm')+ "/waring-tpm/repair/page-record?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageRepairRecord(_response);
        });
    }

    protected processGetPageRepairRecord(response: AxiosResponse): Promise<IPageOfRepairRecordVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfRepairRecordVo.fromJS(resultData200) : new IPageOfRepairRecordVo();
            return result200;
        }
        return Promise.resolve<IPageOfRepairRecordVo>(<any>null);
    }
}

export class ApplyCodeVo implements IApplyCodeVo {
    /** 申请单号 */
    applyCode!: string | undefined;
    /** 申请单id */
    id!: string | undefined;

    constructor(data?: IApplyCodeVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applyCode = data["applyCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ApplyCodeVo {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyCodeVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applyCode"] = this.applyCode;
        data["id"] = this.id;
        return data; 
    }
}

export interface IApplyCodeVo {
    /** 申请单号 */
    applyCode: string | undefined;
    /** 申请单id */
    id: string | undefined;
}

export class ApplyRecordMaterialVo implements IApplyRecordMaterialVo {
    materialVoList!: MaterialVo[] | undefined;
    repairApplyFileAddDTOList!: RepairApplyFileAddDTO[] | undefined;
    repairRecordFileAddDTOList!: RepairRecordFileAddDTO[] | undefined;

    constructor(data?: IApplyRecordMaterialVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["materialVoList"] && data["materialVoList"].constructor === Array) {
                this.materialVoList = [] as any;
                for (let item of data["materialVoList"])
                    this.materialVoList!.push(MaterialVo.fromJS(item));
            }
            if (data["repairApplyFileAddDTOList"] && data["repairApplyFileAddDTOList"].constructor === Array) {
                this.repairApplyFileAddDTOList = [] as any;
                for (let item of data["repairApplyFileAddDTOList"])
                    this.repairApplyFileAddDTOList!.push(RepairApplyFileAddDTO.fromJS(item));
            }
            if (data["repairRecordFileAddDTOList"] && data["repairRecordFileAddDTOList"].constructor === Array) {
                this.repairRecordFileAddDTOList = [] as any;
                for (let item of data["repairRecordFileAddDTOList"])
                    this.repairRecordFileAddDTOList!.push(RepairRecordFileAddDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApplyRecordMaterialVo {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyRecordMaterialVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.materialVoList && this.materialVoList.constructor === Array) {
            data["materialVoList"] = [];
            for (let item of this.materialVoList)
                data["materialVoList"].push(item.toJSON());
        }
        if (this.repairApplyFileAddDTOList && this.repairApplyFileAddDTOList.constructor === Array) {
            data["repairApplyFileAddDTOList"] = [];
            for (let item of this.repairApplyFileAddDTOList)
                data["repairApplyFileAddDTOList"].push(item.toJSON());
        }
        if (this.repairRecordFileAddDTOList && this.repairRecordFileAddDTOList.constructor === Array) {
            data["repairRecordFileAddDTOList"] = [];
            for (let item of this.repairRecordFileAddDTOList)
                data["repairRecordFileAddDTOList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IApplyRecordMaterialVo {
    materialVoList: MaterialVo[] | undefined;
    repairApplyFileAddDTOList: RepairApplyFileAddDTO[] | undefined;
    repairRecordFileAddDTOList: RepairRecordFileAddDTO[] | undefined;
}

/** 新增点检项信息 */
export class CheckItemSubmitDTO implements ICheckItemSubmitDTO {
    /** 点检项 */
    name!: string | undefined;
    /** 点检要求 */
    requirement!: string | undefined;
    /** 标准数值 */
    standardValue!: string | undefined;
    /** 数值类型 */
    valueType!: string | undefined;

    constructor(data?: ICheckItemSubmitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.requirement = data["requirement"];
            this.standardValue = data["standardValue"];
            this.valueType = data["valueType"];
        }
    }

    static fromJS(data: any): CheckItemSubmitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckItemSubmitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["requirement"] = this.requirement;
        data["standardValue"] = this.standardValue;
        data["valueType"] = this.valueType;
        return data; 
    }
}

/** 新增点检项信息 */
export interface ICheckItemSubmitDTO {
    /** 点检项 */
    name: string | undefined;
    /** 点检要求 */
    requirement: string | undefined;
    /** 标准数值 */
    standardValue: string | undefined;
    /** 数值类型 */
    valueType: string | undefined;
}

/** 更新点检项信息 */
export class CheckItemUpdateDTO implements ICheckItemUpdateDTO {
    /** 点检项主键id */
    id!: string | undefined;
    /** 点检项 */
    name!: string | undefined;
    /** 点检要求 */
    requirement!: string | undefined;
    /** 标准数值 */
    standardValue!: string | undefined;
    /** 数值类型 */
    valueType!: string | undefined;

    constructor(data?: ICheckItemUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.requirement = data["requirement"];
            this.standardValue = data["standardValue"];
            this.valueType = data["valueType"];
        }
    }

    static fromJS(data: any): CheckItemUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckItemUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["requirement"] = this.requirement;
        data["standardValue"] = this.standardValue;
        data["valueType"] = this.valueType;
        return data; 
    }
}

/** 更新点检项信息 */
export interface ICheckItemUpdateDTO {
    /** 点检项主键id */
    id: string | undefined;
    /** 点检项 */
    name: string | undefined;
    /** 点检要求 */
    requirement: string | undefined;
    /** 标准数值 */
    standardValue: string | undefined;
    /** 数值类型 */
    valueType: string | undefined;
}

/** 点检项信息 */
export class CheckItemVO implements ICheckItemVO {
    /** 点检项主键id */
    id!: string | undefined;
    /** 点检项 */
    name!: string | undefined;
    /** 点检要求 */
    requirement!: string | undefined;
    /** 标准数值 */
    standardValue!: string | undefined;
    /** 数值类型 */
    valueType!: string | undefined;

    constructor(data?: ICheckItemVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.requirement = data["requirement"];
            this.standardValue = data["standardValue"];
            this.valueType = data["valueType"];
        }
    }

    static fromJS(data: any): CheckItemVO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckItemVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["requirement"] = this.requirement;
        data["standardValue"] = this.standardValue;
        data["valueType"] = this.valueType;
        return data; 
    }
}

/** 点检项信息 */
export interface ICheckItemVO {
    /** 点检项主键id */
    id: string | undefined;
    /** 点检项 */
    name: string | undefined;
    /** 点检要求 */
    requirement: string | undefined;
    /** 标准数值 */
    standardValue: string | undefined;
    /** 数值类型 */
    valueType: string | undefined;
}

export class CheckProjectExcelDTO implements ICheckProjectExcelDTO {
    id!: string | undefined;

    constructor(data?: ICheckProjectExcelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CheckProjectExcelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckProjectExcelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface ICheckProjectExcelDTO {
    id: string | undefined;
}

/** 新增点检项目信息 */
export class CheckProjectSubmitDTO implements ICheckProjectSubmitDTO {
    /** 点检项目编码 */
    code!: string | undefined;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 点检项目下的点检项集合 */
    list!: CheckItemSubmitDTO[] | undefined;
    /** 点检项目名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: ICheckProjectSubmitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(CheckItemSubmitDTO.fromJS(item));
            }
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): CheckProjectSubmitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckProjectSubmitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 新增点检项目信息 */
export interface ICheckProjectSubmitDTO {
    /** 点检项目编码 */
    code: string | undefined;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 点检项目下的点检项集合 */
    list: CheckItemSubmitDTO[] | undefined;
    /** 点检项目名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

/** 点检项目信息 */
export class CheckProjectVO implements ICheckProjectVO {
    /** 点检项目编码 */
    code!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 点检项目名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: ICheckProjectVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): CheckProjectVO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckProjectVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 点检项目信息 */
export interface ICheckProjectVO {
    /** 点检项目编码 */
    code: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 点检项目名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class CheckRecordDTO implements ICheckRecordDTO {
    /** 点检记录code */
    checkCode!: string | undefined;
    /** 点检项目编码 */
    checkProjectCode!: string | undefined;
    /** 点检项目id */
    checkProjectId!: string | undefined;
    /** 点检项目名称 */
    checkProjectName!: string | undefined;
    /** 点检记录附件 */
    checkRecordFileList!: CheckRecordFileDTO[] | undefined;
    /** 点检记录点检项 */
    checkRecordItemList!: CheckRecordItemDTO[] | undefined;
    /** 点检结果(0: 不正常；1: 正常) */
    checkResult!: number | undefined;
    /** 点检时间 */
    checkTime!: Date | undefined;
    /** 检验人员id */
    checkUserId!: string | undefined;
    /** 检验人员名称 */
    checkUserName!: string | undefined;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 设备编码 */
    deviceCode!: string | undefined;
    /** 设备id */
    deviceId!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 设备类型 */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 点检描述 */
    remark!: string | undefined;

    constructor(data?: ICheckRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.checkCode = data["checkCode"];
            this.checkProjectCode = data["checkProjectCode"];
            this.checkProjectId = data["checkProjectId"];
            this.checkProjectName = data["checkProjectName"];
            if (data["checkRecordFileList"] && data["checkRecordFileList"].constructor === Array) {
                this.checkRecordFileList = [] as any;
                for (let item of data["checkRecordFileList"])
                    this.checkRecordFileList!.push(CheckRecordFileDTO.fromJS(item));
            }
            if (data["checkRecordItemList"] && data["checkRecordItemList"].constructor === Array) {
                this.checkRecordItemList = [] as any;
                for (let item of data["checkRecordItemList"])
                    this.checkRecordItemList!.push(CheckRecordItemDTO.fromJS(item));
            }
            this.checkResult = data["checkResult"];
            this.checkTime = data["checkTime"] ? new Date(data["checkTime"].toString()) : <any>undefined;
            this.checkUserId = data["checkUserId"];
            this.checkUserName = data["checkUserName"];
            this.codeRuleId = data["codeRuleId"];
            this.deviceCode = data["deviceCode"];
            this.deviceId = data["deviceId"];
            this.deviceName = data["deviceName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): CheckRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkCode"] = this.checkCode;
        data["checkProjectCode"] = this.checkProjectCode;
        data["checkProjectId"] = this.checkProjectId;
        data["checkProjectName"] = this.checkProjectName;
        if (this.checkRecordFileList && this.checkRecordFileList.constructor === Array) {
            data["checkRecordFileList"] = [];
            for (let item of this.checkRecordFileList)
                data["checkRecordFileList"].push(item.toJSON());
        }
        if (this.checkRecordItemList && this.checkRecordItemList.constructor === Array) {
            data["checkRecordItemList"] = [];
            for (let item of this.checkRecordItemList)
                data["checkRecordItemList"].push(item.toJSON());
        }
        data["checkResult"] = this.checkResult;
        data["checkTime"] = this.checkTime ? this.checkTime.toISOString() : <any>undefined;
        data["checkUserId"] = this.checkUserId;
        data["checkUserName"] = this.checkUserName;
        data["codeRuleId"] = this.codeRuleId;
        data["deviceCode"] = this.deviceCode;
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface ICheckRecordDTO {
    /** 点检记录code */
    checkCode: string | undefined;
    /** 点检项目编码 */
    checkProjectCode: string | undefined;
    /** 点检项目id */
    checkProjectId: string | undefined;
    /** 点检项目名称 */
    checkProjectName: string | undefined;
    /** 点检记录附件 */
    checkRecordFileList: CheckRecordFileDTO[] | undefined;
    /** 点检记录点检项 */
    checkRecordItemList: CheckRecordItemDTO[] | undefined;
    /** 点检结果(0: 不正常；1: 正常) */
    checkResult: number | undefined;
    /** 点检时间 */
    checkTime: Date | undefined;
    /** 检验人员id */
    checkUserId: string | undefined;
    /** 检验人员名称 */
    checkUserName: string | undefined;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 设备编码 */
    deviceCode: string | undefined;
    /** 设备id */
    deviceId: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 设备类型 */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 点检描述 */
    remark: string | undefined;
}

export class CheckRecordFileDTO implements ICheckRecordFileDTO {
    /** 文件mini类型 */
    contentType!: string | undefined;
    /** 文件名称 */
    fileName!: string | undefined;
    /** 文件key */
    objectKey!: string | undefined;

    constructor(data?: ICheckRecordFileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentType = data["contentType"];
            this.fileName = data["fileName"];
            this.objectKey = data["objectKey"];
        }
    }

    static fromJS(data: any): CheckRecordFileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckRecordFileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["fileName"] = this.fileName;
        data["objectKey"] = this.objectKey;
        return data; 
    }
}

export interface ICheckRecordFileDTO {
    /** 文件mini类型 */
    contentType: string | undefined;
    /** 文件名称 */
    fileName: string | undefined;
    /** 文件key */
    objectKey: string | undefined;
}

export class CheckRecordFileVO implements ICheckRecordFileVO {
    /** 点检记录id */
    checkRecordId!: string | undefined;
    /** 文件mini类型 */
    contentType!: string | undefined;
    /** 文件名称 */
    fileName!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 文件key */
    objectKey!: string | undefined;

    constructor(data?: ICheckRecordFileVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.checkRecordId = data["checkRecordId"];
            this.contentType = data["contentType"];
            this.fileName = data["fileName"];
            this.id = data["id"];
            this.objectKey = data["objectKey"];
        }
    }

    static fromJS(data: any): CheckRecordFileVO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckRecordFileVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkRecordId"] = this.checkRecordId;
        data["contentType"] = this.contentType;
        data["fileName"] = this.fileName;
        data["id"] = this.id;
        data["objectKey"] = this.objectKey;
        return data; 
    }
}

export interface ICheckRecordFileVO {
    /** 点检记录id */
    checkRecordId: string | undefined;
    /** 文件mini类型 */
    contentType: string | undefined;
    /** 文件名称 */
    fileName: string | undefined;
    /** id */
    id: string | undefined;
    /** 文件key */
    objectKey: string | undefined;
}

export class CheckRecordIdsDTO implements ICheckRecordIdsDTO {
    ids!: string[] | undefined;

    constructor(data?: ICheckRecordIdsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [] as any;
                for (let item of data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): CheckRecordIdsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckRecordIdsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface ICheckRecordIdsDTO {
    ids: string[] | undefined;
}

export class CheckRecordItemDTO implements ICheckRecordItemDTO {
    /** 检验数值 */
    checkValue!: string | undefined;
    /** 点检项id */
    itemId!: string | undefined;
    /** 点检项 */
    name!: string | undefined;
    /** 标准数值 */
    standardValue!: string | undefined;

    constructor(data?: ICheckRecordItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.checkValue = data["checkValue"];
            this.itemId = data["itemId"];
            this.name = data["name"];
            this.standardValue = data["standardValue"];
        }
    }

    static fromJS(data: any): CheckRecordItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckRecordItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkValue"] = this.checkValue;
        data["itemId"] = this.itemId;
        data["name"] = this.name;
        data["standardValue"] = this.standardValue;
        return data; 
    }
}

export interface ICheckRecordItemDTO {
    /** 检验数值 */
    checkValue: string | undefined;
    /** 点检项id */
    itemId: string | undefined;
    /** 点检项 */
    name: string | undefined;
    /** 标准数值 */
    standardValue: string | undefined;
}

export class CheckRecordItemVO implements ICheckRecordItemVO {
    /** 点检记录id */
    checkRecordId!: string | undefined;
    /** 检验数值 */
    checkValue!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 点检项 */
    name!: string | undefined;
    /** 标准数值 */
    standardValue!: string | undefined;

    constructor(data?: ICheckRecordItemVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.checkRecordId = data["checkRecordId"];
            this.checkValue = data["checkValue"];
            this.id = data["id"];
            this.name = data["name"];
            this.standardValue = data["standardValue"];
        }
    }

    static fromJS(data: any): CheckRecordItemVO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckRecordItemVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkRecordId"] = this.checkRecordId;
        data["checkValue"] = this.checkValue;
        data["id"] = this.id;
        data["name"] = this.name;
        data["standardValue"] = this.standardValue;
        return data; 
    }
}

export interface ICheckRecordItemVO {
    /** 点检记录id */
    checkRecordId: string | undefined;
    /** 检验数值 */
    checkValue: string | undefined;
    /** id */
    id: string | undefined;
    /** 点检项 */
    name: string | undefined;
    /** 标准数值 */
    standardValue: string | undefined;
}

export class CheckRecordUpdateDTO implements ICheckRecordUpdateDTO {
    /** 点检记录code */
    checkCode!: string | undefined;
    /** 点检项目编码 */
    checkProjectCode!: string | undefined;
    /** 点检项目id */
    checkProjectId!: string | undefined;
    /** 点检项目名称 */
    checkProjectName!: string | undefined;
    /** 点检记录附件 */
    checkRecordFileList!: CheckRecordFileDTO[] | undefined;
    /** 点检记录点检项 */
    checkRecordItemList!: CheckRecordItemDTO[] | undefined;
    /** 点检结果(0: 不正常；1: 正常) */
    checkResult!: number | undefined;
    /** 点检时间 */
    checkTime!: Date | undefined;
    /** 检验人员id */
    checkUserId!: string | undefined;
    /** 检验人员名称 */
    checkUserName!: string | undefined;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 设备编码 */
    deviceCode!: string | undefined;
    /** 设备id */
    deviceId!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 设备类型 */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 点检记录id */
    id!: string | undefined;
    /** 点检描述 */
    remark!: string | undefined;

    constructor(data?: ICheckRecordUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.checkCode = data["checkCode"];
            this.checkProjectCode = data["checkProjectCode"];
            this.checkProjectId = data["checkProjectId"];
            this.checkProjectName = data["checkProjectName"];
            if (data["checkRecordFileList"] && data["checkRecordFileList"].constructor === Array) {
                this.checkRecordFileList = [] as any;
                for (let item of data["checkRecordFileList"])
                    this.checkRecordFileList!.push(CheckRecordFileDTO.fromJS(item));
            }
            if (data["checkRecordItemList"] && data["checkRecordItemList"].constructor === Array) {
                this.checkRecordItemList = [] as any;
                for (let item of data["checkRecordItemList"])
                    this.checkRecordItemList!.push(CheckRecordItemDTO.fromJS(item));
            }
            this.checkResult = data["checkResult"];
            this.checkTime = data["checkTime"] ? new Date(data["checkTime"].toString()) : <any>undefined;
            this.checkUserId = data["checkUserId"];
            this.checkUserName = data["checkUserName"];
            this.codeRuleId = data["codeRuleId"];
            this.deviceCode = data["deviceCode"];
            this.deviceId = data["deviceId"];
            this.deviceName = data["deviceName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.id = data["id"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): CheckRecordUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckRecordUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkCode"] = this.checkCode;
        data["checkProjectCode"] = this.checkProjectCode;
        data["checkProjectId"] = this.checkProjectId;
        data["checkProjectName"] = this.checkProjectName;
        if (this.checkRecordFileList && this.checkRecordFileList.constructor === Array) {
            data["checkRecordFileList"] = [];
            for (let item of this.checkRecordFileList)
                data["checkRecordFileList"].push(item.toJSON());
        }
        if (this.checkRecordItemList && this.checkRecordItemList.constructor === Array) {
            data["checkRecordItemList"] = [];
            for (let item of this.checkRecordItemList)
                data["checkRecordItemList"].push(item.toJSON());
        }
        data["checkResult"] = this.checkResult;
        data["checkTime"] = this.checkTime ? this.checkTime.toISOString() : <any>undefined;
        data["checkUserId"] = this.checkUserId;
        data["checkUserName"] = this.checkUserName;
        data["codeRuleId"] = this.codeRuleId;
        data["deviceCode"] = this.deviceCode;
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["id"] = this.id;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface ICheckRecordUpdateDTO {
    /** 点检记录code */
    checkCode: string | undefined;
    /** 点检项目编码 */
    checkProjectCode: string | undefined;
    /** 点检项目id */
    checkProjectId: string | undefined;
    /** 点检项目名称 */
    checkProjectName: string | undefined;
    /** 点检记录附件 */
    checkRecordFileList: CheckRecordFileDTO[] | undefined;
    /** 点检记录点检项 */
    checkRecordItemList: CheckRecordItemDTO[] | undefined;
    /** 点检结果(0: 不正常；1: 正常) */
    checkResult: number | undefined;
    /** 点检时间 */
    checkTime: Date | undefined;
    /** 检验人员id */
    checkUserId: string | undefined;
    /** 检验人员名称 */
    checkUserName: string | undefined;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 设备编码 */
    deviceCode: string | undefined;
    /** 设备id */
    deviceId: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 设备类型 */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 点检记录id */
    id: string | undefined;
    /** 点检描述 */
    remark: string | undefined;
}

export class CheckRecordVO implements ICheckRecordVO {
    /** 点检记录code */
    checkCode!: string | undefined;
    /** 点检项目编码 */
    checkProjectCode!: string | undefined;
    /** 点检项目id */
    checkProjectId!: string | undefined;
    /** 点检项目名称 */
    checkProjectName!: string | undefined;
    /** 点检结果(0: 不正常；1: 正常) */
    checkResult!: number | undefined;
    /** 点检时间 */
    checkTime!: Date | undefined;
    /** 检验人员id */
    checkUserId!: string | undefined;
    /** 检验人员名称 */
    checkUserName!: string | undefined;
    /** 设备编码 */
    deviceCode!: string | undefined;
    /** 设备id */
    deviceId!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 设备类型 */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 点检记录id */
    id!: string | undefined;
    /** 点检描述 */
    remark!: string | undefined;

    constructor(data?: ICheckRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.checkCode = data["checkCode"];
            this.checkProjectCode = data["checkProjectCode"];
            this.checkProjectId = data["checkProjectId"];
            this.checkProjectName = data["checkProjectName"];
            this.checkResult = data["checkResult"];
            this.checkTime = data["checkTime"] ? new Date(data["checkTime"].toString()) : <any>undefined;
            this.checkUserId = data["checkUserId"];
            this.checkUserName = data["checkUserName"];
            this.deviceCode = data["deviceCode"];
            this.deviceId = data["deviceId"];
            this.deviceName = data["deviceName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.id = data["id"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): CheckRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkCode"] = this.checkCode;
        data["checkProjectCode"] = this.checkProjectCode;
        data["checkProjectId"] = this.checkProjectId;
        data["checkProjectName"] = this.checkProjectName;
        data["checkResult"] = this.checkResult;
        data["checkTime"] = this.checkTime ? this.checkTime.toISOString() : <any>undefined;
        data["checkUserId"] = this.checkUserId;
        data["checkUserName"] = this.checkUserName;
        data["deviceCode"] = this.deviceCode;
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["id"] = this.id;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface ICheckRecordVO {
    /** 点检记录code */
    checkCode: string | undefined;
    /** 点检项目编码 */
    checkProjectCode: string | undefined;
    /** 点检项目id */
    checkProjectId: string | undefined;
    /** 点检项目名称 */
    checkProjectName: string | undefined;
    /** 点检结果(0: 不正常；1: 正常) */
    checkResult: number | undefined;
    /** 点检时间 */
    checkTime: Date | undefined;
    /** 检验人员id */
    checkUserId: string | undefined;
    /** 检验人员名称 */
    checkUserName: string | undefined;
    /** 设备编码 */
    deviceCode: string | undefined;
    /** 设备id */
    deviceId: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 设备类型 */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 点检记录id */
    id: string | undefined;
    /** 点检描述 */
    remark: string | undefined;
}

/** 编辑点检项目和以及对应的点检项信息 */
export class CheckUpdateDTO implements ICheckUpdateDTO {
    /** 点检项目编码 */
    code!: string | undefined;
    /** 点检项目主键id */
    id!: string | undefined;
    /** 点检项目下的点检项 */
    list!: CheckItemUpdateDTO[] | undefined;
    /** 点检项目名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: ICheckUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(CheckItemUpdateDTO.fromJS(item));
            }
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): CheckUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 编辑点检项目和以及对应的点检项信息 */
export interface ICheckUpdateDTO {
    /** 点检项目编码 */
    code: string | undefined;
    /** 点检项目主键id */
    id: string | undefined;
    /** 点检项目下的点检项 */
    list: CheckItemUpdateDTO[] | undefined;
    /** 点检项目名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

/** 点检项目和以及对应的点检项信息 */
export class CheckVO implements ICheckVO {
    /** 点检项目编码 */
    code!: string | undefined;
    /** 点检项目主键id */
    id!: string | undefined;
    /** 点检项目下的点检项 */
    list!: CheckItemVO[] | undefined;
    /** 点检项目名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: ICheckVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(CheckItemVO.fromJS(item));
            }
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): CheckVO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 点检项目和以及对应的点检项信息 */
export interface ICheckVO {
    /** 点检项目编码 */
    code: string | undefined;
    /** 点检项目主键id */
    id: string | undefined;
    /** 点检项目下的点检项 */
    list: CheckItemVO[] | undefined;
    /** 点检项目名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

/** 备品工况导出 */
export class DeviceMaterialRecordExcelDTO implements IDeviceMaterialRecordExcelDTO {
    /** 设备编码 */
    deviceCode!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 设备类型名称 */
    deviceType!: string | undefined;
    /** 设备id */
    id!: string | undefined;

    constructor(data?: IDeviceMaterialRecordExcelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceCode = data["deviceCode"];
            this.deviceName = data["deviceName"];
            this.deviceType = data["deviceType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeviceMaterialRecordExcelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceMaterialRecordExcelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceCode"] = this.deviceCode;
        data["deviceName"] = this.deviceName;
        data["deviceType"] = this.deviceType;
        data["id"] = this.id;
        return data; 
    }
}

/** 备品工况导出 */
export interface IDeviceMaterialRecordExcelDTO {
    /** 设备编码 */
    deviceCode: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 设备类型名称 */
    deviceType: string | undefined;
    /** 设备id */
    id: string | undefined;
}

/** 备品工况 */
export class DeviceMaterialRecordVO implements IDeviceMaterialRecordVO {
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 保养记录Id/维修单Id */
    materialId!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 数量 */
    number!: number | undefined;
    /** 保养/维修单号 */
    recordCode!: string | undefined;
    /** 保养记录Id/维修单Id */
    recordId!: string | undefined;
    /** 使用时间（维修单或保养记录的结束时间） */
    usageTime!: Date | undefined;
    /** 使用人员姓名 */
    userName!: string | undefined;

    constructor(data?: IDeviceMaterialRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.number = data["number"];
            this.recordCode = data["recordCode"];
            this.recordId = data["recordId"];
            this.usageTime = data["usageTime"] ? new Date(data["usageTime"].toString()) : <any>undefined;
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): DeviceMaterialRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceMaterialRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["number"] = this.number;
        data["recordCode"] = this.recordCode;
        data["recordId"] = this.recordId;
        data["usageTime"] = this.usageTime ? this.usageTime.toISOString() : <any>undefined;
        data["userName"] = this.userName;
        return data; 
    }
}

/** 备品工况 */
export interface IDeviceMaterialRecordVO {
    /** 物料编码 */
    materialCode: string | undefined;
    /** 保养记录Id/维修单Id */
    materialId: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 数量 */
    number: number | undefined;
    /** 保养/维修单号 */
    recordCode: string | undefined;
    /** 保养记录Id/维修单Id */
    recordId: string | undefined;
    /** 使用时间（维修单或保养记录的结束时间） */
    usageTime: Date | undefined;
    /** 使用人员姓名 */
    userName: string | undefined;
}

/** 设备类型添加呼叫类型 */
export class DeviceTypeAndonTypeDTO implements IDeviceTypeAndonTypeDTO {
    /** 呼叫类型编码 */
    andonTypeCode!: string;
    /** 呼叫类型id */
    andonTypeId!: string;
    /** 呼叫类型名称 */
    andonTypeName!: string;
    /** 设备类型id */
    deviceTypeId!: string;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IDeviceTypeAndonTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.andonTypeCode = data["andonTypeCode"];
            this.andonTypeId = data["andonTypeId"];
            this.andonTypeName = data["andonTypeName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): DeviceTypeAndonTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceTypeAndonTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["andonTypeCode"] = this.andonTypeCode;
        data["andonTypeId"] = this.andonTypeId;
        data["andonTypeName"] = this.andonTypeName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 设备类型添加呼叫类型 */
export interface IDeviceTypeAndonTypeDTO {
    /** 呼叫类型编码 */
    andonTypeCode: string;
    /** 呼叫类型id */
    andonTypeId: string;
    /** 呼叫类型名称 */
    andonTypeName: string;
    /** 设备类型id */
    deviceTypeId: string;
    /** 备注 */
    remark: string | undefined;
}

/** 设备类型呼叫类型信息 */
export class DeviceTypeAndonTypeVO implements IDeviceTypeAndonTypeVO {
    /** 呼叫类型编码 */
    andonTypeCode!: string | undefined;
    /** 呼叫类型id */
    andonTypeId!: string | undefined;
    /** 呼叫类型名称 */
    andonTypeName!: string | undefined;
    /** 设备类型id */
    deviceTypeId!: string | undefined;
    /** 设备类型呼叫类型主键id */
    id!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IDeviceTypeAndonTypeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.andonTypeCode = data["andonTypeCode"];
            this.andonTypeId = data["andonTypeId"];
            this.andonTypeName = data["andonTypeName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.id = data["id"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): DeviceTypeAndonTypeVO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceTypeAndonTypeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["andonTypeCode"] = this.andonTypeCode;
        data["andonTypeId"] = this.andonTypeId;
        data["andonTypeName"] = this.andonTypeName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["id"] = this.id;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 设备类型呼叫类型信息 */
export interface IDeviceTypeAndonTypeVO {
    /** 呼叫类型编码 */
    andonTypeCode: string | undefined;
    /** 呼叫类型id */
    andonTypeId: string | undefined;
    /** 呼叫类型名称 */
    andonTypeName: string | undefined;
    /** 设备类型id */
    deviceTypeId: string | undefined;
    /** 设备类型呼叫类型主键id */
    id: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

/** 设备类型添加点检项目 */
export class DeviceTypeCheckProjectDTO implements IDeviceTypeCheckProjectDTO {
    /** 设备类型id */
    deviceTypeId!: string | undefined;
    /** 设备类型添加的点检项目 */
    list!: DeviceTypeCheckProjectListDTO[] | undefined;

    constructor(data?: IDeviceTypeCheckProjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceTypeId = data["deviceTypeId"];
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(DeviceTypeCheckProjectListDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceTypeCheckProjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceTypeCheckProjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceTypeId"] = this.deviceTypeId;
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        return data; 
    }
}

/** 设备类型添加点检项目 */
export interface IDeviceTypeCheckProjectDTO {
    /** 设备类型id */
    deviceTypeId: string | undefined;
    /** 设备类型添加的点检项目 */
    list: DeviceTypeCheckProjectListDTO[] | undefined;
}

/** 设备类型下添加的点检项目 */
export class DeviceTypeCheckProjectListDTO implements IDeviceTypeCheckProjectListDTO {
    /** 点检项目id */
    checkProjectId!: string | undefined;
    /** 点检项目编码 */
    code!: string | undefined;
    /** 点检周期 */
    intervalTime!: number | undefined;
    /** 点检项目 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IDeviceTypeCheckProjectListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.checkProjectId = data["checkProjectId"];
            this.code = data["code"];
            this.intervalTime = data["intervalTime"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): DeviceTypeCheckProjectListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceTypeCheckProjectListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkProjectId"] = this.checkProjectId;
        data["code"] = this.code;
        data["intervalTime"] = this.intervalTime;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 设备类型下添加的点检项目 */
export interface IDeviceTypeCheckProjectListDTO {
    /** 点检项目id */
    checkProjectId: string | undefined;
    /** 点检项目编码 */
    code: string | undefined;
    /** 点检周期 */
    intervalTime: number | undefined;
    /** 点检项目 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

/** 设备类型点检项目信息 */
export class DeviceTypeCheckProjectVO implements IDeviceTypeCheckProjectVO {
    /** 点检项目id */
    checkProjectId!: string | undefined;
    /** 点检项目编码 */
    code!: string | undefined;
    /** 设备类型点检项目主键id */
    id!: string | undefined;
    /** 点检周期 */
    intervalTime!: number | undefined;
    /** 点检项目 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IDeviceTypeCheckProjectVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.checkProjectId = data["checkProjectId"];
            this.code = data["code"];
            this.id = data["id"];
            this.intervalTime = data["intervalTime"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): DeviceTypeCheckProjectVO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceTypeCheckProjectVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkProjectId"] = this.checkProjectId;
        data["code"] = this.code;
        data["id"] = this.id;
        data["intervalTime"] = this.intervalTime;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 设备类型点检项目信息 */
export interface IDeviceTypeCheckProjectVO {
    /** 点检项目id */
    checkProjectId: string | undefined;
    /** 点检项目编码 */
    code: string | undefined;
    /** 设备类型点检项目主键id */
    id: string | undefined;
    /** 点检周期 */
    intervalTime: number | undefined;
    /** 点检项目 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class GatewayFilterDefinition implements IGatewayFilterDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayFilterDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayFilterDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayFilterDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayFilterDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class GatewayPredicateDefinition implements IGatewayPredicateDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayPredicateDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayPredicateDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayPredicateDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayPredicateDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class HmiRepairApplyVo implements IHmiRepairApplyVo {
    /** 申请单号 */
    applyCode!: string | undefined;
    /** 申请单状态： 待执行 1  执行中 2  待确认 3  已确认 4 */
    applyStatus!: number | undefined;
    /** 申请时间 */
    applyTime!: Date | undefined;
    /** id */
    id!: string | undefined;
    /** 故障编码 */
    malfunctionCode!: string | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgency!: number | undefined;

    constructor(data?: IHmiRepairApplyVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applyCode = data["applyCode"];
            this.applyStatus = data["applyStatus"];
            this.applyTime = data["applyTime"] ? new Date(data["applyTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.malfunctionCode = data["malfunctionCode"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.urgency = data["urgency"];
        }
    }

    static fromJS(data: any): HmiRepairApplyVo {
        data = typeof data === 'object' ? data : {};
        let result = new HmiRepairApplyVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applyCode"] = this.applyCode;
        data["applyStatus"] = this.applyStatus;
        data["applyTime"] = this.applyTime ? this.applyTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["malfunctionCode"] = this.malfunctionCode;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["urgency"] = this.urgency;
        return data; 
    }
}

export interface IHmiRepairApplyVo {
    /** 申请单号 */
    applyCode: string | undefined;
    /** 申请单状态： 待执行 1  执行中 2  待确认 3  已确认 4 */
    applyStatus: number | undefined;
    /** 申请时间 */
    applyTime: Date | undefined;
    /** id */
    id: string | undefined;
    /** 故障编码 */
    malfunctionCode: string | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgency: number | undefined;
}

export class IPageOfCheckItemVO implements IIPageOfCheckItemVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: CheckItemVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfCheckItemVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(CheckItemVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfCheckItemVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfCheckItemVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfCheckItemVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: CheckItemVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfCheckProjectVO implements IIPageOfCheckProjectVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: CheckProjectVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfCheckProjectVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(CheckProjectVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfCheckProjectVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfCheckProjectVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfCheckProjectVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: CheckProjectVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfCheckRecordItemVO implements IIPageOfCheckRecordItemVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: CheckRecordItemVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfCheckRecordItemVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(CheckRecordItemVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfCheckRecordItemVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfCheckRecordItemVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfCheckRecordItemVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: CheckRecordItemVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfCheckRecordVO implements IIPageOfCheckRecordVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: CheckRecordVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfCheckRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(CheckRecordVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfCheckRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfCheckRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfCheckRecordVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: CheckRecordVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfDeviceMaterialRecordVO implements IIPageOfDeviceMaterialRecordVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: DeviceMaterialRecordVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfDeviceMaterialRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(DeviceMaterialRecordVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfDeviceMaterialRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfDeviceMaterialRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfDeviceMaterialRecordVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: DeviceMaterialRecordVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfDeviceTypeAndonTypeVO implements IIPageOfDeviceTypeAndonTypeVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: DeviceTypeAndonTypeVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfDeviceTypeAndonTypeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(DeviceTypeAndonTypeVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfDeviceTypeAndonTypeVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfDeviceTypeAndonTypeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfDeviceTypeAndonTypeVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: DeviceTypeAndonTypeVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfDeviceTypeCheckProjectVO implements IIPageOfDeviceTypeCheckProjectVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: DeviceTypeCheckProjectVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfDeviceTypeCheckProjectVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(DeviceTypeCheckProjectVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfDeviceTypeCheckProjectVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfDeviceTypeCheckProjectVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfDeviceTypeCheckProjectVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: DeviceTypeCheckProjectVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfMaintainItemVo implements IIPageOfMaintainItemVo {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: MaintainItemVo[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfMaintainItemVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(MaintainItemVo.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfMaintainItemVo {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfMaintainItemVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfMaintainItemVo {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: MaintainItemVo[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfMaintainPlanExpireVO implements IIPageOfMaintainPlanExpireVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: MaintainPlanExpireVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfMaintainPlanExpireVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(MaintainPlanExpireVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfMaintainPlanExpireVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfMaintainPlanExpireVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfMaintainPlanExpireVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: MaintainPlanExpireVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfMaintainPlanItemVo implements IIPageOfMaintainPlanItemVo {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: MaintainPlanItemVo[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfMaintainPlanItemVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(MaintainPlanItemVo.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfMaintainPlanItemVo {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfMaintainPlanItemVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfMaintainPlanItemVo {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: MaintainPlanItemVo[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfMaintainPlanVo implements IIPageOfMaintainPlanVo {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: MaintainPlanVo[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfMaintainPlanVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(MaintainPlanVo.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfMaintainPlanVo {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfMaintainPlanVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfMaintainPlanVo {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: MaintainPlanVo[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfMaintainProjectItemVo implements IIPageOfMaintainProjectItemVo {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: MaintainProjectItemVo[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfMaintainProjectItemVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(MaintainProjectItemVo.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfMaintainProjectItemVo {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfMaintainProjectItemVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfMaintainProjectItemVo {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: MaintainProjectItemVo[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfMaintainProjectVo implements IIPageOfMaintainProjectVo {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: MaintainProjectVo[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfMaintainProjectVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(MaintainProjectVo.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfMaintainProjectVo {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfMaintainProjectVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfMaintainProjectVo {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: MaintainProjectVo[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfMaintainRecordItemVo implements IIPageOfMaintainRecordItemVo {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: MaintainRecordItemVo[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfMaintainRecordItemVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(MaintainRecordItemVo.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfMaintainRecordItemVo {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfMaintainRecordItemVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfMaintainRecordItemVo {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: MaintainRecordItemVo[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfMaintainRecordToConfirmVO implements IIPageOfMaintainRecordToConfirmVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: MaintainRecordToConfirmVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfMaintainRecordToConfirmVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(MaintainRecordToConfirmVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfMaintainRecordToConfirmVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfMaintainRecordToConfirmVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfMaintainRecordToConfirmVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: MaintainRecordToConfirmVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfMaintainRecordVo implements IIPageOfMaintainRecordVo {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: MaintainRecordVo[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfMaintainRecordVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(MaintainRecordVo.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfMaintainRecordVo {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfMaintainRecordVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfMaintainRecordVo {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: MaintainRecordVo[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfMalfunctionTypeDetailVo implements IIPageOfMalfunctionTypeDetailVo {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: MalfunctionTypeDetailVo[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfMalfunctionTypeDetailVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(MalfunctionTypeDetailVo.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfMalfunctionTypeDetailVo {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfMalfunctionTypeDetailVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfMalfunctionTypeDetailVo {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: MalfunctionTypeDetailVo[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfRepairApplyVo implements IIPageOfRepairApplyVo {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: RepairApplyVo[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfRepairApplyVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(RepairApplyVo.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfRepairApplyVo {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfRepairApplyVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfRepairApplyVo {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: RepairApplyVo[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfRepairRecordVo implements IIPageOfRepairRecordVo {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: RepairRecordVo[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfRepairRecordVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(RepairRecordVo.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfRepairRecordVo {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfRepairRecordVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfRepairRecordVo {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: RepairRecordVo[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class MaintainItemAddDTO implements IMaintainItemAddDTO {
    /** 编码 */
    code!: string | undefined;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 保养要求 */
    requirement!: string | undefined;

    constructor(data?: IMaintainItemAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.name = data["name"];
            this.remark = data["remark"];
            this.requirement = data["requirement"];
        }
    }

    static fromJS(data: any): MaintainItemAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainItemAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["requirement"] = this.requirement;
        return data; 
    }
}

export interface IMaintainItemAddDTO {
    /** 编码 */
    code: string | undefined;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 保养要求 */
    requirement: string | undefined;
}

export class MaintainItemExportDTO implements IMaintainItemExportDTO {
    /** 是否选中导出 */
    exportSelected!: boolean | undefined;
    /** 关键词 */
    keyWord!: string | undefined;
    /** 选中记录id集合 */
    selectedRecords!: string[] | undefined;

    constructor(data?: IMaintainItemExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.exportSelected = data["exportSelected"];
            this.keyWord = data["keyWord"];
            if (data["selectedRecords"] && data["selectedRecords"].constructor === Array) {
                this.selectedRecords = [] as any;
                for (let item of data["selectedRecords"])
                    this.selectedRecords!.push(item);
            }
        }
    }

    static fromJS(data: any): MaintainItemExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainItemExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exportSelected"] = this.exportSelected;
        data["keyWord"] = this.keyWord;
        if (this.selectedRecords && this.selectedRecords.constructor === Array) {
            data["selectedRecords"] = [];
            for (let item of this.selectedRecords)
                data["selectedRecords"].push(item);
        }
        return data; 
    }
}

export interface IMaintainItemExportDTO {
    /** 是否选中导出 */
    exportSelected: boolean | undefined;
    /** 关键词 */
    keyWord: string | undefined;
    /** 选中记录id集合 */
    selectedRecords: string[] | undefined;
}

export class MaintainItemUpdateDTO implements IMaintainItemUpdateDTO {
    /** 编号 */
    code!: string | undefined;
    /** 保养项Id */
    id!: string | undefined;
    /** 名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 保养要求 */
    requirement!: string | undefined;

    constructor(data?: IMaintainItemUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
            this.requirement = data["requirement"];
        }
    }

    static fromJS(data: any): MaintainItemUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainItemUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["requirement"] = this.requirement;
        return data; 
    }
}

export interface IMaintainItemUpdateDTO {
    /** 编号 */
    code: string | undefined;
    /** 保养项Id */
    id: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 保养要求 */
    requirement: string | undefined;
}

/** 保养项 */
export class MaintainItemVo implements IMaintainItemVo {
    /** 编号 */
    code!: string | undefined;
    /** 保养项Id（主键） */
    id!: string | undefined;
    /** 名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 保养要求 */
    requirement!: string | undefined;

    constructor(data?: IMaintainItemVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
            this.requirement = data["requirement"];
        }
    }

    static fromJS(data: any): MaintainItemVo {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainItemVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["requirement"] = this.requirement;
        return data; 
    }
}

/** 保养项 */
export interface IMaintainItemVo {
    /** 编号 */
    code: string | undefined;
    /** 保养项Id（主键） */
    id: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 保养要求 */
    requirement: string | undefined;
}

export class MaintainPlanAddDTO implements IMaintainPlanAddDTO {
    /** 编码 */
    code!: string | undefined;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 设备编码 */
    deviceCode!: string | undefined;
    /** 设备Id */
    deviceId!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 设备类型Id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 保养日期 */
    maintainDate!: Date | undefined;
    /** 保养项目保养项 */
    maintainItemList!: MaintainPlanItemAddDTO[] | undefined;
    /** 保养预警提示 */
    preWarningDays!: number | undefined;
    /** 保养项目编码 */
    projectCode!: string | undefined;
    /** 保养项目名称 */
    projectName!: string | undefined;

    constructor(data?: IMaintainPlanAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.deviceCode = data["deviceCode"];
            this.deviceId = data["deviceId"];
            this.deviceName = data["deviceName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.maintainDate = data["maintainDate"] ? new Date(data["maintainDate"].toString()) : <any>undefined;
            if (data["maintainItemList"] && data["maintainItemList"].constructor === Array) {
                this.maintainItemList = [] as any;
                for (let item of data["maintainItemList"])
                    this.maintainItemList!.push(MaintainPlanItemAddDTO.fromJS(item));
            }
            this.preWarningDays = data["preWarningDays"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): MaintainPlanAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainPlanAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["deviceCode"] = this.deviceCode;
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["maintainDate"] = this.maintainDate ? this.maintainDate.toISOString() : <any>undefined;
        if (this.maintainItemList && this.maintainItemList.constructor === Array) {
            data["maintainItemList"] = [];
            for (let item of this.maintainItemList)
                data["maintainItemList"].push(item.toJSON());
        }
        data["preWarningDays"] = this.preWarningDays;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        return data; 
    }
}

export interface IMaintainPlanAddDTO {
    /** 编码 */
    code: string | undefined;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 设备编码 */
    deviceCode: string | undefined;
    /** 设备Id */
    deviceId: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 设备类型Id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 保养日期 */
    maintainDate: Date | undefined;
    /** 保养项目保养项 */
    maintainItemList: MaintainPlanItemAddDTO[] | undefined;
    /** 保养预警提示 */
    preWarningDays: number | undefined;
    /** 保养项目编码 */
    projectCode: string | undefined;
    /** 保养项目名称 */
    projectName: string | undefined;
}

/** 保养计划超期 */
export class MaintainPlanExpireVO implements IMaintainPlanExpireVO {
    /** 计划任务编码 */
    code!: string | undefined;
    /** 设备编码 */
    deviceCode!: string | undefined;
    /** 设备Id */
    deviceId!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 设备类型Id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 保养计划Id（主键） */
    id!: string | undefined;
    /** 周期（天） */
    intervalTime!: number | undefined;
    /** 是否自动生成计划 */
    isAuto!: number | undefined;
    /** 保养日期 */
    maintainDate!: Date | undefined;
    /** 计划状态 */
    planStatus!: number | undefined;
    /** 计划状态名称 */
    planStatusName!: string | undefined;
    /** 上一次保养时间 */
    preMaintainTime!: Date | undefined;
    /** 保养预警提示 */
    preWarningDays!: number | undefined;
    /** 保养项目编码 */
    projectCode!: string | undefined;
    /** 保养项目Id */
    projectId!: string | undefined;
    /** 保养项目名称 */
    projectName!: string | undefined;

    constructor(data?: IMaintainPlanExpireVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.deviceCode = data["deviceCode"];
            this.deviceId = data["deviceId"];
            this.deviceName = data["deviceName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.id = data["id"];
            this.intervalTime = data["intervalTime"];
            this.isAuto = data["isAuto"];
            this.maintainDate = data["maintainDate"] ? new Date(data["maintainDate"].toString()) : <any>undefined;
            this.planStatus = data["planStatus"];
            this.planStatusName = data["planStatusName"];
            this.preMaintainTime = data["preMaintainTime"] ? new Date(data["preMaintainTime"].toString()) : <any>undefined;
            this.preWarningDays = data["preWarningDays"];
            this.projectCode = data["projectCode"];
            this.projectId = data["projectId"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): MaintainPlanExpireVO {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainPlanExpireVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["deviceCode"] = this.deviceCode;
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["id"] = this.id;
        data["intervalTime"] = this.intervalTime;
        data["isAuto"] = this.isAuto;
        data["maintainDate"] = this.maintainDate ? this.maintainDate.toISOString() : <any>undefined;
        data["planStatus"] = this.planStatus;
        data["planStatusName"] = this.planStatusName;
        data["preMaintainTime"] = this.preMaintainTime ? this.preMaintainTime.toISOString() : <any>undefined;
        data["preWarningDays"] = this.preWarningDays;
        data["projectCode"] = this.projectCode;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        return data; 
    }
}

/** 保养计划超期 */
export interface IMaintainPlanExpireVO {
    /** 计划任务编码 */
    code: string | undefined;
    /** 设备编码 */
    deviceCode: string | undefined;
    /** 设备Id */
    deviceId: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 设备类型Id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 保养计划Id（主键） */
    id: string | undefined;
    /** 周期（天） */
    intervalTime: number | undefined;
    /** 是否自动生成计划 */
    isAuto: number | undefined;
    /** 保养日期 */
    maintainDate: Date | undefined;
    /** 计划状态 */
    planStatus: number | undefined;
    /** 计划状态名称 */
    planStatusName: string | undefined;
    /** 上一次保养时间 */
    preMaintainTime: Date | undefined;
    /** 保养预警提示 */
    preWarningDays: number | undefined;
    /** 保养项目编码 */
    projectCode: string | undefined;
    /** 保养项目Id */
    projectId: string | undefined;
    /** 保养项目名称 */
    projectName: string | undefined;
}

export class MaintainPlanExportDTO implements IMaintainPlanExportDTO {
    /** 设备Id */
    deviceId!: string | undefined;
    /** 设备类型ID */
    deviceTypeId!: string | undefined;
    /** 是否选中导出 */
    exportSelected!: boolean | undefined;
    /** 关键词 */
    keyWord!: string | undefined;
    /** 选中记录id集合 */
    selectedRecords!: string[] | undefined;

    constructor(data?: IMaintainPlanExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.deviceTypeId = data["deviceTypeId"];
            this.exportSelected = data["exportSelected"];
            this.keyWord = data["keyWord"];
            if (data["selectedRecords"] && data["selectedRecords"].constructor === Array) {
                this.selectedRecords = [] as any;
                for (let item of data["selectedRecords"])
                    this.selectedRecords!.push(item);
            }
        }
    }

    static fromJS(data: any): MaintainPlanExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainPlanExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["deviceTypeId"] = this.deviceTypeId;
        data["exportSelected"] = this.exportSelected;
        data["keyWord"] = this.keyWord;
        if (this.selectedRecords && this.selectedRecords.constructor === Array) {
            data["selectedRecords"] = [];
            for (let item of this.selectedRecords)
                data["selectedRecords"].push(item);
        }
        return data; 
    }
}

export interface IMaintainPlanExportDTO {
    /** 设备Id */
    deviceId: string | undefined;
    /** 设备类型ID */
    deviceTypeId: string | undefined;
    /** 是否选中导出 */
    exportSelected: boolean | undefined;
    /** 关键词 */
    keyWord: string | undefined;
    /** 选中记录id集合 */
    selectedRecords: string[] | undefined;
}

export class MaintainPlanItemAddDTO implements IMaintainPlanItemAddDTO {
    /** 保养项Id */
    itemId!: string | undefined;

    constructor(data?: IMaintainPlanItemAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemId = data["itemId"];
        }
    }

    static fromJS(data: any): MaintainPlanItemAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainPlanItemAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        return data; 
    }
}

export interface IMaintainPlanItemAddDTO {
    /** 保养项Id */
    itemId: string | undefined;
}

/** 保养项目保养项 */
export class MaintainPlanItemVo implements IMaintainPlanItemVo {
    /** 保养计划保养项Id（主键） */
    id!: string | undefined;
    /** 编号 */
    itemCode!: string | undefined;
    /** 保养项Id */
    itemId!: string | undefined;
    /** 名称 */
    itemName!: string | undefined;
    /** 备注 */
    itemRemark!: string | undefined;
    /** 保养要求 */
    itemRequirement!: string | undefined;
    /** 保养计划Id */
    planId!: string | undefined;

    constructor(data?: IMaintainPlanItemVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.itemCode = data["itemCode"];
            this.itemId = data["itemId"];
            this.itemName = data["itemName"];
            this.itemRemark = data["itemRemark"];
            this.itemRequirement = data["itemRequirement"];
            this.planId = data["planId"];
        }
    }

    static fromJS(data: any): MaintainPlanItemVo {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainPlanItemVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemCode"] = this.itemCode;
        data["itemId"] = this.itemId;
        data["itemName"] = this.itemName;
        data["itemRemark"] = this.itemRemark;
        data["itemRequirement"] = this.itemRequirement;
        data["planId"] = this.planId;
        return data; 
    }
}

/** 保养项目保养项 */
export interface IMaintainPlanItemVo {
    /** 保养计划保养项Id（主键） */
    id: string | undefined;
    /** 编号 */
    itemCode: string | undefined;
    /** 保养项Id */
    itemId: string | undefined;
    /** 名称 */
    itemName: string | undefined;
    /** 备注 */
    itemRemark: string | undefined;
    /** 保养要求 */
    itemRequirement: string | undefined;
    /** 保养计划Id */
    planId: string | undefined;
}

export class MaintainPlanSearchByPlanStatusDTO implements IMaintainPlanSearchByPlanStatusDTO {
    /** 设备Id */
    deviceId!: string | undefined;
    /** 设备类型ID */
    deviceTypeId!: string | undefined;
    /** 是否高级筛选 */
    filterPlus!: boolean;
    /** 关键词 */
    keyWord!: string | undefined;
    /** 查询条件字典 */
    param!: any | undefined;
    /** 计划状态 */
    planStatus!: number | undefined;

    constructor(data?: IMaintainPlanSearchByPlanStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.deviceTypeId = data["deviceTypeId"];
            this.filterPlus = data["filterPlus"];
            this.keyWord = data["keyWord"];
            this.param = data["param"];
            this.planStatus = data["planStatus"];
        }
    }

    static fromJS(data: any): MaintainPlanSearchByPlanStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainPlanSearchByPlanStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["deviceTypeId"] = this.deviceTypeId;
        data["filterPlus"] = this.filterPlus;
        data["keyWord"] = this.keyWord;
        data["param"] = this.param;
        data["planStatus"] = this.planStatus;
        return data; 
    }
}

export interface IMaintainPlanSearchByPlanStatusDTO {
    /** 设备Id */
    deviceId: string | undefined;
    /** 设备类型ID */
    deviceTypeId: string | undefined;
    /** 是否高级筛选 */
    filterPlus: boolean;
    /** 关键词 */
    keyWord: string | undefined;
    /** 查询条件字典 */
    param: any | undefined;
    /** 计划状态 */
    planStatus: number | undefined;
}

export class MaintainPlanSearchDTO implements IMaintainPlanSearchDTO {
    /** 设备Id */
    deviceId!: string | undefined;
    /** 设备类型ID */
    deviceTypeId!: string | undefined;
    /** 是否高级筛选 */
    filterPlus!: boolean;
    /** 计划类型（0：人工创建；1：自动生成） */
    isAuto!: number | undefined;
    /** 关键词 */
    keyWord!: string | undefined;
    /** 查询条件字典 */
    param!: any | undefined;

    constructor(data?: IMaintainPlanSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.deviceTypeId = data["deviceTypeId"];
            this.filterPlus = data["filterPlus"];
            this.isAuto = data["isAuto"];
            this.keyWord = data["keyWord"];
            this.param = data["param"];
        }
    }

    static fromJS(data: any): MaintainPlanSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainPlanSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["deviceTypeId"] = this.deviceTypeId;
        data["filterPlus"] = this.filterPlus;
        data["isAuto"] = this.isAuto;
        data["keyWord"] = this.keyWord;
        data["param"] = this.param;
        return data; 
    }
}

export interface IMaintainPlanSearchDTO {
    /** 设备Id */
    deviceId: string | undefined;
    /** 设备类型ID */
    deviceTypeId: string | undefined;
    /** 是否高级筛选 */
    filterPlus: boolean;
    /** 计划类型（0：人工创建；1：自动生成） */
    isAuto: number | undefined;
    /** 关键词 */
    keyWord: string | undefined;
    /** 查询条件字典 */
    param: any | undefined;
}

export class MaintainPlanUpdateDTO implements IMaintainPlanUpdateDTO {
    /** 计划任务编码 */
    code!: string | undefined;
    /** 设备编码 */
    deviceCode!: string | undefined;
    /** 设备Id */
    deviceId!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 设备类型Id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 计划Id */
    id!: string | undefined;
    /** 周期（天） */
    intervalTime!: number | undefined;
    /** 是否自动生成计划 */
    isAuto!: number | undefined;
    /** 保养日期 */
    maintainDate!: Date | undefined;
    /** 保养项目保养项 */
    maintainItemList!: MaintainPlanItemAddDTO[] | undefined;
    /** 计划状态 */
    planStatus!: number | undefined;
    /** 上次保养日期 */
    preMaintainTime!: Date | undefined;
    /** 保养预警提示 */
    preWarningDays!: number | undefined;
    /** 保养项目编码 */
    projectCode!: string | undefined;
    /** 保养项目Id */
    projectId!: string | undefined;
    /** 保养项目名称 */
    projectName!: string | undefined;

    constructor(data?: IMaintainPlanUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.deviceCode = data["deviceCode"];
            this.deviceId = data["deviceId"];
            this.deviceName = data["deviceName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.id = data["id"];
            this.intervalTime = data["intervalTime"];
            this.isAuto = data["isAuto"];
            this.maintainDate = data["maintainDate"] ? new Date(data["maintainDate"].toString()) : <any>undefined;
            if (data["maintainItemList"] && data["maintainItemList"].constructor === Array) {
                this.maintainItemList = [] as any;
                for (let item of data["maintainItemList"])
                    this.maintainItemList!.push(MaintainPlanItemAddDTO.fromJS(item));
            }
            this.planStatus = data["planStatus"];
            this.preMaintainTime = data["preMaintainTime"] ? new Date(data["preMaintainTime"].toString()) : <any>undefined;
            this.preWarningDays = data["preWarningDays"];
            this.projectCode = data["projectCode"];
            this.projectId = data["projectId"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): MaintainPlanUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainPlanUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["deviceCode"] = this.deviceCode;
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["id"] = this.id;
        data["intervalTime"] = this.intervalTime;
        data["isAuto"] = this.isAuto;
        data["maintainDate"] = this.maintainDate ? this.maintainDate.toISOString() : <any>undefined;
        if (this.maintainItemList && this.maintainItemList.constructor === Array) {
            data["maintainItemList"] = [];
            for (let item of this.maintainItemList)
                data["maintainItemList"].push(item.toJSON());
        }
        data["planStatus"] = this.planStatus;
        data["preMaintainTime"] = this.preMaintainTime ? this.preMaintainTime.toISOString() : <any>undefined;
        data["preWarningDays"] = this.preWarningDays;
        data["projectCode"] = this.projectCode;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        return data; 
    }
}

export interface IMaintainPlanUpdateDTO {
    /** 计划任务编码 */
    code: string | undefined;
    /** 设备编码 */
    deviceCode: string | undefined;
    /** 设备Id */
    deviceId: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 设备类型Id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 计划Id */
    id: string | undefined;
    /** 周期（天） */
    intervalTime: number | undefined;
    /** 是否自动生成计划 */
    isAuto: number | undefined;
    /** 保养日期 */
    maintainDate: Date | undefined;
    /** 保养项目保养项 */
    maintainItemList: MaintainPlanItemAddDTO[] | undefined;
    /** 计划状态 */
    planStatus: number | undefined;
    /** 上次保养日期 */
    preMaintainTime: Date | undefined;
    /** 保养预警提示 */
    preWarningDays: number | undefined;
    /** 保养项目编码 */
    projectCode: string | undefined;
    /** 保养项目Id */
    projectId: string | undefined;
    /** 保养项目名称 */
    projectName: string | undefined;
}

/** 保养计划 */
export class MaintainPlanVo implements IMaintainPlanVo {
    /** 计划任务编码 */
    code!: string | undefined;
    /** 设备编码 */
    deviceCode!: string | undefined;
    /** 设备Id */
    deviceId!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 设备类型Id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 保养计划Id（主键） */
    id!: string | undefined;
    /** 周期（天） */
    intervalTime!: number | undefined;
    /** 是否自动生成计划 */
    isAuto!: number | undefined;
    /** 是否自动生成计划名称 */
    isAutoName!: string | undefined;
    /** 保养日期 */
    maintainDate!: Date | undefined;
    /** 保养计划保养项 */
    maintainPlanItemVoList!: MaintainPlanItemVo[] | undefined;
    /** 计划状态 */
    planStatus!: number | undefined;
    /** 计划状态名称 */
    planStatusName!: string | undefined;
    /** 上一次保养时间 */
    preMaintainTime!: Date | undefined;
    /** 保养预警提示 */
    preWarningDays!: number | undefined;
    /** 保养项目编码 */
    projectCode!: string | undefined;
    /** 保养项目Id */
    projectId!: string | undefined;
    /** 保养项目名称 */
    projectName!: string | undefined;

    constructor(data?: IMaintainPlanVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.deviceCode = data["deviceCode"];
            this.deviceId = data["deviceId"];
            this.deviceName = data["deviceName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.id = data["id"];
            this.intervalTime = data["intervalTime"];
            this.isAuto = data["isAuto"];
            this.isAutoName = data["isAutoName"];
            this.maintainDate = data["maintainDate"] ? new Date(data["maintainDate"].toString()) : <any>undefined;
            if (data["maintainPlanItemVoList"] && data["maintainPlanItemVoList"].constructor === Array) {
                this.maintainPlanItemVoList = [] as any;
                for (let item of data["maintainPlanItemVoList"])
                    this.maintainPlanItemVoList!.push(MaintainPlanItemVo.fromJS(item));
            }
            this.planStatus = data["planStatus"];
            this.planStatusName = data["planStatusName"];
            this.preMaintainTime = data["preMaintainTime"] ? new Date(data["preMaintainTime"].toString()) : <any>undefined;
            this.preWarningDays = data["preWarningDays"];
            this.projectCode = data["projectCode"];
            this.projectId = data["projectId"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): MaintainPlanVo {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainPlanVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["deviceCode"] = this.deviceCode;
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["id"] = this.id;
        data["intervalTime"] = this.intervalTime;
        data["isAuto"] = this.isAuto;
        data["isAutoName"] = this.isAutoName;
        data["maintainDate"] = this.maintainDate ? this.maintainDate.toISOString() : <any>undefined;
        if (this.maintainPlanItemVoList && this.maintainPlanItemVoList.constructor === Array) {
            data["maintainPlanItemVoList"] = [];
            for (let item of this.maintainPlanItemVoList)
                data["maintainPlanItemVoList"].push(item.toJSON());
        }
        data["planStatus"] = this.planStatus;
        data["planStatusName"] = this.planStatusName;
        data["preMaintainTime"] = this.preMaintainTime ? this.preMaintainTime.toISOString() : <any>undefined;
        data["preWarningDays"] = this.preWarningDays;
        data["projectCode"] = this.projectCode;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        return data; 
    }
}

/** 保养计划 */
export interface IMaintainPlanVo {
    /** 计划任务编码 */
    code: string | undefined;
    /** 设备编码 */
    deviceCode: string | undefined;
    /** 设备Id */
    deviceId: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 设备类型Id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 保养计划Id（主键） */
    id: string | undefined;
    /** 周期（天） */
    intervalTime: number | undefined;
    /** 是否自动生成计划 */
    isAuto: number | undefined;
    /** 是否自动生成计划名称 */
    isAutoName: string | undefined;
    /** 保养日期 */
    maintainDate: Date | undefined;
    /** 保养计划保养项 */
    maintainPlanItemVoList: MaintainPlanItemVo[] | undefined;
    /** 计划状态 */
    planStatus: number | undefined;
    /** 计划状态名称 */
    planStatusName: string | undefined;
    /** 上一次保养时间 */
    preMaintainTime: Date | undefined;
    /** 保养预警提示 */
    preWarningDays: number | undefined;
    /** 保养项目编码 */
    projectCode: string | undefined;
    /** 保养项目Id */
    projectId: string | undefined;
    /** 保养项目名称 */
    projectName: string | undefined;
}

export class MaintainProjectAddDTO implements IMaintainProjectAddDTO {
    /** 保养项目编码 */
    code!: string | undefined;
    /** 设备类型Id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 周期（天） */
    intervalTime!: number | undefined;
    /** 保养项目保养项 */
    maintainItemList!: MaintainProjectItemAddDTO[] | undefined;
    /** 保养项目名称 */
    name!: string | undefined;
    /** 保养预警提示 */
    preWarningDays!: number | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IMaintainProjectAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.intervalTime = data["intervalTime"];
            if (data["maintainItemList"] && data["maintainItemList"].constructor === Array) {
                this.maintainItemList = [] as any;
                for (let item of data["maintainItemList"])
                    this.maintainItemList!.push(MaintainProjectItemAddDTO.fromJS(item));
            }
            this.name = data["name"];
            this.preWarningDays = data["preWarningDays"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): MaintainProjectAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainProjectAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["intervalTime"] = this.intervalTime;
        if (this.maintainItemList && this.maintainItemList.constructor === Array) {
            data["maintainItemList"] = [];
            for (let item of this.maintainItemList)
                data["maintainItemList"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["preWarningDays"] = this.preWarningDays;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IMaintainProjectAddDTO {
    /** 保养项目编码 */
    code: string | undefined;
    /** 设备类型Id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 周期（天） */
    intervalTime: number | undefined;
    /** 保养项目保养项 */
    maintainItemList: MaintainProjectItemAddDTO[] | undefined;
    /** 保养项目名称 */
    name: string | undefined;
    /** 保养预警提示 */
    preWarningDays: number | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class MaintainProjectItemAddDTO implements IMaintainProjectItemAddDTO {
    /** 保养项Id */
    itemId!: string | undefined;
    /** 保养项目Id */
    projectId!: string | undefined;

    constructor(data?: IMaintainProjectItemAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemId = data["itemId"];
            this.projectId = data["projectId"];
        }
    }

    static fromJS(data: any): MaintainProjectItemAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainProjectItemAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["projectId"] = this.projectId;
        return data; 
    }
}

export interface IMaintainProjectItemAddDTO {
    /** 保养项Id */
    itemId: string | undefined;
    /** 保养项目Id */
    projectId: string | undefined;
}

/** 保养项目保养项 */
export class MaintainProjectItemVo implements IMaintainProjectItemVo {
    /** 保养项目保养项Id（主键） */
    id!: string | undefined;
    /** 编号 */
    itemCode!: string | undefined;
    /** 保养项Id */
    itemId!: string | undefined;
    /** 名称 */
    itemName!: string | undefined;
    /** 备注 */
    itemRemark!: string | undefined;
    /** 保养要求 */
    itemRequirement!: string | undefined;
    /** 保养项目Id */
    projectId!: string | undefined;

    constructor(data?: IMaintainProjectItemVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.itemCode = data["itemCode"];
            this.itemId = data["itemId"];
            this.itemName = data["itemName"];
            this.itemRemark = data["itemRemark"];
            this.itemRequirement = data["itemRequirement"];
            this.projectId = data["projectId"];
        }
    }

    static fromJS(data: any): MaintainProjectItemVo {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainProjectItemVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemCode"] = this.itemCode;
        data["itemId"] = this.itemId;
        data["itemName"] = this.itemName;
        data["itemRemark"] = this.itemRemark;
        data["itemRequirement"] = this.itemRequirement;
        data["projectId"] = this.projectId;
        return data; 
    }
}

/** 保养项目保养项 */
export interface IMaintainProjectItemVo {
    /** 保养项目保养项Id（主键） */
    id: string | undefined;
    /** 编号 */
    itemCode: string | undefined;
    /** 保养项Id */
    itemId: string | undefined;
    /** 名称 */
    itemName: string | undefined;
    /** 备注 */
    itemRemark: string | undefined;
    /** 保养要求 */
    itemRequirement: string | undefined;
    /** 保养项目Id */
    projectId: string | undefined;
}

export class MaintainProjectUpdateDTO implements IMaintainProjectUpdateDTO {
    /** 保养项目编码 */
    code!: string | undefined;
    /** 设备类型Id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 保养项目Id */
    id!: string | undefined;
    /** 周期（天） */
    intervalTime!: number | undefined;
    /** 保养项目保养项 */
    maintainItemList!: MaintainProjectItemAddDTO[] | undefined;
    /** 保养项目名称 */
    name!: string | undefined;
    /** 保养预警提示 */
    preWarningDays!: number | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IMaintainProjectUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.id = data["id"];
            this.intervalTime = data["intervalTime"];
            if (data["maintainItemList"] && data["maintainItemList"].constructor === Array) {
                this.maintainItemList = [] as any;
                for (let item of data["maintainItemList"])
                    this.maintainItemList!.push(MaintainProjectItemAddDTO.fromJS(item));
            }
            this.name = data["name"];
            this.preWarningDays = data["preWarningDays"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): MaintainProjectUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainProjectUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["id"] = this.id;
        data["intervalTime"] = this.intervalTime;
        if (this.maintainItemList && this.maintainItemList.constructor === Array) {
            data["maintainItemList"] = [];
            for (let item of this.maintainItemList)
                data["maintainItemList"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["preWarningDays"] = this.preWarningDays;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IMaintainProjectUpdateDTO {
    /** 保养项目编码 */
    code: string | undefined;
    /** 设备类型Id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 保养项目Id */
    id: string | undefined;
    /** 周期（天） */
    intervalTime: number | undefined;
    /** 保养项目保养项 */
    maintainItemList: MaintainProjectItemAddDTO[] | undefined;
    /** 保养项目名称 */
    name: string | undefined;
    /** 保养预警提示 */
    preWarningDays: number | undefined;
    /** 备注 */
    remark: string | undefined;
}

/** 保养项目 */
export class MaintainProjectVo implements IMaintainProjectVo {
    /** 保养项目编码 */
    code!: string | undefined;
    /** 设备类型Id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 保养项目Id（主键） */
    id!: string | undefined;
    /** 周期（天） */
    intervalTime!: number | undefined;
    /** 保养项目保养项 */
    maintainProjectItemVoList!: MaintainProjectItemVo[] | undefined;
    /** 保养项目名称 */
    name!: string | undefined;
    /** 保养预警提示 */
    preWarningDays!: number | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IMaintainProjectVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.id = data["id"];
            this.intervalTime = data["intervalTime"];
            if (data["maintainProjectItemVoList"] && data["maintainProjectItemVoList"].constructor === Array) {
                this.maintainProjectItemVoList = [] as any;
                for (let item of data["maintainProjectItemVoList"])
                    this.maintainProjectItemVoList!.push(MaintainProjectItemVo.fromJS(item));
            }
            this.name = data["name"];
            this.preWarningDays = data["preWarningDays"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): MaintainProjectVo {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainProjectVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["id"] = this.id;
        data["intervalTime"] = this.intervalTime;
        if (this.maintainProjectItemVoList && this.maintainProjectItemVoList.constructor === Array) {
            data["maintainProjectItemVoList"] = [];
            for (let item of this.maintainProjectItemVoList)
                data["maintainProjectItemVoList"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["preWarningDays"] = this.preWarningDays;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 保养项目 */
export interface IMaintainProjectVo {
    /** 保养项目编码 */
    code: string | undefined;
    /** 设备类型Id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 保养项目Id（主键） */
    id: string | undefined;
    /** 周期（天） */
    intervalTime: number | undefined;
    /** 保养项目保养项 */
    maintainProjectItemVoList: MaintainProjectItemVo[] | undefined;
    /** 保养项目名称 */
    name: string | undefined;
    /** 保养预警提示 */
    preWarningDays: number | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class MaintainRecordAddDTO implements IMaintainRecordAddDTO {
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 延期天数 */
    delayDays!: number | undefined;
    /** 延期原因 */
    delayReason!: string | undefined;
    /** 设备编号 */
    deviceCode!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 是否延期（0：未延期；1：已延期） */
    isDelay!: number | undefined;
    /** 保养记录保养项 */
    maintainRecordItemAddDTOList!: MaintainRecordItemAddDTO[] | undefined;
    /** 保养负责人Id */
    maintainUserId!: string | undefined;
    /** 保养负责人名称 */
    maintainUserName!: string | undefined;
    /** 保养计划编号 */
    planCode!: string | undefined;
    /** 保养计划Id */
    planId!: string | undefined;
    /** 保养项目名称 */
    projectName!: string | undefined;
    /** 记录单号 */
    recordCode!: string | undefined;
    repairRecordMaterialAddDTOList!: RepairRecordMaterialAddDTO[] | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;

    constructor(data?: IMaintainRecordAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.codeRuleId = data["codeRuleId"];
            this.delayDays = data["delayDays"];
            this.delayReason = data["delayReason"];
            this.deviceCode = data["deviceCode"];
            this.deviceName = data["deviceName"];
            this.deviceTypeName = data["deviceTypeName"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.isDelay = data["isDelay"];
            if (data["maintainRecordItemAddDTOList"] && data["maintainRecordItemAddDTOList"].constructor === Array) {
                this.maintainRecordItemAddDTOList = [] as any;
                for (let item of data["maintainRecordItemAddDTOList"])
                    this.maintainRecordItemAddDTOList!.push(MaintainRecordItemAddDTO.fromJS(item));
            }
            this.maintainUserId = data["maintainUserId"];
            this.maintainUserName = data["maintainUserName"];
            this.planCode = data["planCode"];
            this.planId = data["planId"];
            this.projectName = data["projectName"];
            this.recordCode = data["recordCode"];
            if (data["repairRecordMaterialAddDTOList"] && data["repairRecordMaterialAddDTOList"].constructor === Array) {
                this.repairRecordMaterialAddDTOList = [] as any;
                for (let item of data["repairRecordMaterialAddDTOList"])
                    this.repairRecordMaterialAddDTOList!.push(RepairRecordMaterialAddDTO.fromJS(item));
            }
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MaintainRecordAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainRecordAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeRuleId"] = this.codeRuleId;
        data["delayDays"] = this.delayDays;
        data["delayReason"] = this.delayReason;
        data["deviceCode"] = this.deviceCode;
        data["deviceName"] = this.deviceName;
        data["deviceTypeName"] = this.deviceTypeName;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["isDelay"] = this.isDelay;
        if (this.maintainRecordItemAddDTOList && this.maintainRecordItemAddDTOList.constructor === Array) {
            data["maintainRecordItemAddDTOList"] = [];
            for (let item of this.maintainRecordItemAddDTOList)
                data["maintainRecordItemAddDTOList"].push(item.toJSON());
        }
        data["maintainUserId"] = this.maintainUserId;
        data["maintainUserName"] = this.maintainUserName;
        data["planCode"] = this.planCode;
        data["planId"] = this.planId;
        data["projectName"] = this.projectName;
        data["recordCode"] = this.recordCode;
        if (this.repairRecordMaterialAddDTOList && this.repairRecordMaterialAddDTOList.constructor === Array) {
            data["repairRecordMaterialAddDTOList"] = [];
            for (let item of this.repairRecordMaterialAddDTOList)
                data["repairRecordMaterialAddDTOList"].push(item.toJSON());
        }
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IMaintainRecordAddDTO {
    /** 规则id */
    codeRuleId: string | undefined;
    /** 延期天数 */
    delayDays: number | undefined;
    /** 延期原因 */
    delayReason: string | undefined;
    /** 设备编号 */
    deviceCode: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 是否延期（0：未延期；1：已延期） */
    isDelay: number | undefined;
    /** 保养记录保养项 */
    maintainRecordItemAddDTOList: MaintainRecordItemAddDTO[] | undefined;
    /** 保养负责人Id */
    maintainUserId: string | undefined;
    /** 保养负责人名称 */
    maintainUserName: string | undefined;
    /** 保养计划编号 */
    planCode: string | undefined;
    /** 保养计划Id */
    planId: string | undefined;
    /** 保养项目名称 */
    projectName: string | undefined;
    /** 记录单号 */
    recordCode: string | undefined;
    repairRecordMaterialAddDTOList: RepairRecordMaterialAddDTO[] | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
}

export class MaintainRecordExportDTO implements IMaintainRecordExportDTO {
    /** 设备Id */
    deviceId!: string | undefined;
    /** 设备类型ID */
    deviceTypeId!: string | undefined;
    /** 是否选中导出 */
    exportSelected!: boolean | undefined;
    /** 关键词 */
    keyWord!: string | undefined;
    /** 保养记录状态 */
    recordStatus!: number | undefined;
    /** 选中记录id集合 */
    selectedRecords!: string[] | undefined;

    constructor(data?: IMaintainRecordExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.deviceTypeId = data["deviceTypeId"];
            this.exportSelected = data["exportSelected"];
            this.keyWord = data["keyWord"];
            this.recordStatus = data["recordStatus"];
            if (data["selectedRecords"] && data["selectedRecords"].constructor === Array) {
                this.selectedRecords = [] as any;
                for (let item of data["selectedRecords"])
                    this.selectedRecords!.push(item);
            }
        }
    }

    static fromJS(data: any): MaintainRecordExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainRecordExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["deviceTypeId"] = this.deviceTypeId;
        data["exportSelected"] = this.exportSelected;
        data["keyWord"] = this.keyWord;
        data["recordStatus"] = this.recordStatus;
        if (this.selectedRecords && this.selectedRecords.constructor === Array) {
            data["selectedRecords"] = [];
            for (let item of this.selectedRecords)
                data["selectedRecords"].push(item);
        }
        return data; 
    }
}

export interface IMaintainRecordExportDTO {
    /** 设备Id */
    deviceId: string | undefined;
    /** 设备类型ID */
    deviceTypeId: string | undefined;
    /** 是否选中导出 */
    exportSelected: boolean | undefined;
    /** 关键词 */
    keyWord: string | undefined;
    /** 保养记录状态 */
    recordStatus: number | undefined;
    /** 选中记录id集合 */
    selectedRecords: string[] | undefined;
}

export class MaintainRecordItemAddDTO implements IMaintainRecordItemAddDTO {
    /** 编码 */
    code!: string | undefined;
    /** 保养判定（0：否，1：是） */
    isExecute!: number | undefined;
    /** 保养项Id */
    itemId!: string | undefined;
    /** 名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 保养要求 */
    requirement!: string | undefined;

    constructor(data?: IMaintainRecordItemAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.isExecute = data["isExecute"];
            this.itemId = data["itemId"];
            this.name = data["name"];
            this.remark = data["remark"];
            this.requirement = data["requirement"];
        }
    }

    static fromJS(data: any): MaintainRecordItemAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainRecordItemAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["isExecute"] = this.isExecute;
        data["itemId"] = this.itemId;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["requirement"] = this.requirement;
        return data; 
    }
}

export interface IMaintainRecordItemAddDTO {
    /** 编码 */
    code: string | undefined;
    /** 保养判定（0：否，1：是） */
    isExecute: number | undefined;
    /** 保养项Id */
    itemId: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 保养要求 */
    requirement: string | undefined;
}

/** 保养项目保养项 */
export class MaintainRecordItemVo implements IMaintainRecordItemVo {
    /** 编码 */
    code!: string | undefined;
    /** 保养记录保养项Id（主键） */
    id!: string | undefined;
    /** 保养判定（0：否，1：是） */
    isExecute!: number | undefined;
    /** 保养判定（0：否，1：是） */
    isExecuteName!: string | undefined;
    /** 保养项Id */
    itemId!: string | undefined;
    /** 名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 保养要求 */
    requirement!: string | undefined;

    constructor(data?: IMaintainRecordItemVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.isExecute = data["isExecute"];
            this.isExecuteName = data["isExecuteName"];
            this.itemId = data["itemId"];
            this.name = data["name"];
            this.remark = data["remark"];
            this.requirement = data["requirement"];
        }
    }

    static fromJS(data: any): MaintainRecordItemVo {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainRecordItemVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["isExecute"] = this.isExecute;
        data["isExecuteName"] = this.isExecuteName;
        data["itemId"] = this.itemId;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["requirement"] = this.requirement;
        return data; 
    }
}

/** 保养项目保养项 */
export interface IMaintainRecordItemVo {
    /** 编码 */
    code: string | undefined;
    /** 保养记录保养项Id（主键） */
    id: string | undefined;
    /** 保养判定（0：否，1：是） */
    isExecute: number | undefined;
    /** 保养判定（0：否，1：是） */
    isExecuteName: string | undefined;
    /** 保养项Id */
    itemId: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 保养要求 */
    requirement: string | undefined;
}

export class MaintainRecordSearchDTO implements IMaintainRecordSearchDTO {
    /** 设备ID */
    deviceId!: string | undefined;
    /** 设备类型ID */
    deviceTypeId!: string | undefined;
    /** 是否高级筛选 */
    filterPlus!: boolean;
    /** 关键词 */
    keyWord!: string | undefined;
    /** 查询条件字典 */
    param!: any | undefined;
    /** 保养记录状态 */
    recordStatus!: number | undefined;

    constructor(data?: IMaintainRecordSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.deviceTypeId = data["deviceTypeId"];
            this.filterPlus = data["filterPlus"];
            this.keyWord = data["keyWord"];
            this.param = data["param"];
            this.recordStatus = data["recordStatus"];
        }
    }

    static fromJS(data: any): MaintainRecordSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainRecordSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["deviceTypeId"] = this.deviceTypeId;
        data["filterPlus"] = this.filterPlus;
        data["keyWord"] = this.keyWord;
        data["param"] = this.param;
        data["recordStatus"] = this.recordStatus;
        return data; 
    }
}

export interface IMaintainRecordSearchDTO {
    /** 设备ID */
    deviceId: string | undefined;
    /** 设备类型ID */
    deviceTypeId: string | undefined;
    /** 是否高级筛选 */
    filterPlus: boolean;
    /** 关键词 */
    keyWord: string | undefined;
    /** 查询条件字典 */
    param: any | undefined;
    /** 保养记录状态 */
    recordStatus: number | undefined;
}

/** 保养计划待确认 */
export class MaintainRecordToConfirmVO implements IMaintainRecordToConfirmVO {
    /** 延期天数 */
    delayDays!: number | undefined;
    /** 延期原因 */
    delayReason!: string | undefined;
    /** 设备编码 */
    deviceCode!: string | undefined;
    /** 设备Id */
    deviceId!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 设备类型Id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 保养记录ID */
    id!: string | undefined;
    /** 是否延期（0：未延期；1：已延期） */
    isDelay!: number | undefined;
    /** 是否延期（0：未延期；1：已延期） */
    isDelayName!: string | undefined;
    /** 保养负责人Id */
    maintainUserId!: string | undefined;
    /** 保养负责人名称 */
    maintainUserName!: string | undefined;
    /** 保养计划编码 */
    planCode!: string | undefined;
    /** 保养计划Id */
    planId!: string | undefined;
    /** 保养项目Id */
    projectId!: string | undefined;
    /** 保养项目名称 */
    projectName!: string | undefined;
    /** 保养记录单号 */
    recordCode!: string | undefined;
    /** 保养记录状态（1：待确认；2：已确认） */
    recordStatus!: number | undefined;
    /** 保养记录状态（1：待确认；2：已确认） */
    recordStatusName!: string | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;

    constructor(data?: IMaintainRecordToConfirmVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.delayDays = data["delayDays"];
            this.delayReason = data["delayReason"];
            this.deviceCode = data["deviceCode"];
            this.deviceId = data["deviceId"];
            this.deviceName = data["deviceName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.isDelay = data["isDelay"];
            this.isDelayName = data["isDelayName"];
            this.maintainUserId = data["maintainUserId"];
            this.maintainUserName = data["maintainUserName"];
            this.planCode = data["planCode"];
            this.planId = data["planId"];
            this.projectId = data["projectId"];
            this.projectName = data["projectName"];
            this.recordCode = data["recordCode"];
            this.recordStatus = data["recordStatus"];
            this.recordStatusName = data["recordStatusName"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MaintainRecordToConfirmVO {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainRecordToConfirmVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delayDays"] = this.delayDays;
        data["delayReason"] = this.delayReason;
        data["deviceCode"] = this.deviceCode;
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["isDelay"] = this.isDelay;
        data["isDelayName"] = this.isDelayName;
        data["maintainUserId"] = this.maintainUserId;
        data["maintainUserName"] = this.maintainUserName;
        data["planCode"] = this.planCode;
        data["planId"] = this.planId;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["recordCode"] = this.recordCode;
        data["recordStatus"] = this.recordStatus;
        data["recordStatusName"] = this.recordStatusName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        return data; 
    }
}

/** 保养计划待确认 */
export interface IMaintainRecordToConfirmVO {
    /** 延期天数 */
    delayDays: number | undefined;
    /** 延期原因 */
    delayReason: string | undefined;
    /** 设备编码 */
    deviceCode: string | undefined;
    /** 设备Id */
    deviceId: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 设备类型Id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 保养记录ID */
    id: string | undefined;
    /** 是否延期（0：未延期；1：已延期） */
    isDelay: number | undefined;
    /** 是否延期（0：未延期；1：已延期） */
    isDelayName: string | undefined;
    /** 保养负责人Id */
    maintainUserId: string | undefined;
    /** 保养负责人名称 */
    maintainUserName: string | undefined;
    /** 保养计划编码 */
    planCode: string | undefined;
    /** 保养计划Id */
    planId: string | undefined;
    /** 保养项目Id */
    projectId: string | undefined;
    /** 保养项目名称 */
    projectName: string | undefined;
    /** 保养记录单号 */
    recordCode: string | undefined;
    /** 保养记录状态（1：待确认；2：已确认） */
    recordStatus: number | undefined;
    /** 保养记录状态（1：待确认；2：已确认） */
    recordStatusName: string | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
}

export class MaintainRecordUpdateDTO implements IMaintainRecordUpdateDTO {
    /** 延期天数 */
    delayDays!: number | undefined;
    /** 延期原因 */
    delayReason!: string | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 保养记录Id */
    id!: string | undefined;
    /** 是否延期（0：未延期；1：已延期） */
    isDelay!: number | undefined;
    /** 保养记录保养项 */
    maintainRecordItemAddDTOList!: MaintainRecordItemAddDTO[] | undefined;
    /** 保养负责人Id */
    maintainUserId!: string | undefined;
    /** 保养负责人名称 */
    maintainUserName!: string | undefined;
    /** 保养计划Id */
    planId!: string | undefined;
    repairRecordMaterialAddDTOList!: RepairRecordMaterialAddDTO[] | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;

    constructor(data?: IMaintainRecordUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.delayDays = data["delayDays"];
            this.delayReason = data["delayReason"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.isDelay = data["isDelay"];
            if (data["maintainRecordItemAddDTOList"] && data["maintainRecordItemAddDTOList"].constructor === Array) {
                this.maintainRecordItemAddDTOList = [] as any;
                for (let item of data["maintainRecordItemAddDTOList"])
                    this.maintainRecordItemAddDTOList!.push(MaintainRecordItemAddDTO.fromJS(item));
            }
            this.maintainUserId = data["maintainUserId"];
            this.maintainUserName = data["maintainUserName"];
            this.planId = data["planId"];
            if (data["repairRecordMaterialAddDTOList"] && data["repairRecordMaterialAddDTOList"].constructor === Array) {
                this.repairRecordMaterialAddDTOList = [] as any;
                for (let item of data["repairRecordMaterialAddDTOList"])
                    this.repairRecordMaterialAddDTOList!.push(RepairRecordMaterialAddDTO.fromJS(item));
            }
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MaintainRecordUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainRecordUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delayDays"] = this.delayDays;
        data["delayReason"] = this.delayReason;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["isDelay"] = this.isDelay;
        if (this.maintainRecordItemAddDTOList && this.maintainRecordItemAddDTOList.constructor === Array) {
            data["maintainRecordItemAddDTOList"] = [];
            for (let item of this.maintainRecordItemAddDTOList)
                data["maintainRecordItemAddDTOList"].push(item.toJSON());
        }
        data["maintainUserId"] = this.maintainUserId;
        data["maintainUserName"] = this.maintainUserName;
        data["planId"] = this.planId;
        if (this.repairRecordMaterialAddDTOList && this.repairRecordMaterialAddDTOList.constructor === Array) {
            data["repairRecordMaterialAddDTOList"] = [];
            for (let item of this.repairRecordMaterialAddDTOList)
                data["repairRecordMaterialAddDTOList"].push(item.toJSON());
        }
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IMaintainRecordUpdateDTO {
    /** 延期天数 */
    delayDays: number | undefined;
    /** 延期原因 */
    delayReason: string | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 保养记录Id */
    id: string | undefined;
    /** 是否延期（0：未延期；1：已延期） */
    isDelay: number | undefined;
    /** 保养记录保养项 */
    maintainRecordItemAddDTOList: MaintainRecordItemAddDTO[] | undefined;
    /** 保养负责人Id */
    maintainUserId: string | undefined;
    /** 保养负责人名称 */
    maintainUserName: string | undefined;
    /** 保养计划Id */
    planId: string | undefined;
    repairRecordMaterialAddDTOList: RepairRecordMaterialAddDTO[] | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
}

/** 保养计划 */
export class MaintainRecordVo implements IMaintainRecordVo {
    /** 延期天数 */
    delayDays!: number | undefined;
    /** 延期原因 */
    delayReason!: string | undefined;
    /** 设备编码 */
    deviceCode!: string | undefined;
    /** 设备Id */
    deviceId!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 设备类型Id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 保养记录ID */
    id!: string | undefined;
    /** 是否延期（0：未延期；1：已延期） */
    isDelay!: number | undefined;
    /** 是否延期（0：未延期；1：已延期） */
    isDelayName!: string | undefined;
    /** 保养记录保养项 */
    maintainRecordItemVoList!: MaintainRecordItemVo[] | undefined;
    /** 保养负责人Id */
    maintainUserId!: string | undefined;
    /** 保养负责人名称 */
    maintainUserName!: string | undefined;
    /** 保养计划编码 */
    planCode!: string | undefined;
    /** 保养计划Id */
    planId!: string | undefined;
    /** 保养项目Id */
    projectId!: string | undefined;
    /** 保养项目名称 */
    projectName!: string | undefined;
    /** 保养记录单号 */
    recordCode!: string | undefined;
    /** 保养记录状态（1：待确认；2：已确认） */
    recordStatus!: number | undefined;
    /** 保养记录状态（1：待确认；2：已确认） */
    recordStatusName!: string | undefined;
    /** 保养记录备品备件 */
    repairRecordMaterialVOList!: RepairRecordMaterialVO[] | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;

    constructor(data?: IMaintainRecordVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.delayDays = data["delayDays"];
            this.delayReason = data["delayReason"];
            this.deviceCode = data["deviceCode"];
            this.deviceId = data["deviceId"];
            this.deviceName = data["deviceName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.isDelay = data["isDelay"];
            this.isDelayName = data["isDelayName"];
            if (data["maintainRecordItemVoList"] && data["maintainRecordItemVoList"].constructor === Array) {
                this.maintainRecordItemVoList = [] as any;
                for (let item of data["maintainRecordItemVoList"])
                    this.maintainRecordItemVoList!.push(MaintainRecordItemVo.fromJS(item));
            }
            this.maintainUserId = data["maintainUserId"];
            this.maintainUserName = data["maintainUserName"];
            this.planCode = data["planCode"];
            this.planId = data["planId"];
            this.projectId = data["projectId"];
            this.projectName = data["projectName"];
            this.recordCode = data["recordCode"];
            this.recordStatus = data["recordStatus"];
            this.recordStatusName = data["recordStatusName"];
            if (data["repairRecordMaterialVOList"] && data["repairRecordMaterialVOList"].constructor === Array) {
                this.repairRecordMaterialVOList = [] as any;
                for (let item of data["repairRecordMaterialVOList"])
                    this.repairRecordMaterialVOList!.push(RepairRecordMaterialVO.fromJS(item));
            }
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MaintainRecordVo {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainRecordVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delayDays"] = this.delayDays;
        data["delayReason"] = this.delayReason;
        data["deviceCode"] = this.deviceCode;
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["isDelay"] = this.isDelay;
        data["isDelayName"] = this.isDelayName;
        if (this.maintainRecordItemVoList && this.maintainRecordItemVoList.constructor === Array) {
            data["maintainRecordItemVoList"] = [];
            for (let item of this.maintainRecordItemVoList)
                data["maintainRecordItemVoList"].push(item.toJSON());
        }
        data["maintainUserId"] = this.maintainUserId;
        data["maintainUserName"] = this.maintainUserName;
        data["planCode"] = this.planCode;
        data["planId"] = this.planId;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["recordCode"] = this.recordCode;
        data["recordStatus"] = this.recordStatus;
        data["recordStatusName"] = this.recordStatusName;
        if (this.repairRecordMaterialVOList && this.repairRecordMaterialVOList.constructor === Array) {
            data["repairRecordMaterialVOList"] = [];
            for (let item of this.repairRecordMaterialVOList)
                data["repairRecordMaterialVOList"].push(item.toJSON());
        }
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        return data; 
    }
}

/** 保养计划 */
export interface IMaintainRecordVo {
    /** 延期天数 */
    delayDays: number | undefined;
    /** 延期原因 */
    delayReason: string | undefined;
    /** 设备编码 */
    deviceCode: string | undefined;
    /** 设备Id */
    deviceId: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 设备类型Id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 保养记录ID */
    id: string | undefined;
    /** 是否延期（0：未延期；1：已延期） */
    isDelay: number | undefined;
    /** 是否延期（0：未延期；1：已延期） */
    isDelayName: string | undefined;
    /** 保养记录保养项 */
    maintainRecordItemVoList: MaintainRecordItemVo[] | undefined;
    /** 保养负责人Id */
    maintainUserId: string | undefined;
    /** 保养负责人名称 */
    maintainUserName: string | undefined;
    /** 保养计划编码 */
    planCode: string | undefined;
    /** 保养计划Id */
    planId: string | undefined;
    /** 保养项目Id */
    projectId: string | undefined;
    /** 保养项目名称 */
    projectName: string | undefined;
    /** 保养记录单号 */
    recordCode: string | undefined;
    /** 保养记录状态（1：待确认；2：已确认） */
    recordStatus: number | undefined;
    /** 保养记录状态（1：待确认；2：已确认） */
    recordStatusName: string | undefined;
    /** 保养记录备品备件 */
    repairRecordMaterialVOList: RepairRecordMaterialVO[] | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
}

/** 保养项目保养项 */
export class MaintainStatisticsVo implements IMaintainStatisticsVo {
    /** 超期数量 */
    delayNum!: number | undefined;
    /** 待确认数量 */
    recordNum!: number | undefined;
    /** 今日保养数量 */
    todayNum!: number | undefined;
    /** 预警保养数量 */
    warningNum!: number | undefined;

    constructor(data?: IMaintainStatisticsVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.delayNum = data["delayNum"];
            this.recordNum = data["recordNum"];
            this.todayNum = data["todayNum"];
            this.warningNum = data["warningNum"];
        }
    }

    static fromJS(data: any): MaintainStatisticsVo {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainStatisticsVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delayNum"] = this.delayNum;
        data["recordNum"] = this.recordNum;
        data["todayNum"] = this.todayNum;
        data["warningNum"] = this.warningNum;
        return data; 
    }
}

/** 保养项目保养项 */
export interface IMaintainStatisticsVo {
    /** 超期数量 */
    delayNum: number | undefined;
    /** 待确认数量 */
    recordNum: number | undefined;
    /** 今日保养数量 */
    todayNum: number | undefined;
    /** 预警保养数量 */
    warningNum: number | undefined;
}

export class MalfunctionTypeAddDTO implements IMalfunctionTypeAddDTO {
    /** 故障编码 唯一 */
    code!: string | undefined;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 故障类型 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IMalfunctionTypeAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): MalfunctionTypeAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MalfunctionTypeAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IMalfunctionTypeAddDTO {
    /** 故障编码 唯一 */
    code: string | undefined;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 故障类型 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class MalfunctionTypeDetailVo implements IMalfunctionTypeDetailVo {
    /** 故障编码 唯一 */
    code!: string | undefined;
    /** 故障类型Id */
    id!: string | undefined;
    /** 故障类型 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IMalfunctionTypeDetailVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): MalfunctionTypeDetailVo {
        data = typeof data === 'object' ? data : {};
        let result = new MalfunctionTypeDetailVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IMalfunctionTypeDetailVo {
    /** 故障编码 唯一 */
    code: string | undefined;
    /** 故障类型Id */
    id: string | undefined;
    /** 故障类型 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class MalfunctionTypeExportDTO implements IMalfunctionTypeExportDTO {
    /** 是否选中导出 */
    exportSelected!: boolean | undefined;
    /** 选中故障类型的id集合 */
    selectedRecords!: string[] | undefined;

    constructor(data?: IMalfunctionTypeExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.exportSelected = data["exportSelected"];
            if (data["selectedRecords"] && data["selectedRecords"].constructor === Array) {
                this.selectedRecords = [] as any;
                for (let item of data["selectedRecords"])
                    this.selectedRecords!.push(item);
            }
        }
    }

    static fromJS(data: any): MalfunctionTypeExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MalfunctionTypeExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exportSelected"] = this.exportSelected;
        if (this.selectedRecords && this.selectedRecords.constructor === Array) {
            data["selectedRecords"] = [];
            for (let item of this.selectedRecords)
                data["selectedRecords"].push(item);
        }
        return data; 
    }
}

export interface IMalfunctionTypeExportDTO {
    /** 是否选中导出 */
    exportSelected: boolean | undefined;
    /** 选中故障类型的id集合 */
    selectedRecords: string[] | undefined;
}

export class MalfunctionTypeRecordVo implements IMalfunctionTypeRecordVo {
    /** 故障编码 唯一 */
    code!: string | undefined;
    /** 故障类型Id */
    id!: string | undefined;
    /** 故障类型 */
    name!: string | undefined;

    constructor(data?: IMalfunctionTypeRecordVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): MalfunctionTypeRecordVo {
        data = typeof data === 'object' ? data : {};
        let result = new MalfunctionTypeRecordVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IMalfunctionTypeRecordVo {
    /** 故障编码 唯一 */
    code: string | undefined;
    /** 故障类型Id */
    id: string | undefined;
    /** 故障类型 */
    name: string | undefined;
}

export class MalfunctionTypeUpdateDTO implements IMalfunctionTypeUpdateDTO {
    /** 故障类型Id */
    id!: string | undefined;
    /** 故障类型 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IMalfunctionTypeUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): MalfunctionTypeUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MalfunctionTypeUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IMalfunctionTypeUpdateDTO {
    /** 故障类型Id */
    id: string | undefined;
    /** 故障类型 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class MaterialVo implements IMaterialVo {
    /** id */
    id!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 数量 */
    number!: number | undefined;
    /** 维修记录id */
    recordId!: string | undefined;

    constructor(data?: IMaterialVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.materialName = data["materialName"];
            this.number = data["number"];
            this.recordId = data["recordId"];
        }
    }

    static fromJS(data: any): MaterialVo {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialName"] = this.materialName;
        data["number"] = this.number;
        data["recordId"] = this.recordId;
        return data; 
    }
}

export interface IMaterialVo {
    /** id */
    id: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 数量 */
    number: number | undefined;
    /** 维修记录id */
    recordId: string | undefined;
}

/** 分页查询点检项目信息 */
export class PageCheckProjectsDTO implements IPageCheckProjectsDTO {
    /** 关键词 */
    keyWord!: string | undefined;
    /** 分页信息 */
    query!: Query | undefined;

    constructor(data?: IPageCheckProjectsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.keyWord = data["keyWord"];
            this.query = data["query"] ? Query.fromJS(data["query"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PageCheckProjectsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PageCheckProjectsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyWord"] = this.keyWord;
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        return data; 
    }
}

/** 分页查询点检项目信息 */
export interface IPageCheckProjectsDTO {
    /** 关键词 */
    keyWord: string | undefined;
    /** 分页信息 */
    query: Query | undefined;
}

/** 查询条件 */
export class Query implements IQuery {
    /** 当前页 */
    current!: number | undefined;
    /** 每页的数量 */
    size!: number | undefined;

    constructor(data?: IQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.size = data["size"];
        }
    }

    static fromJS(data: any): Query {
        data = typeof data === 'object' ? data : {};
        let result = new Query();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["size"] = this.size;
        return data; 
    }
}

/** 查询条件 */
export interface IQuery {
    /** 当前页 */
    current: number | undefined;
    /** 每页的数量 */
    size: number | undefined;
}

export class RepairApplyAddDTO implements IRepairApplyAddDTO {
    /** 维修申请单号 */
    applyCode!: string | undefined;
    /** 维修申请人id */
    applyUserId!: string | undefined;
    /** 维修申请人名称 */
    applyUserName!: string | undefined;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 职权域名称 */
    deptName!: string | undefined;
    /** 故障描述 */
    description!: string | undefined;
    /** 设备编码 */
    deviceCode!: string | undefined;
    /** 设备id */
    deviceId!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 设备类型id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 维修申请关联的文件 */
    fileAddDTOList!: RepairApplyFileAddDTO[] | undefined;
    /** 影响生产：是 1   否   2 */
    isAffect!: number | undefined;
    /** 影响生产名称 */
    isAffectName!: string | undefined;
    /** 故障类型编码 */
    malfunctionCode!: string | undefined;
    /** 故障类型id */
    malfunctionId!: string | undefined;
    /** 故障类型 */
    malfunctionName!: string | undefined;
    /** 故障发生时间 */
    malfunctionTime!: Date | undefined;
    /** 维修负责人id */
    repairUserId!: string | undefined;
    /** 维修负责人名称 */
    repairUserName!: string | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgency!: number | undefined;
    /** 紧急度名称 */
    urgencyName!: string | undefined;

    constructor(data?: IRepairApplyAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applyCode = data["applyCode"];
            this.applyUserId = data["applyUserId"];
            this.applyUserName = data["applyUserName"];
            this.codeRuleId = data["codeRuleId"];
            this.deptName = data["deptName"];
            this.description = data["description"];
            this.deviceCode = data["deviceCode"];
            this.deviceId = data["deviceId"];
            this.deviceName = data["deviceName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            if (data["fileAddDTOList"] && data["fileAddDTOList"].constructor === Array) {
                this.fileAddDTOList = [] as any;
                for (let item of data["fileAddDTOList"])
                    this.fileAddDTOList!.push(RepairApplyFileAddDTO.fromJS(item));
            }
            this.isAffect = data["isAffect"];
            this.isAffectName = data["isAffectName"];
            this.malfunctionCode = data["malfunctionCode"];
            this.malfunctionId = data["malfunctionId"];
            this.malfunctionName = data["malfunctionName"];
            this.malfunctionTime = data["malfunctionTime"] ? new Date(data["malfunctionTime"].toString()) : <any>undefined;
            this.repairUserId = data["repairUserId"];
            this.repairUserName = data["repairUserName"];
            this.urgency = data["urgency"];
            this.urgencyName = data["urgencyName"];
        }
    }

    static fromJS(data: any): RepairApplyAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RepairApplyAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applyCode"] = this.applyCode;
        data["applyUserId"] = this.applyUserId;
        data["applyUserName"] = this.applyUserName;
        data["codeRuleId"] = this.codeRuleId;
        data["deptName"] = this.deptName;
        data["description"] = this.description;
        data["deviceCode"] = this.deviceCode;
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        if (this.fileAddDTOList && this.fileAddDTOList.constructor === Array) {
            data["fileAddDTOList"] = [];
            for (let item of this.fileAddDTOList)
                data["fileAddDTOList"].push(item.toJSON());
        }
        data["isAffect"] = this.isAffect;
        data["isAffectName"] = this.isAffectName;
        data["malfunctionCode"] = this.malfunctionCode;
        data["malfunctionId"] = this.malfunctionId;
        data["malfunctionName"] = this.malfunctionName;
        data["malfunctionTime"] = this.malfunctionTime ? this.malfunctionTime.toISOString() : <any>undefined;
        data["repairUserId"] = this.repairUserId;
        data["repairUserName"] = this.repairUserName;
        data["urgency"] = this.urgency;
        data["urgencyName"] = this.urgencyName;
        return data; 
    }
}

export interface IRepairApplyAddDTO {
    /** 维修申请单号 */
    applyCode: string | undefined;
    /** 维修申请人id */
    applyUserId: string | undefined;
    /** 维修申请人名称 */
    applyUserName: string | undefined;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 职权域名称 */
    deptName: string | undefined;
    /** 故障描述 */
    description: string | undefined;
    /** 设备编码 */
    deviceCode: string | undefined;
    /** 设备id */
    deviceId: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 设备类型id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 维修申请关联的文件 */
    fileAddDTOList: RepairApplyFileAddDTO[] | undefined;
    /** 影响生产：是 1   否   2 */
    isAffect: number | undefined;
    /** 影响生产名称 */
    isAffectName: string | undefined;
    /** 故障类型编码 */
    malfunctionCode: string | undefined;
    /** 故障类型id */
    malfunctionId: string | undefined;
    /** 故障类型 */
    malfunctionName: string | undefined;
    /** 故障发生时间 */
    malfunctionTime: Date | undefined;
    /** 维修负责人id */
    repairUserId: string | undefined;
    /** 维修负责人名称 */
    repairUserName: string | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgency: number | undefined;
    /** 紧急度名称 */
    urgencyName: string | undefined;
}

export class RepairApplyConditionDTO implements IRepairApplyConditionDTO {
    /** 设备类型id */
    deviceId!: string | undefined;
    /** 申请单状态： 待执行 1  执行中 2 */
    statusList!: number[] | undefined;

    constructor(data?: IRepairApplyConditionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
            if (data["statusList"] && data["statusList"].constructor === Array) {
                this.statusList = [] as any;
                for (let item of data["statusList"])
                    this.statusList!.push(item);
            }
        }
    }

    static fromJS(data: any): RepairApplyConditionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RepairApplyConditionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        if (this.statusList && this.statusList.constructor === Array) {
            data["statusList"] = [];
            for (let item of this.statusList)
                data["statusList"].push(item);
        }
        return data; 
    }
}

export interface IRepairApplyConditionDTO {
    /** 设备类型id */
    deviceId: string | undefined;
    /** 申请单状态： 待执行 1  执行中 2 */
    statusList: number[] | undefined;
}

export class RepairApplyDetailVo implements IRepairApplyDetailVo {
    /** 申请单号 */
    applyCode!: string | undefined;
    /** 申请单状态： 待执行 1  执行中 2  待确认 3  已确认 4 */
    applyStatus!: number | undefined;
    /** 申请单状态： 待执行 1  执行中 2  待确认 3  已确认 4 */
    applyStatusStr!: string | undefined;
    /** 申请时间 */
    applyTime!: Date | undefined;
    /** 维修申请人id */
    applyUserId!: string | undefined;
    /** 维修申请人名称 */
    applyUserName!: string | undefined;
    /** 故障描述 */
    description!: string | undefined;
    /** 设备编码 */
    deviceCode!: string | undefined;
    /** 设备id */
    deviceId!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 设备类型id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 维修申请关联的文件 */
    fileAddDTOList!: RepairApplyFileAddDTO[] | undefined;
    /** id */
    id!: string | undefined;
    /** 影响生产：是 1   否   2 */
    isAffect!: number | undefined;
    /** 影响生产：是 1   否   2 */
    isAffectStr!: string | undefined;
    /** 故障类型编码 */
    malfunctionCode!: string | undefined;
    /** 故障类型id */
    malfunctionId!: string | undefined;
    /** 故障类型 */
    malfunctionName!: string | undefined;
    /** 故障发生时间 */
    malfunctionTime!: Date | undefined;
    /** 维修负责人id */
    repairUserId!: string | undefined;
    /** 维修负责人名称 */
    repairUserName!: string | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgency!: number | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgencyStr!: string | undefined;

    constructor(data?: IRepairApplyDetailVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applyCode = data["applyCode"];
            this.applyStatus = data["applyStatus"];
            this.applyStatusStr = data["applyStatusStr"];
            this.applyTime = data["applyTime"] ? new Date(data["applyTime"].toString()) : <any>undefined;
            this.applyUserId = data["applyUserId"];
            this.applyUserName = data["applyUserName"];
            this.description = data["description"];
            this.deviceCode = data["deviceCode"];
            this.deviceId = data["deviceId"];
            this.deviceName = data["deviceName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            if (data["fileAddDTOList"] && data["fileAddDTOList"].constructor === Array) {
                this.fileAddDTOList = [] as any;
                for (let item of data["fileAddDTOList"])
                    this.fileAddDTOList!.push(RepairApplyFileAddDTO.fromJS(item));
            }
            this.id = data["id"];
            this.isAffect = data["isAffect"];
            this.isAffectStr = data["isAffectStr"];
            this.malfunctionCode = data["malfunctionCode"];
            this.malfunctionId = data["malfunctionId"];
            this.malfunctionName = data["malfunctionName"];
            this.malfunctionTime = data["malfunctionTime"] ? new Date(data["malfunctionTime"].toString()) : <any>undefined;
            this.repairUserId = data["repairUserId"];
            this.repairUserName = data["repairUserName"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.urgency = data["urgency"];
            this.urgencyStr = data["urgencyStr"];
        }
    }

    static fromJS(data: any): RepairApplyDetailVo {
        data = typeof data === 'object' ? data : {};
        let result = new RepairApplyDetailVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applyCode"] = this.applyCode;
        data["applyStatus"] = this.applyStatus;
        data["applyStatusStr"] = this.applyStatusStr;
        data["applyTime"] = this.applyTime ? this.applyTime.toISOString() : <any>undefined;
        data["applyUserId"] = this.applyUserId;
        data["applyUserName"] = this.applyUserName;
        data["description"] = this.description;
        data["deviceCode"] = this.deviceCode;
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        if (this.fileAddDTOList && this.fileAddDTOList.constructor === Array) {
            data["fileAddDTOList"] = [];
            for (let item of this.fileAddDTOList)
                data["fileAddDTOList"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["isAffect"] = this.isAffect;
        data["isAffectStr"] = this.isAffectStr;
        data["malfunctionCode"] = this.malfunctionCode;
        data["malfunctionId"] = this.malfunctionId;
        data["malfunctionName"] = this.malfunctionName;
        data["malfunctionTime"] = this.malfunctionTime ? this.malfunctionTime.toISOString() : <any>undefined;
        data["repairUserId"] = this.repairUserId;
        data["repairUserName"] = this.repairUserName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["urgency"] = this.urgency;
        data["urgencyStr"] = this.urgencyStr;
        return data; 
    }
}

export interface IRepairApplyDetailVo {
    /** 申请单号 */
    applyCode: string | undefined;
    /** 申请单状态： 待执行 1  执行中 2  待确认 3  已确认 4 */
    applyStatus: number | undefined;
    /** 申请单状态： 待执行 1  执行中 2  待确认 3  已确认 4 */
    applyStatusStr: string | undefined;
    /** 申请时间 */
    applyTime: Date | undefined;
    /** 维修申请人id */
    applyUserId: string | undefined;
    /** 维修申请人名称 */
    applyUserName: string | undefined;
    /** 故障描述 */
    description: string | undefined;
    /** 设备编码 */
    deviceCode: string | undefined;
    /** 设备id */
    deviceId: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 设备类型id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 维修申请关联的文件 */
    fileAddDTOList: RepairApplyFileAddDTO[] | undefined;
    /** id */
    id: string | undefined;
    /** 影响生产：是 1   否   2 */
    isAffect: number | undefined;
    /** 影响生产：是 1   否   2 */
    isAffectStr: string | undefined;
    /** 故障类型编码 */
    malfunctionCode: string | undefined;
    /** 故障类型id */
    malfunctionId: string | undefined;
    /** 故障类型 */
    malfunctionName: string | undefined;
    /** 故障发生时间 */
    malfunctionTime: Date | undefined;
    /** 维修负责人id */
    repairUserId: string | undefined;
    /** 维修负责人名称 */
    repairUserName: string | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgency: number | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgencyStr: string | undefined;
}

export class RepairApplyExportDTO implements IRepairApplyExportDTO {
    /** 申请单状态： 待执行 1  执行中 2  待确认 3  已确认 4 */
    applyStatus!: number | undefined;
    /** 设备Id */
    deviceId!: string | undefined;
    /** 设备类型ID */
    deviceTypeId!: string | undefined;
    /** 是否选中导出 */
    exportSelected!: boolean | undefined;
    /** 关键词 */
    keyWord!: string | undefined;
    /** 选中申请id集合 */
    selectedRecords!: string[] | undefined;

    constructor(data?: IRepairApplyExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applyStatus = data["applyStatus"];
            this.deviceId = data["deviceId"];
            this.deviceTypeId = data["deviceTypeId"];
            this.exportSelected = data["exportSelected"];
            this.keyWord = data["keyWord"];
            if (data["selectedRecords"] && data["selectedRecords"].constructor === Array) {
                this.selectedRecords = [] as any;
                for (let item of data["selectedRecords"])
                    this.selectedRecords!.push(item);
            }
        }
    }

    static fromJS(data: any): RepairApplyExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RepairApplyExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applyStatus"] = this.applyStatus;
        data["deviceId"] = this.deviceId;
        data["deviceTypeId"] = this.deviceTypeId;
        data["exportSelected"] = this.exportSelected;
        data["keyWord"] = this.keyWord;
        if (this.selectedRecords && this.selectedRecords.constructor === Array) {
            data["selectedRecords"] = [];
            for (let item of this.selectedRecords)
                data["selectedRecords"].push(item);
        }
        return data; 
    }
}

export interface IRepairApplyExportDTO {
    /** 申请单状态： 待执行 1  执行中 2  待确认 3  已确认 4 */
    applyStatus: number | undefined;
    /** 设备Id */
    deviceId: string | undefined;
    /** 设备类型ID */
    deviceTypeId: string | undefined;
    /** 是否选中导出 */
    exportSelected: boolean | undefined;
    /** 关键词 */
    keyWord: string | undefined;
    /** 选中申请id集合 */
    selectedRecords: string[] | undefined;
}

export class RepairApplyFileAddDTO implements IRepairApplyFileAddDTO {
    /** 文件mini类型 */
    contentType!: string;
    /** 文件名称 */
    fileName!: string;
    /** 文件key */
    objectKey!: string;

    constructor(data?: IRepairApplyFileAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentType = data["contentType"];
            this.fileName = data["fileName"];
            this.objectKey = data["objectKey"];
        }
    }

    static fromJS(data: any): RepairApplyFileAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RepairApplyFileAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["fileName"] = this.fileName;
        data["objectKey"] = this.objectKey;
        return data; 
    }
}

export interface IRepairApplyFileAddDTO {
    /** 文件mini类型 */
    contentType: string;
    /** 文件名称 */
    fileName: string;
    /** 文件key */
    objectKey: string;
}

export class RepairApplyHMIAddDTO implements IRepairApplyHMIAddDTO {
    /** 维修申请单号 */
    applyCode!: string | undefined;
    /** 维修申请人id */
    applyUserId!: string | undefined;
    /** 维修申请人名称 */
    applyUserName!: string | undefined;
    /** 设备编码 */
    deviceCode!: string | undefined;
    /** 设备id */
    deviceId!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 设备类型id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 影响生产：是 1   否   2 */
    isAffect!: number | undefined;
    /** 故障类型编码 */
    malfunctionCode!: string | undefined;
    /** 故障类型id */
    malfunctionId!: string | undefined;
    /** 故障类型 */
    malfunctionName!: string | undefined;
    /** 故障发生时间 */
    malfunctionTime!: Date | undefined;
    /** 维修负责人id */
    repairUserId!: string | undefined;
    /** 维修负责人名称 */
    repairUserName!: string | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgency!: number | undefined;

    constructor(data?: IRepairApplyHMIAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applyCode = data["applyCode"];
            this.applyUserId = data["applyUserId"];
            this.applyUserName = data["applyUserName"];
            this.deviceCode = data["deviceCode"];
            this.deviceId = data["deviceId"];
            this.deviceName = data["deviceName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.isAffect = data["isAffect"];
            this.malfunctionCode = data["malfunctionCode"];
            this.malfunctionId = data["malfunctionId"];
            this.malfunctionName = data["malfunctionName"];
            this.malfunctionTime = data["malfunctionTime"] ? new Date(data["malfunctionTime"].toString()) : <any>undefined;
            this.repairUserId = data["repairUserId"];
            this.repairUserName = data["repairUserName"];
            this.urgency = data["urgency"];
        }
    }

    static fromJS(data: any): RepairApplyHMIAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RepairApplyHMIAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applyCode"] = this.applyCode;
        data["applyUserId"] = this.applyUserId;
        data["applyUserName"] = this.applyUserName;
        data["deviceCode"] = this.deviceCode;
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["isAffect"] = this.isAffect;
        data["malfunctionCode"] = this.malfunctionCode;
        data["malfunctionId"] = this.malfunctionId;
        data["malfunctionName"] = this.malfunctionName;
        data["malfunctionTime"] = this.malfunctionTime ? this.malfunctionTime.toISOString() : <any>undefined;
        data["repairUserId"] = this.repairUserId;
        data["repairUserName"] = this.repairUserName;
        data["urgency"] = this.urgency;
        return data; 
    }
}

export interface IRepairApplyHMIAddDTO {
    /** 维修申请单号 */
    applyCode: string | undefined;
    /** 维修申请人id */
    applyUserId: string | undefined;
    /** 维修申请人名称 */
    applyUserName: string | undefined;
    /** 设备编码 */
    deviceCode: string | undefined;
    /** 设备id */
    deviceId: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 设备类型id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 影响生产：是 1   否   2 */
    isAffect: number | undefined;
    /** 故障类型编码 */
    malfunctionCode: string | undefined;
    /** 故障类型id */
    malfunctionId: string | undefined;
    /** 故障类型 */
    malfunctionName: string | undefined;
    /** 故障发生时间 */
    malfunctionTime: Date | undefined;
    /** 维修负责人id */
    repairUserId: string | undefined;
    /** 维修负责人名称 */
    repairUserName: string | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgency: number | undefined;
}

export class RepairApplySearchDTO implements IRepairApplySearchDTO {
    /** 申请单状态： 待执行 1  执行中 2  待确认 3  已确认 4 */
    applyStatus!: number | undefined;
    /** 设备类型id */
    deviceTypeId!: string | undefined;
    /** 是否高级筛选 */
    filterPlus!: boolean | undefined;
    /** 关键词,申请单号，设备编码，设备名称模糊匹配 */
    keyWords!: string | undefined;
    /** 查询条件字典 */
    param!: any | undefined;

    constructor(data?: IRepairApplySearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applyStatus = data["applyStatus"];
            this.deviceTypeId = data["deviceTypeId"];
            this.filterPlus = data["filterPlus"];
            this.keyWords = data["keyWords"];
            this.param = data["param"];
        }
    }

    static fromJS(data: any): RepairApplySearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RepairApplySearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applyStatus"] = this.applyStatus;
        data["deviceTypeId"] = this.deviceTypeId;
        data["filterPlus"] = this.filterPlus;
        data["keyWords"] = this.keyWords;
        data["param"] = this.param;
        return data; 
    }
}

export interface IRepairApplySearchDTO {
    /** 申请单状态： 待执行 1  执行中 2  待确认 3  已确认 4 */
    applyStatus: number | undefined;
    /** 设备类型id */
    deviceTypeId: string | undefined;
    /** 是否高级筛选 */
    filterPlus: boolean | undefined;
    /** 关键词,申请单号，设备编码，设备名称模糊匹配 */
    keyWords: string | undefined;
    /** 查询条件字典 */
    param: any | undefined;
}

export class RepairApplyUpdateDTO implements IRepairApplyUpdateDTO {
    /** 维修申请人id */
    applyUserId!: string | undefined;
    /** 维修申请人名称 */
    applyUserName!: string | undefined;
    /** 故障描述 */
    description!: string | undefined;
    /** 设备编码 */
    deviceCode!: string | undefined;
    /** 设备id */
    deviceId!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 设备类型id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 维修申请关联的文件 */
    fileAddDTOList!: RepairApplyFileAddDTO[] | undefined;
    /** id */
    id!: string | undefined;
    /** 影响生产：是 1   否   2 */
    isAffect!: number | undefined;
    /** 故障类型编码 */
    malfunctionCode!: string | undefined;
    /** 故障类型id */
    malfunctionId!: string | undefined;
    /** 故障类型 */
    malfunctionName!: string | undefined;
    /** 故障发生时间 */
    malfunctionTime!: Date | undefined;
    /** 维修负责人id */
    repairUserId!: string | undefined;
    /** 维修负责人名称 */
    repairUserName!: string | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgency!: number | undefined;

    constructor(data?: IRepairApplyUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applyUserId = data["applyUserId"];
            this.applyUserName = data["applyUserName"];
            this.description = data["description"];
            this.deviceCode = data["deviceCode"];
            this.deviceId = data["deviceId"];
            this.deviceName = data["deviceName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            if (data["fileAddDTOList"] && data["fileAddDTOList"].constructor === Array) {
                this.fileAddDTOList = [] as any;
                for (let item of data["fileAddDTOList"])
                    this.fileAddDTOList!.push(RepairApplyFileAddDTO.fromJS(item));
            }
            this.id = data["id"];
            this.isAffect = data["isAffect"];
            this.malfunctionCode = data["malfunctionCode"];
            this.malfunctionId = data["malfunctionId"];
            this.malfunctionName = data["malfunctionName"];
            this.malfunctionTime = data["malfunctionTime"] ? new Date(data["malfunctionTime"].toString()) : <any>undefined;
            this.repairUserId = data["repairUserId"];
            this.repairUserName = data["repairUserName"];
            this.urgency = data["urgency"];
        }
    }

    static fromJS(data: any): RepairApplyUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RepairApplyUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applyUserId"] = this.applyUserId;
        data["applyUserName"] = this.applyUserName;
        data["description"] = this.description;
        data["deviceCode"] = this.deviceCode;
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        if (this.fileAddDTOList && this.fileAddDTOList.constructor === Array) {
            data["fileAddDTOList"] = [];
            for (let item of this.fileAddDTOList)
                data["fileAddDTOList"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["isAffect"] = this.isAffect;
        data["malfunctionCode"] = this.malfunctionCode;
        data["malfunctionId"] = this.malfunctionId;
        data["malfunctionName"] = this.malfunctionName;
        data["malfunctionTime"] = this.malfunctionTime ? this.malfunctionTime.toISOString() : <any>undefined;
        data["repairUserId"] = this.repairUserId;
        data["repairUserName"] = this.repairUserName;
        data["urgency"] = this.urgency;
        return data; 
    }
}

export interface IRepairApplyUpdateDTO {
    /** 维修申请人id */
    applyUserId: string | undefined;
    /** 维修申请人名称 */
    applyUserName: string | undefined;
    /** 故障描述 */
    description: string | undefined;
    /** 设备编码 */
    deviceCode: string | undefined;
    /** 设备id */
    deviceId: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 设备类型id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 维修申请关联的文件 */
    fileAddDTOList: RepairApplyFileAddDTO[] | undefined;
    /** id */
    id: string | undefined;
    /** 影响生产：是 1   否   2 */
    isAffect: number | undefined;
    /** 故障类型编码 */
    malfunctionCode: string | undefined;
    /** 故障类型id */
    malfunctionId: string | undefined;
    /** 故障类型 */
    malfunctionName: string | undefined;
    /** 故障发生时间 */
    malfunctionTime: Date | undefined;
    /** 维修负责人id */
    repairUserId: string | undefined;
    /** 维修负责人名称 */
    repairUserName: string | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgency: number | undefined;
}

export class RepairApplyVo implements IRepairApplyVo {
    /** 申请单号 */
    applyCode!: string | undefined;
    /** 申请单状态： 待执行 1  执行中 2  待确认 3  已确认 4 */
    applyStatus!: number | undefined;
    /** 申请单状态： 待执行 1  执行中 2  待确认 3  已确认 4 */
    applyStatusStr!: string | undefined;
    /** 申请时间 */
    applyTime!: Date | undefined;
    /** 维修申请人id */
    applyUserId!: string | undefined;
    /** 维修申请人名称 */
    applyUserName!: string | undefined;
    /** 故障详情 */
    description!: string | undefined;
    /** 设备编码 */
    deviceCode!: string | undefined;
    /** 设备id */
    deviceId!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 设备类型id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 影响生产：是 1   否   2 */
    isAffectStr!: string | undefined;
    /** 故障发生时间 */
    malfunctionTime!: Date | undefined;
    /** 维修负责人id */
    repairUserId!: string | undefined;
    /** 维修负责人名称 */
    repairUserName!: string | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgency!: number | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgencyStr!: string | undefined;

    constructor(data?: IRepairApplyVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applyCode = data["applyCode"];
            this.applyStatus = data["applyStatus"];
            this.applyStatusStr = data["applyStatusStr"];
            this.applyTime = data["applyTime"] ? new Date(data["applyTime"].toString()) : <any>undefined;
            this.applyUserId = data["applyUserId"];
            this.applyUserName = data["applyUserName"];
            this.description = data["description"];
            this.deviceCode = data["deviceCode"];
            this.deviceId = data["deviceId"];
            this.deviceName = data["deviceName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.id = data["id"];
            this.isAffectStr = data["isAffectStr"];
            this.malfunctionTime = data["malfunctionTime"] ? new Date(data["malfunctionTime"].toString()) : <any>undefined;
            this.repairUserId = data["repairUserId"];
            this.repairUserName = data["repairUserName"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.urgency = data["urgency"];
            this.urgencyStr = data["urgencyStr"];
        }
    }

    static fromJS(data: any): RepairApplyVo {
        data = typeof data === 'object' ? data : {};
        let result = new RepairApplyVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applyCode"] = this.applyCode;
        data["applyStatus"] = this.applyStatus;
        data["applyStatusStr"] = this.applyStatusStr;
        data["applyTime"] = this.applyTime ? this.applyTime.toISOString() : <any>undefined;
        data["applyUserId"] = this.applyUserId;
        data["applyUserName"] = this.applyUserName;
        data["description"] = this.description;
        data["deviceCode"] = this.deviceCode;
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["id"] = this.id;
        data["isAffectStr"] = this.isAffectStr;
        data["malfunctionTime"] = this.malfunctionTime ? this.malfunctionTime.toISOString() : <any>undefined;
        data["repairUserId"] = this.repairUserId;
        data["repairUserName"] = this.repairUserName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["urgency"] = this.urgency;
        data["urgencyStr"] = this.urgencyStr;
        return data; 
    }
}

export interface IRepairApplyVo {
    /** 申请单号 */
    applyCode: string | undefined;
    /** 申请单状态： 待执行 1  执行中 2  待确认 3  已确认 4 */
    applyStatus: number | undefined;
    /** 申请单状态： 待执行 1  执行中 2  待确认 3  已确认 4 */
    applyStatusStr: string | undefined;
    /** 申请时间 */
    applyTime: Date | undefined;
    /** 维修申请人id */
    applyUserId: string | undefined;
    /** 维修申请人名称 */
    applyUserName: string | undefined;
    /** 故障详情 */
    description: string | undefined;
    /** 设备编码 */
    deviceCode: string | undefined;
    /** 设备id */
    deviceId: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 设备类型id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** id */
    id: string | undefined;
    /** 影响生产：是 1   否   2 */
    isAffectStr: string | undefined;
    /** 故障发生时间 */
    malfunctionTime: Date | undefined;
    /** 维修负责人id */
    repairUserId: string | undefined;
    /** 维修负责人名称 */
    repairUserName: string | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgency: number | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgencyStr: string | undefined;
}

export class RepairFileVo implements IRepairFileVo {
    /** 故障描述 */
    description!: string | undefined;
    /** 维修申请关联的文件 */
    fileAddDTOList!: RepairApplyFileAddDTO[] | undefined;

    constructor(data?: IRepairFileVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            if (data["fileAddDTOList"] && data["fileAddDTOList"].constructor === Array) {
                this.fileAddDTOList = [] as any;
                for (let item of data["fileAddDTOList"])
                    this.fileAddDTOList!.push(RepairApplyFileAddDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RepairFileVo {
        data = typeof data === 'object' ? data : {};
        let result = new RepairFileVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        if (this.fileAddDTOList && this.fileAddDTOList.constructor === Array) {
            data["fileAddDTOList"] = [];
            for (let item of this.fileAddDTOList)
                data["fileAddDTOList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRepairFileVo {
    /** 故障描述 */
    description: string | undefined;
    /** 维修申请关联的文件 */
    fileAddDTOList: RepairApplyFileAddDTO[] | undefined;
}

export class RepairRecordAddDTO implements IRepairRecordAddDTO {
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 设备编码 */
    deviceCode!: string | undefined;
    /** 设备id */
    deviceId!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 设备类型id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 故障码 */
    errorCode!: string | undefined;
    /** 影响生产：是 1 , 否 2 */
    isAffect!: number | undefined;
    /** 故障类型编码 */
    malfunctionCode!: string | undefined;
    /** 故障分析 */
    malfunctionDetails!: string | undefined;
    /** 故障类型id */
    malfunctionId!: string | undefined;
    /** 故障类型 */
    malfunctionName!: string | undefined;
    /** 发生时间 （例行维修） */
    malfunctionTime!: Date | undefined;
    /** 维修记录关联的备品备件 */
    materialAddDTOList!: RepairRecordMaterialAddDTO[] | undefined;
    /** 维修单号 */
    recordCode!: string | undefined;
    /** 维修记录关联附件 */
    recordFileList!: RepairRecordFileAddDTO[] | undefined;
    /** 维修记录状态：待确认 1  已确认 2 */
    recordStatus!: number | undefined;
    /** 维修记录类型： 临时维修  1   例行维修 2 */
    recordType!: number | undefined;
    /** 维修记录类型名称 */
    recordTypeName!: string | undefined;
    /** 维修申请id */
    repairApplyId!: string | undefined;
    /** 维修完成时间 */
    repairEndTime!: Date | undefined;
    /** 维修开始时间 */
    repairStartTime!: Date | undefined;
    /** 维修用时  单位：分钟 */
    repairTime!: number | undefined;
    /** 维修负责人id */
    repairUserId!: string | undefined;
    /** 维修负责人名称 */
    repairUserName!: string | undefined;

    constructor(data?: IRepairRecordAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.codeRuleId = data["codeRuleId"];
            this.deviceCode = data["deviceCode"];
            this.deviceId = data["deviceId"];
            this.deviceName = data["deviceName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.errorCode = data["errorCode"];
            this.isAffect = data["isAffect"];
            this.malfunctionCode = data["malfunctionCode"];
            this.malfunctionDetails = data["malfunctionDetails"];
            this.malfunctionId = data["malfunctionId"];
            this.malfunctionName = data["malfunctionName"];
            this.malfunctionTime = data["malfunctionTime"] ? new Date(data["malfunctionTime"].toString()) : <any>undefined;
            if (data["materialAddDTOList"] && data["materialAddDTOList"].constructor === Array) {
                this.materialAddDTOList = [] as any;
                for (let item of data["materialAddDTOList"])
                    this.materialAddDTOList!.push(RepairRecordMaterialAddDTO.fromJS(item));
            }
            this.recordCode = data["recordCode"];
            if (data["recordFileList"] && data["recordFileList"].constructor === Array) {
                this.recordFileList = [] as any;
                for (let item of data["recordFileList"])
                    this.recordFileList!.push(RepairRecordFileAddDTO.fromJS(item));
            }
            this.recordStatus = data["recordStatus"];
            this.recordType = data["recordType"];
            this.recordTypeName = data["recordTypeName"];
            this.repairApplyId = data["repairApplyId"];
            this.repairEndTime = data["repairEndTime"] ? new Date(data["repairEndTime"].toString()) : <any>undefined;
            this.repairStartTime = data["repairStartTime"] ? new Date(data["repairStartTime"].toString()) : <any>undefined;
            this.repairTime = data["repairTime"];
            this.repairUserId = data["repairUserId"];
            this.repairUserName = data["repairUserName"];
        }
    }

    static fromJS(data: any): RepairRecordAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RepairRecordAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeRuleId"] = this.codeRuleId;
        data["deviceCode"] = this.deviceCode;
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["errorCode"] = this.errorCode;
        data["isAffect"] = this.isAffect;
        data["malfunctionCode"] = this.malfunctionCode;
        data["malfunctionDetails"] = this.malfunctionDetails;
        data["malfunctionId"] = this.malfunctionId;
        data["malfunctionName"] = this.malfunctionName;
        data["malfunctionTime"] = this.malfunctionTime ? this.malfunctionTime.toISOString() : <any>undefined;
        if (this.materialAddDTOList && this.materialAddDTOList.constructor === Array) {
            data["materialAddDTOList"] = [];
            for (let item of this.materialAddDTOList)
                data["materialAddDTOList"].push(item.toJSON());
        }
        data["recordCode"] = this.recordCode;
        if (this.recordFileList && this.recordFileList.constructor === Array) {
            data["recordFileList"] = [];
            for (let item of this.recordFileList)
                data["recordFileList"].push(item.toJSON());
        }
        data["recordStatus"] = this.recordStatus;
        data["recordType"] = this.recordType;
        data["recordTypeName"] = this.recordTypeName;
        data["repairApplyId"] = this.repairApplyId;
        data["repairEndTime"] = this.repairEndTime ? this.repairEndTime.toISOString() : <any>undefined;
        data["repairStartTime"] = this.repairStartTime ? this.repairStartTime.toISOString() : <any>undefined;
        data["repairTime"] = this.repairTime;
        data["repairUserId"] = this.repairUserId;
        data["repairUserName"] = this.repairUserName;
        return data; 
    }
}

export interface IRepairRecordAddDTO {
    /** 规则id */
    codeRuleId: string | undefined;
    /** 设备编码 */
    deviceCode: string | undefined;
    /** 设备id */
    deviceId: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 设备类型id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 故障码 */
    errorCode: string | undefined;
    /** 影响生产：是 1 , 否 2 */
    isAffect: number | undefined;
    /** 故障类型编码 */
    malfunctionCode: string | undefined;
    /** 故障分析 */
    malfunctionDetails: string | undefined;
    /** 故障类型id */
    malfunctionId: string | undefined;
    /** 故障类型 */
    malfunctionName: string | undefined;
    /** 发生时间 （例行维修） */
    malfunctionTime: Date | undefined;
    /** 维修记录关联的备品备件 */
    materialAddDTOList: RepairRecordMaterialAddDTO[] | undefined;
    /** 维修单号 */
    recordCode: string | undefined;
    /** 维修记录关联附件 */
    recordFileList: RepairRecordFileAddDTO[] | undefined;
    /** 维修记录状态：待确认 1  已确认 2 */
    recordStatus: number | undefined;
    /** 维修记录类型： 临时维修  1   例行维修 2 */
    recordType: number | undefined;
    /** 维修记录类型名称 */
    recordTypeName: string | undefined;
    /** 维修申请id */
    repairApplyId: string | undefined;
    /** 维修完成时间 */
    repairEndTime: Date | undefined;
    /** 维修开始时间 */
    repairStartTime: Date | undefined;
    /** 维修用时  单位：分钟 */
    repairTime: number | undefined;
    /** 维修负责人id */
    repairUserId: string | undefined;
    /** 维修负责人名称 */
    repairUserName: string | undefined;
}

export class RepairRecordDetailVo implements IRepairRecordDetailVo {
    /** 设备编码 */
    deviceCode!: string | undefined;
    /** 设备id */
    deviceId!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 设备类型id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 故障码 */
    errorCode!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 影响生产：是 1 , 否 2 */
    isAffect!: number | undefined;
    /** 影响生产：是 1 , 否 2 */
    isAffectStr!: string | undefined;
    /** 故障类型编码 */
    malfunctionCode!: string | undefined;
    /** 故障详情 */
    malfunctionDetails!: string | undefined;
    /** 故障类型id */
    malfunctionId!: string | undefined;
    /** 故障类型 */
    malfunctionName!: string | undefined;
    /** 发生时间 （例行维修） */
    malfunctionTime!: Date | undefined;
    /** 关联的备品备件 */
    materialVOList!: RepairRecordMaterialVO[] | undefined;
    /** 维修单号 */
    recordCode!: string | undefined;
    /** 维修记录关联附件 */
    recordFileAddDTOList!: RepairRecordFileAddDTO[] | undefined;
    /** 维修记录状态：待确认 1  已确认 2 */
    recordStatus!: number | undefined;
    /** 维修记录状态：待确认 1  已确认 2 */
    recordStatusStr!: string | undefined;
    /** 维修记录类型： 临时维修  1   例行维修 2 */
    recordType!: number | undefined;
    /** 维修记录类型： 临时维修  1   例行维修 2 */
    recordTypeStr!: string | undefined;
    /** 关联的维修申请 */
    repairApplyDetailVo!: RepairApplyDetailVo | undefined;
    /** 维修申请id */
    repairApplyId!: string | undefined;
    /** 维修完成时间 */
    repairEndTime!: Date | undefined;
    /** 维修开始时间 */
    repairStartTime!: Date | undefined;
    /** 维修用时  单位：分钟 */
    repairTime!: number | undefined;
    /** 维修负责人id */
    repairUserId!: string | undefined;
    /** 维修负责人名称 */
    repairUserName!: string | undefined;

    constructor(data?: IRepairRecordDetailVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceCode = data["deviceCode"];
            this.deviceId = data["deviceId"];
            this.deviceName = data["deviceName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.errorCode = data["errorCode"];
            this.id = data["id"];
            this.isAffect = data["isAffect"];
            this.isAffectStr = data["isAffectStr"];
            this.malfunctionCode = data["malfunctionCode"];
            this.malfunctionDetails = data["malfunctionDetails"];
            this.malfunctionId = data["malfunctionId"];
            this.malfunctionName = data["malfunctionName"];
            this.malfunctionTime = data["malfunctionTime"] ? new Date(data["malfunctionTime"].toString()) : <any>undefined;
            if (data["materialVOList"] && data["materialVOList"].constructor === Array) {
                this.materialVOList = [] as any;
                for (let item of data["materialVOList"])
                    this.materialVOList!.push(RepairRecordMaterialVO.fromJS(item));
            }
            this.recordCode = data["recordCode"];
            if (data["recordFileAddDTOList"] && data["recordFileAddDTOList"].constructor === Array) {
                this.recordFileAddDTOList = [] as any;
                for (let item of data["recordFileAddDTOList"])
                    this.recordFileAddDTOList!.push(RepairRecordFileAddDTO.fromJS(item));
            }
            this.recordStatus = data["recordStatus"];
            this.recordStatusStr = data["recordStatusStr"];
            this.recordType = data["recordType"];
            this.recordTypeStr = data["recordTypeStr"];
            this.repairApplyDetailVo = data["repairApplyDetailVo"] ? RepairApplyDetailVo.fromJS(data["repairApplyDetailVo"]) : <any>undefined;
            this.repairApplyId = data["repairApplyId"];
            this.repairEndTime = data["repairEndTime"] ? new Date(data["repairEndTime"].toString()) : <any>undefined;
            this.repairStartTime = data["repairStartTime"] ? new Date(data["repairStartTime"].toString()) : <any>undefined;
            this.repairTime = data["repairTime"];
            this.repairUserId = data["repairUserId"];
            this.repairUserName = data["repairUserName"];
        }
    }

    static fromJS(data: any): RepairRecordDetailVo {
        data = typeof data === 'object' ? data : {};
        let result = new RepairRecordDetailVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceCode"] = this.deviceCode;
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["errorCode"] = this.errorCode;
        data["id"] = this.id;
        data["isAffect"] = this.isAffect;
        data["isAffectStr"] = this.isAffectStr;
        data["malfunctionCode"] = this.malfunctionCode;
        data["malfunctionDetails"] = this.malfunctionDetails;
        data["malfunctionId"] = this.malfunctionId;
        data["malfunctionName"] = this.malfunctionName;
        data["malfunctionTime"] = this.malfunctionTime ? this.malfunctionTime.toISOString() : <any>undefined;
        if (this.materialVOList && this.materialVOList.constructor === Array) {
            data["materialVOList"] = [];
            for (let item of this.materialVOList)
                data["materialVOList"].push(item.toJSON());
        }
        data["recordCode"] = this.recordCode;
        if (this.recordFileAddDTOList && this.recordFileAddDTOList.constructor === Array) {
            data["recordFileAddDTOList"] = [];
            for (let item of this.recordFileAddDTOList)
                data["recordFileAddDTOList"].push(item.toJSON());
        }
        data["recordStatus"] = this.recordStatus;
        data["recordStatusStr"] = this.recordStatusStr;
        data["recordType"] = this.recordType;
        data["recordTypeStr"] = this.recordTypeStr;
        data["repairApplyDetailVo"] = this.repairApplyDetailVo ? this.repairApplyDetailVo.toJSON() : <any>undefined;
        data["repairApplyId"] = this.repairApplyId;
        data["repairEndTime"] = this.repairEndTime ? this.repairEndTime.toISOString() : <any>undefined;
        data["repairStartTime"] = this.repairStartTime ? this.repairStartTime.toISOString() : <any>undefined;
        data["repairTime"] = this.repairTime;
        data["repairUserId"] = this.repairUserId;
        data["repairUserName"] = this.repairUserName;
        return data; 
    }
}

export interface IRepairRecordDetailVo {
    /** 设备编码 */
    deviceCode: string | undefined;
    /** 设备id */
    deviceId: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 设备类型id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 故障码 */
    errorCode: string | undefined;
    /** id */
    id: string | undefined;
    /** 影响生产：是 1 , 否 2 */
    isAffect: number | undefined;
    /** 影响生产：是 1 , 否 2 */
    isAffectStr: string | undefined;
    /** 故障类型编码 */
    malfunctionCode: string | undefined;
    /** 故障详情 */
    malfunctionDetails: string | undefined;
    /** 故障类型id */
    malfunctionId: string | undefined;
    /** 故障类型 */
    malfunctionName: string | undefined;
    /** 发生时间 （例行维修） */
    malfunctionTime: Date | undefined;
    /** 关联的备品备件 */
    materialVOList: RepairRecordMaterialVO[] | undefined;
    /** 维修单号 */
    recordCode: string | undefined;
    /** 维修记录关联附件 */
    recordFileAddDTOList: RepairRecordFileAddDTO[] | undefined;
    /** 维修记录状态：待确认 1  已确认 2 */
    recordStatus: number | undefined;
    /** 维修记录状态：待确认 1  已确认 2 */
    recordStatusStr: string | undefined;
    /** 维修记录类型： 临时维修  1   例行维修 2 */
    recordType: number | undefined;
    /** 维修记录类型： 临时维修  1   例行维修 2 */
    recordTypeStr: string | undefined;
    /** 关联的维修申请 */
    repairApplyDetailVo: RepairApplyDetailVo | undefined;
    /** 维修申请id */
    repairApplyId: string | undefined;
    /** 维修完成时间 */
    repairEndTime: Date | undefined;
    /** 维修开始时间 */
    repairStartTime: Date | undefined;
    /** 维修用时  单位：分钟 */
    repairTime: number | undefined;
    /** 维修负责人id */
    repairUserId: string | undefined;
    /** 维修负责人名称 */
    repairUserName: string | undefined;
}

export class RepairRecordExportDTO implements IRepairRecordExportDTO {
    /** 设备Id */
    deviceId!: string | undefined;
    /** 设备类型ID */
    deviceTypeId!: string | undefined;
    /** 是否选中导出 */
    exportSelected!: boolean | undefined;
    /** 关键词 */
    keyWord!: string | undefined;
    /** 维修记录状态：待确认 1  已确认 2 */
    recordStatus!: number | undefined;
    /** 选中记录id集合 */
    selectedRecords!: string[] | undefined;

    constructor(data?: IRepairRecordExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.deviceTypeId = data["deviceTypeId"];
            this.exportSelected = data["exportSelected"];
            this.keyWord = data["keyWord"];
            this.recordStatus = data["recordStatus"];
            if (data["selectedRecords"] && data["selectedRecords"].constructor === Array) {
                this.selectedRecords = [] as any;
                for (let item of data["selectedRecords"])
                    this.selectedRecords!.push(item);
            }
        }
    }

    static fromJS(data: any): RepairRecordExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RepairRecordExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["deviceTypeId"] = this.deviceTypeId;
        data["exportSelected"] = this.exportSelected;
        data["keyWord"] = this.keyWord;
        data["recordStatus"] = this.recordStatus;
        if (this.selectedRecords && this.selectedRecords.constructor === Array) {
            data["selectedRecords"] = [];
            for (let item of this.selectedRecords)
                data["selectedRecords"].push(item);
        }
        return data; 
    }
}

export interface IRepairRecordExportDTO {
    /** 设备Id */
    deviceId: string | undefined;
    /** 设备类型ID */
    deviceTypeId: string | undefined;
    /** 是否选中导出 */
    exportSelected: boolean | undefined;
    /** 关键词 */
    keyWord: string | undefined;
    /** 维修记录状态：待确认 1  已确认 2 */
    recordStatus: number | undefined;
    /** 选中记录id集合 */
    selectedRecords: string[] | undefined;
}

export class RepairRecordFileAddDTO implements IRepairRecordFileAddDTO {
    /** 文件mini类型 */
    contentType!: string;
    /** 文件名称 */
    fileName!: string;
    /** 文件key */
    objectKey!: string;

    constructor(data?: IRepairRecordFileAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentType = data["contentType"];
            this.fileName = data["fileName"];
            this.objectKey = data["objectKey"];
        }
    }

    static fromJS(data: any): RepairRecordFileAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RepairRecordFileAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["fileName"] = this.fileName;
        data["objectKey"] = this.objectKey;
        return data; 
    }
}

export interface IRepairRecordFileAddDTO {
    /** 文件mini类型 */
    contentType: string;
    /** 文件名称 */
    fileName: string;
    /** 文件key */
    objectKey: string;
}

export class RepairRecordMaterialAddDTO implements IRepairRecordMaterialAddDTO {
    /** 库区Id */
    areaId!: string | undefined;
    /** 库区名称 */
    areaName!: string | undefined;
    /** 是否出库 : 0 是  1 否  2 空 */
    issue!: number | undefined;
    /** 库位Id */
    locationId!: string | undefined;
    /** 库位名称 */
    locationName!: string | undefined;
    /** 库位数量 */
    locationNum!: number | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料id */
    materialId!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 数量 */
    number!: number | undefined;
    /** 出库数量 */
    stockOutNum!: number | undefined;
    /** 出库单号 */
    stockOutOrderCode!: string | undefined;
    /** 总库存数量 */
    stockSumNum!: number | undefined;

    constructor(data?: IRepairRecordMaterialAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.areaName = data["areaName"];
            this.issue = data["issue"];
            this.locationId = data["locationId"];
            this.locationName = data["locationName"];
            this.locationNum = data["locationNum"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.number = data["number"];
            this.stockOutNum = data["stockOutNum"];
            this.stockOutOrderCode = data["stockOutOrderCode"];
            this.stockSumNum = data["stockSumNum"];
        }
    }

    static fromJS(data: any): RepairRecordMaterialAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RepairRecordMaterialAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["issue"] = this.issue;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["locationNum"] = this.locationNum;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["number"] = this.number;
        data["stockOutNum"] = this.stockOutNum;
        data["stockOutOrderCode"] = this.stockOutOrderCode;
        data["stockSumNum"] = this.stockSumNum;
        return data; 
    }
}

export interface IRepairRecordMaterialAddDTO {
    /** 库区Id */
    areaId: string | undefined;
    /** 库区名称 */
    areaName: string | undefined;
    /** 是否出库 : 0 是  1 否  2 空 */
    issue: number | undefined;
    /** 库位Id */
    locationId: string | undefined;
    /** 库位名称 */
    locationName: string | undefined;
    /** 库位数量 */
    locationNum: number | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料id */
    materialId: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 数量 */
    number: number | undefined;
    /** 出库数量 */
    stockOutNum: number | undefined;
    /** 出库单号 */
    stockOutOrderCode: string | undefined;
    /** 总库存数量 */
    stockSumNum: number | undefined;
}

export class RepairRecordMaterialVO implements IRepairRecordMaterialVO {
    /** 库区Id */
    areaId!: string | undefined;
    /** 库区名称 */
    areaName!: string | undefined;
    deviceId!: string | undefined;
    id!: string | undefined;
    /** 是否出库 : 0 是  1 否  2 空 */
    issue!: number | undefined;
    /** 库位Id */
    locationId!: string | undefined;
    /** 库位名称 */
    locationName!: string | undefined;
    /** 库位数量 */
    locationNum!: number | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料id */
    materialId!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 数量 */
    number!: number | undefined;
    recordId!: string | undefined;
    /** 出库数量 */
    stockOutNum!: number | undefined;
    /** 出库单号 */
    stockOutOrderCode!: string | undefined;
    /** 总库存数量 */
    stockSumNum!: number | undefined;
    userId!: string | undefined;

    constructor(data?: IRepairRecordMaterialVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.areaName = data["areaName"];
            this.deviceId = data["deviceId"];
            this.id = data["id"];
            this.issue = data["issue"];
            this.locationId = data["locationId"];
            this.locationName = data["locationName"];
            this.locationNum = data["locationNum"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.number = data["number"];
            this.recordId = data["recordId"];
            this.stockOutNum = data["stockOutNum"];
            this.stockOutOrderCode = data["stockOutOrderCode"];
            this.stockSumNum = data["stockSumNum"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): RepairRecordMaterialVO {
        data = typeof data === 'object' ? data : {};
        let result = new RepairRecordMaterialVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["deviceId"] = this.deviceId;
        data["id"] = this.id;
        data["issue"] = this.issue;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["locationNum"] = this.locationNum;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["number"] = this.number;
        data["recordId"] = this.recordId;
        data["stockOutNum"] = this.stockOutNum;
        data["stockOutOrderCode"] = this.stockOutOrderCode;
        data["stockSumNum"] = this.stockSumNum;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IRepairRecordMaterialVO {
    /** 库区Id */
    areaId: string | undefined;
    /** 库区名称 */
    areaName: string | undefined;
    deviceId: string | undefined;
    id: string | undefined;
    /** 是否出库 : 0 是  1 否  2 空 */
    issue: number | undefined;
    /** 库位Id */
    locationId: string | undefined;
    /** 库位名称 */
    locationName: string | undefined;
    /** 库位数量 */
    locationNum: number | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料id */
    materialId: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 数量 */
    number: number | undefined;
    recordId: string | undefined;
    /** 出库数量 */
    stockOutNum: number | undefined;
    /** 出库单号 */
    stockOutOrderCode: string | undefined;
    /** 总库存数量 */
    stockSumNum: number | undefined;
    userId: string | undefined;
}

export class RepairRecordSearchDTO implements IRepairRecordSearchDTO {
    /** 设备类型id */
    deviceTypeId!: string | undefined;
    /** 是否高级筛选 */
    filterPlus!: boolean | undefined;
    /** 关键词,维修单号，申请单号，设备编码，设备名称模糊匹配 */
    keyWords!: string | undefined;
    /** 查询条件字典 */
    param!: any | undefined;
    /** 维修状态 */
    recordStatus!: number | undefined;

    constructor(data?: IRepairRecordSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceTypeId = data["deviceTypeId"];
            this.filterPlus = data["filterPlus"];
            this.keyWords = data["keyWords"];
            this.param = data["param"];
            this.recordStatus = data["recordStatus"];
        }
    }

    static fromJS(data: any): RepairRecordSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RepairRecordSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceTypeId"] = this.deviceTypeId;
        data["filterPlus"] = this.filterPlus;
        data["keyWords"] = this.keyWords;
        data["param"] = this.param;
        data["recordStatus"] = this.recordStatus;
        return data; 
    }
}

export interface IRepairRecordSearchDTO {
    /** 设备类型id */
    deviceTypeId: string | undefined;
    /** 是否高级筛选 */
    filterPlus: boolean | undefined;
    /** 关键词,维修单号，申请单号，设备编码，设备名称模糊匹配 */
    keyWords: string | undefined;
    /** 查询条件字典 */
    param: any | undefined;
    /** 维修状态 */
    recordStatus: number | undefined;
}

export class RepairRecordUpdateDTO implements IRepairRecordUpdateDTO {
    /** 故障码 */
    errorCode!: string | undefined;
    /** 维修记录Id */
    id!: string | undefined;
    /** 影响生产：是 1 , 否 2（临时维修） */
    isAffect!: number | undefined;
    /** 故障类型编码 */
    malfunctionCode!: string | undefined;
    /** 故障分析 */
    malfunctionDetails!: string | undefined;
    /** 故障类型id */
    malfunctionId!: string | undefined;
    /** 故障类型 */
    malfunctionName!: string | undefined;
    /** 发生时间 （临时维修） */
    malfunctionTime!: Date | undefined;
    /** 维修记录关联的备品备件 */
    materialAddDTOList!: RepairRecordMaterialAddDTO[] | undefined;
    /** 维修记录关联附件 */
    recordFileList!: RepairRecordFileAddDTO[] | undefined;
    /** 维修记录类型： 临时维修  1   例行维修 2 */
    recordType!: number | undefined;
    /** 维修申请id */
    repairApplyId!: string | undefined;
    /** 维修结束时间 */
    repairEndTime!: Date | undefined;
    /** 维修开始时间 */
    repairStartTime!: Date | undefined;
    /** 维修用时  单位：分钟 */
    repairTime!: number | undefined;
    /** 维修负责人id */
    repairUserId!: string | undefined;
    /** 维修负责人名称 */
    repairUserName!: string | undefined;

    constructor(data?: IRepairRecordUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.errorCode = data["errorCode"];
            this.id = data["id"];
            this.isAffect = data["isAffect"];
            this.malfunctionCode = data["malfunctionCode"];
            this.malfunctionDetails = data["malfunctionDetails"];
            this.malfunctionId = data["malfunctionId"];
            this.malfunctionName = data["malfunctionName"];
            this.malfunctionTime = data["malfunctionTime"] ? new Date(data["malfunctionTime"].toString()) : <any>undefined;
            if (data["materialAddDTOList"] && data["materialAddDTOList"].constructor === Array) {
                this.materialAddDTOList = [] as any;
                for (let item of data["materialAddDTOList"])
                    this.materialAddDTOList!.push(RepairRecordMaterialAddDTO.fromJS(item));
            }
            if (data["recordFileList"] && data["recordFileList"].constructor === Array) {
                this.recordFileList = [] as any;
                for (let item of data["recordFileList"])
                    this.recordFileList!.push(RepairRecordFileAddDTO.fromJS(item));
            }
            this.recordType = data["recordType"];
            this.repairApplyId = data["repairApplyId"];
            this.repairEndTime = data["repairEndTime"] ? new Date(data["repairEndTime"].toString()) : <any>undefined;
            this.repairStartTime = data["repairStartTime"] ? new Date(data["repairStartTime"].toString()) : <any>undefined;
            this.repairTime = data["repairTime"];
            this.repairUserId = data["repairUserId"];
            this.repairUserName = data["repairUserName"];
        }
    }

    static fromJS(data: any): RepairRecordUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RepairRecordUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        data["id"] = this.id;
        data["isAffect"] = this.isAffect;
        data["malfunctionCode"] = this.malfunctionCode;
        data["malfunctionDetails"] = this.malfunctionDetails;
        data["malfunctionId"] = this.malfunctionId;
        data["malfunctionName"] = this.malfunctionName;
        data["malfunctionTime"] = this.malfunctionTime ? this.malfunctionTime.toISOString() : <any>undefined;
        if (this.materialAddDTOList && this.materialAddDTOList.constructor === Array) {
            data["materialAddDTOList"] = [];
            for (let item of this.materialAddDTOList)
                data["materialAddDTOList"].push(item.toJSON());
        }
        if (this.recordFileList && this.recordFileList.constructor === Array) {
            data["recordFileList"] = [];
            for (let item of this.recordFileList)
                data["recordFileList"].push(item.toJSON());
        }
        data["recordType"] = this.recordType;
        data["repairApplyId"] = this.repairApplyId;
        data["repairEndTime"] = this.repairEndTime ? this.repairEndTime.toISOString() : <any>undefined;
        data["repairStartTime"] = this.repairStartTime ? this.repairStartTime.toISOString() : <any>undefined;
        data["repairTime"] = this.repairTime;
        data["repairUserId"] = this.repairUserId;
        data["repairUserName"] = this.repairUserName;
        return data; 
    }
}

export interface IRepairRecordUpdateDTO {
    /** 故障码 */
    errorCode: string | undefined;
    /** 维修记录Id */
    id: string | undefined;
    /** 影响生产：是 1 , 否 2（临时维修） */
    isAffect: number | undefined;
    /** 故障类型编码 */
    malfunctionCode: string | undefined;
    /** 故障分析 */
    malfunctionDetails: string | undefined;
    /** 故障类型id */
    malfunctionId: string | undefined;
    /** 故障类型 */
    malfunctionName: string | undefined;
    /** 发生时间 （临时维修） */
    malfunctionTime: Date | undefined;
    /** 维修记录关联的备品备件 */
    materialAddDTOList: RepairRecordMaterialAddDTO[] | undefined;
    /** 维修记录关联附件 */
    recordFileList: RepairRecordFileAddDTO[] | undefined;
    /** 维修记录类型： 临时维修  1   例行维修 2 */
    recordType: number | undefined;
    /** 维修申请id */
    repairApplyId: string | undefined;
    /** 维修结束时间 */
    repairEndTime: Date | undefined;
    /** 维修开始时间 */
    repairStartTime: Date | undefined;
    /** 维修用时  单位：分钟 */
    repairTime: number | undefined;
    /** 维修负责人id */
    repairUserId: string | undefined;
    /** 维修负责人名称 */
    repairUserName: string | undefined;
}

export class RepairRecordVo implements IRepairRecordVo {
    /** 申请单号 */
    applyCode!: string | undefined;
    /** 申请时间 */
    applyTime!: Date | undefined;
    /** 维修申请人id */
    applyUserId!: string | undefined;
    /** 维修申请人名称 */
    applyUserName!: string | undefined;
    /** 故障描述 */
    description!: string | undefined;
    /** 设备编码 */
    deviceCode!: string | undefined;
    /** 设备id */
    deviceId!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 设备类型id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 故障码 */
    errorCode!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 影响生产：是 1 , 否 2 */
    isAffectStr!: string | undefined;
    /** 故障分析 */
    malfunctionDetails!: string | undefined;
    /** 发生时间 （例行维修） */
    malfunctionTime!: Date | undefined;
    /** 维修单号 */
    recordCode!: string | undefined;
    /** 维修记录状态：待确认 1  已确认 2 */
    recordStatus!: number | undefined;
    /** 维修记录状态：待确认 1  已确认 2 */
    recordStatusStr!: string | undefined;
    /** 维修记录类型： 临时维修  1   例行维修 2 */
    recordType!: number | undefined;
    /** 维修记录类型： 临时维修  1   例行维修 2 */
    recordTypeStr!: string | undefined;
    /** 维修申请id */
    repairApplyId!: string | undefined;
    /** 维修完成时间 */
    repairEndTime!: Date | undefined;
    /** 维修开始时间 */
    repairStartTime!: Date | undefined;
    /** 维修用时  单位：分钟 */
    repairTime!: number | undefined;
    /** 维修负责人id */
    repairUserId!: string | undefined;
    /** 维修负责人名称 */
    repairUserName!: string | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgency!: number | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgencyStr!: string | undefined;

    constructor(data?: IRepairRecordVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applyCode = data["applyCode"];
            this.applyTime = data["applyTime"] ? new Date(data["applyTime"].toString()) : <any>undefined;
            this.applyUserId = data["applyUserId"];
            this.applyUserName = data["applyUserName"];
            this.description = data["description"];
            this.deviceCode = data["deviceCode"];
            this.deviceId = data["deviceId"];
            this.deviceName = data["deviceName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.errorCode = data["errorCode"];
            this.id = data["id"];
            this.isAffectStr = data["isAffectStr"];
            this.malfunctionDetails = data["malfunctionDetails"];
            this.malfunctionTime = data["malfunctionTime"] ? new Date(data["malfunctionTime"].toString()) : <any>undefined;
            this.recordCode = data["recordCode"];
            this.recordStatus = data["recordStatus"];
            this.recordStatusStr = data["recordStatusStr"];
            this.recordType = data["recordType"];
            this.recordTypeStr = data["recordTypeStr"];
            this.repairApplyId = data["repairApplyId"];
            this.repairEndTime = data["repairEndTime"] ? new Date(data["repairEndTime"].toString()) : <any>undefined;
            this.repairStartTime = data["repairStartTime"] ? new Date(data["repairStartTime"].toString()) : <any>undefined;
            this.repairTime = data["repairTime"];
            this.repairUserId = data["repairUserId"];
            this.repairUserName = data["repairUserName"];
            this.urgency = data["urgency"];
            this.urgencyStr = data["urgencyStr"];
        }
    }

    static fromJS(data: any): RepairRecordVo {
        data = typeof data === 'object' ? data : {};
        let result = new RepairRecordVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applyCode"] = this.applyCode;
        data["applyTime"] = this.applyTime ? this.applyTime.toISOString() : <any>undefined;
        data["applyUserId"] = this.applyUserId;
        data["applyUserName"] = this.applyUserName;
        data["description"] = this.description;
        data["deviceCode"] = this.deviceCode;
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["errorCode"] = this.errorCode;
        data["id"] = this.id;
        data["isAffectStr"] = this.isAffectStr;
        data["malfunctionDetails"] = this.malfunctionDetails;
        data["malfunctionTime"] = this.malfunctionTime ? this.malfunctionTime.toISOString() : <any>undefined;
        data["recordCode"] = this.recordCode;
        data["recordStatus"] = this.recordStatus;
        data["recordStatusStr"] = this.recordStatusStr;
        data["recordType"] = this.recordType;
        data["recordTypeStr"] = this.recordTypeStr;
        data["repairApplyId"] = this.repairApplyId;
        data["repairEndTime"] = this.repairEndTime ? this.repairEndTime.toISOString() : <any>undefined;
        data["repairStartTime"] = this.repairStartTime ? this.repairStartTime.toISOString() : <any>undefined;
        data["repairTime"] = this.repairTime;
        data["repairUserId"] = this.repairUserId;
        data["repairUserName"] = this.repairUserName;
        data["urgency"] = this.urgency;
        data["urgencyStr"] = this.urgencyStr;
        return data; 
    }
}

export interface IRepairRecordVo {
    /** 申请单号 */
    applyCode: string | undefined;
    /** 申请时间 */
    applyTime: Date | undefined;
    /** 维修申请人id */
    applyUserId: string | undefined;
    /** 维修申请人名称 */
    applyUserName: string | undefined;
    /** 故障描述 */
    description: string | undefined;
    /** 设备编码 */
    deviceCode: string | undefined;
    /** 设备id */
    deviceId: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 设备类型id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 故障码 */
    errorCode: string | undefined;
    /** id */
    id: string | undefined;
    /** 影响生产：是 1 , 否 2 */
    isAffectStr: string | undefined;
    /** 故障分析 */
    malfunctionDetails: string | undefined;
    /** 发生时间 （例行维修） */
    malfunctionTime: Date | undefined;
    /** 维修单号 */
    recordCode: string | undefined;
    /** 维修记录状态：待确认 1  已确认 2 */
    recordStatus: number | undefined;
    /** 维修记录状态：待确认 1  已确认 2 */
    recordStatusStr: string | undefined;
    /** 维修记录类型： 临时维修  1   例行维修 2 */
    recordType: number | undefined;
    /** 维修记录类型： 临时维修  1   例行维修 2 */
    recordTypeStr: string | undefined;
    /** 维修申请id */
    repairApplyId: string | undefined;
    /** 维修完成时间 */
    repairEndTime: Date | undefined;
    /** 维修开始时间 */
    repairStartTime: Date | undefined;
    /** 维修用时  单位：分钟 */
    repairTime: number | undefined;
    /** 维修负责人id */
    repairUserId: string | undefined;
    /** 维修负责人名称 */
    repairUserName: string | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgency: number | undefined;
    /** 紧急度：  高 3 中 2  低 1 */
    urgencyStr: string | undefined;
}

export class RouteDefinition implements IRouteDefinition {
    compatibleMode!: number | undefined;
    filters!: GatewayFilterDefinition[] | undefined;
    id!: string | undefined;
    ignoreValidate!: number | undefined;
    mergeResult!: number | undefined;
    name!: string | undefined;
    needToken!: number | undefined;
    order!: number | undefined;
    path!: string | undefined;
    permission!: number | undefined;
    predicates!: GatewayPredicateDefinition[] | undefined;
    status!: number | undefined;
    uri!: string | undefined;
    version!: string | undefined;

    constructor(data?: IRouteDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.compatibleMode = data["compatibleMode"];
            if (data["filters"] && data["filters"].constructor === Array) {
                this.filters = [] as any;
                for (let item of data["filters"])
                    this.filters!.push(GatewayFilterDefinition.fromJS(item));
            }
            this.id = data["id"];
            this.ignoreValidate = data["ignoreValidate"];
            this.mergeResult = data["mergeResult"];
            this.name = data["name"];
            this.needToken = data["needToken"];
            this.order = data["order"];
            this.path = data["path"];
            this.permission = data["permission"];
            if (data["predicates"] && data["predicates"].constructor === Array) {
                this.predicates = [] as any;
                for (let item of data["predicates"])
                    this.predicates!.push(GatewayPredicateDefinition.fromJS(item));
            }
            this.status = data["status"];
            this.uri = data["uri"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): RouteDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new RouteDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compatibleMode"] = this.compatibleMode;
        if (this.filters && this.filters.constructor === Array) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["ignoreValidate"] = this.ignoreValidate;
        data["mergeResult"] = this.mergeResult;
        data["name"] = this.name;
        data["needToken"] = this.needToken;
        data["order"] = this.order;
        data["path"] = this.path;
        data["permission"] = this.permission;
        if (this.predicates && this.predicates.constructor === Array) {
            data["predicates"] = [];
            for (let item of this.predicates)
                data["predicates"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["uri"] = this.uri;
        data["version"] = this.version;
        return data; 
    }
}

export interface IRouteDefinition {
    compatibleMode: number | undefined;
    filters: GatewayFilterDefinition[] | undefined;
    id: string | undefined;
    ignoreValidate: number | undefined;
    mergeResult: number | undefined;
    name: string | undefined;
    needToken: number | undefined;
    order: number | undefined;
    path: string | undefined;
    permission: number | undefined;
    predicates: GatewayPredicateDefinition[] | undefined;
    status: number | undefined;
    uri: string | undefined;
    version: string | undefined;
}

export class ServiceRouteInfo implements IServiceRouteInfo {
    createTime!: Date | undefined;
    description!: string | undefined;
    routeDefinitionList!: RouteDefinition[] | undefined;
    serviceId!: string | undefined;
    updateTime!: Date | undefined;

    constructor(data?: IServiceRouteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.description = data["description"];
            if (data["routeDefinitionList"] && data["routeDefinitionList"].constructor === Array) {
                this.routeDefinitionList = [] as any;
                for (let item of data["routeDefinitionList"])
                    this.routeDefinitionList!.push(RouteDefinition.fromJS(item));
            }
            this.serviceId = data["serviceId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceRouteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRouteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        if (this.routeDefinitionList && this.routeDefinitionList.constructor === Array) {
            data["routeDefinitionList"] = [];
            for (let item of this.routeDefinitionList)
                data["routeDefinitionList"].push(item.toJSON());
        }
        data["serviceId"] = this.serviceId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IServiceRouteInfo {
    createTime: Date | undefined;
    description: string | undefined;
    routeDefinitionList: RouteDefinition[] | undefined;
    serviceId: string | undefined;
    updateTime: Date | undefined;
}

/** 出库单物料信息 */
export class StockOutOrderMaterialTpmVO implements IStockOutOrderMaterialTpmVO {
    /** 库区名称 */
    areaName!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 是否出库 : 0 是  1 否  2 空 */
    issue!: number | undefined;
    /** 库位名称 */
    locationName!: string | undefined;
    /** 库位数量 */
    locationNum!: number | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 所属物料id */
    materialId!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 物料类型 */
    materialType!: string | undefined;
    /** 出库单号 */
    orderCode!: string | undefined;
    /** 所属出库单id */
    orderId!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 退库数量 */
    returnNum!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 出库数量 */
    stockOutNum!: number | undefined;
    /** 总库存数量 */
    stockSumNum!: number | undefined;
    /** 计量单位 */
    unit!: string | undefined;

    constructor(data?: IStockOutOrderMaterialTpmVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaName = data["areaName"];
            this.id = data["id"];
            this.issue = data["issue"];
            this.locationName = data["locationName"];
            this.locationNum = data["locationNum"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.materialType = data["materialType"];
            this.orderCode = data["orderCode"];
            this.orderId = data["orderId"];
            this.remark = data["remark"];
            this.returnNum = data["returnNum"];
            this.standardModel = data["standardModel"];
            this.stockOutNum = data["stockOutNum"];
            this.stockSumNum = data["stockSumNum"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): StockOutOrderMaterialTpmVO {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutOrderMaterialTpmVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaName"] = this.areaName;
        data["id"] = this.id;
        data["issue"] = this.issue;
        data["locationName"] = this.locationName;
        data["locationNum"] = this.locationNum;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["materialType"] = this.materialType;
        data["orderCode"] = this.orderCode;
        data["orderId"] = this.orderId;
        data["remark"] = this.remark;
        data["returnNum"] = this.returnNum;
        data["standardModel"] = this.standardModel;
        data["stockOutNum"] = this.stockOutNum;
        data["stockSumNum"] = this.stockSumNum;
        data["unit"] = this.unit;
        return data; 
    }
}

/** 出库单物料信息 */
export interface IStockOutOrderMaterialTpmVO {
    /** 库区名称 */
    areaName: string | undefined;
    /** id */
    id: string | undefined;
    /** 是否出库 : 0 是  1 否  2 空 */
    issue: number | undefined;
    /** 库位名称 */
    locationName: string | undefined;
    /** 库位数量 */
    locationNum: number | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 所属物料id */
    materialId: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 物料类型 */
    materialType: string | undefined;
    /** 出库单号 */
    orderCode: string | undefined;
    /** 所属出库单id */
    orderId: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 退库数量 */
    returnNum: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 出库数量 */
    stockOutNum: number | undefined;
    /** 总库存数量 */
    stockSumNum: number | undefined;
    /** 计量单位 */
    unit: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}